var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanBodyDigitalTwin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 668.019,
    height: 680.867,
    viewBox: "0 0 668.019 680.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Line_2250",
    x: 0,
    y: 1,
    width: 72.019,
    height: 20.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_2251",
    x: 52.445,
    y: 0.675,
    width: 291.129,
    height: 205.651,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_52",
    x: 313.509,
    y: 176,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_2252",
    x: 595.999,
    y: 0,
    width: 72.02,
    height: 20.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_2253",
    x: 425.652,
    y: 0.566,
    width: 188.714,
    height: 84.868,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_53",
    x: 414.509,
    y: 55,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_25_1",
    "data-name": "Component 25 \\u2013 1",
    transform: "translate(9.009 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(-573.5 -363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1280,341.088V298.349l38.739,37.368Z",
    transform: "translate(-382.979 191.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1280,297.834l41.761-.374-3.021,37.742Z",
    transform: "translate(-382.979 191.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1280,249.737l41.761,20.054-41.761.374Z",
    transform: "translate(-382.979 219.205)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M1280,742.317v-48.6l32.44-.307Z",
    transform: "translate(-382.979 -38.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1312.44,693.405l.5,46.891L1280,742.317Z",
    transform: "translate(-382.979 -38.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1280,392.647l38.739-5.371-5.921,36.981Z",
    transform: "translate(-382.979 139.462)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1280,434.1V400.058l32.818,31.61Z",
    transform: "translate(-382.979 132.051)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1280,36.03l18.641,13.732L1280,50.634Z",
    transform: "translate(-382.979 343.11)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1280,807.015l32.936-2.021.273.08Z",
    transform: "translate(-382.979 -102.727)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1372.19,335.2l3.021-37.742,30.1,12.443Z",
    transform: "translate(-436.43 191.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M1296.153,90.918,1280,69.581l18.641-.872Z",
    transform: "translate(-382.979 324.163)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1280,91.75V70.783l16.153,21.337Z",
    transform: "translate(-382.979 322.961)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1410.732,287.18l-1.252,16.763-30.1-12.443Z",
    transform: "translate(-440.599 197.496)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1280,629.372V582.435l32.44,46.631Z",
    transform: "translate(-382.979 26.311)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1280,120.68l16.153.37L1280,131.01Z",
    transform: "translate(-382.979 294.031)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1280,481.08l26.767,42.084L1280,523.67Z",
    transform: "translate(-382.979 85.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1312.818,475.282l-6.051,44.52L1280,477.718Z",
    transform: "translate(-382.979 88.437)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1280,581.736l26.767-.507,5.673,47.138Z",
    transform: "translate(-382.979 27.01)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1314.789,240.4l6.971,23.976L1280,244.325Z",
    transform: "translate(-382.979 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M1280,236.249v-9.776l34.789,5.854Z",
    transform: "translate(-382.979 232.693)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1401.113,260.059l-31.352,4.32L1362.79,240.4Z",
    transform: "translate(-430.98 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M1297.426,24.63l1.214,18.522L1280,29.42Z",
    transform: "translate(-382.979 349.72)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1297.426,17.475,1280,22.266V12.29Z",
    transform: "translate(-382.979 356.875)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1331.584,42.92l-8.9.233L1321.47,24.63Z",
    transform: "translate(-407.023 349.72)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1296.153,121.56l-1.072,13L1280,131.52Z",
    transform: "translate(-382.979 293.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1372.19,352.37l33.121-25.3-9.845,11.189Z",
    transform: "translate(-436.43 174.368)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1358.1,404.789l5.921-36.981L1387.3,353.7Z",
    transform: "translate(-428.261 158.929)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1286.24,816.719l-6.24-9.594,33.209-1.941Z",
    transform: "translate(-382.979 -102.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1316.961,121.56l8.6.717-9.669,12.283Z",
    transform: "translate(-403.788 293.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M1324.36,68.388l8.9-.233-2.79,23.158Z",
    transform: "translate(-408.699 324.484)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1327.037,91.634l-8.6-.717,2.488-22.209Z",
    transform: "translate(-405.266 324.163)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M1688.9,268.162l-2.647,14.208-10.539,1.467Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 905.496, -1126.153)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1295.081,148.3,1280,164.157v-18.9Z",
    transform: "translate(-382.979 279.779)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1587.634,283.786l-63.834-4.46,2.727-11.253Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 923.756, -1039.991)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1357.7,739.317l-.5-46.891,18.51-.71Z",
    transform: "translate(-427.739 -37.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1530.29,268.073l55.72,3.959,5.387,11.754Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 922.974, -1043.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1662.89,272.084l18.573-3.922-13.186,15.676Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 907.041, -1118.883)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1675.71,303.441l10.539-1.467,1.315,13.745Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 924.67, -1130.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1358.653,801.758l-.273-.08,23.406-2.4Z",
    transform: "translate(-428.423 -99.411)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1376.394,691.716l5.391,45.2-23.406,2.4Z",
    transform: "translate(-428.423 -37.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1321.819,805.184l2.29,74.66-29.259-63.125Z",
    transform: "translate(-391.589 -102.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1298.334,224.177,1314.789,231,1280,225.142Z",
    transform: "translate(-382.979 234.025)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1362.79,240.4l20.9,4.235,17.422,15.421Z",
    transform: "translate(-430.98 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1945.72,302.953l-22.09,4.62,4.643-5.1Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 895.069, -1270.89)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1971.637,303.613l13.2,2.76-16.51,2.751Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.327, -1296.377)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1945.72,303.613l-3.307,5.511-18.783-.891Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 895.714, -1271.027)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1358.1,404.789l29.2-51.09-11.762,48.311Z",
    transform: "translate(-428.261 158.929)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1968.33,312.931l16.51-2.751-3.059,4.133Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 894.05, -1297.169)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M2014.921,314.863l-14.581-.55,3.059-4.133Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.192, -1315.322)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1523.8,294.852l63.834,4.46-58.539,9.18Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 938.944, -1043.219)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1349.373,626.955l-5.673-47.138,16.052-1.023Z",
    transform: "translate(-419.912 28.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1375.534,468.667l-7.433,46.277-10-43.5Z",
    transform: "translate(-428.261 92.272)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1375.71,626.245l-18.51.71,10.379-48.161Z",
    transform: "translate(-427.739 28.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1349.751,475.282l10,43.5L1343.7,519.8Z",
    transform: "translate(-419.912 88.437)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M2000.34,320.016l14.581.55-4.177,2.6Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 895.77, -1316.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M1953.2,297.218l-1.072,2.687-17.447-.479Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.756, -1276.523)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M1942.413,305.416l4.379-8.2-23.162,7.307Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 892.087, -1270.256)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1976.2,299.905l1.072-2.687,13.081,3.551Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.75, -1300.069)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M1968.33,305.416l17.459-4.647-13.081-3.551Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 886.7, -1295.606)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1985.79,305.669l-17.459,4.647,13.451,1.382Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.493, -1296.625)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1990.353,304.477l-.95,1.9-13.2-2.76Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.377, -1300.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1934.68,296.437l3.5-4.376,15.018,2.167Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 887.832, -1275.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M1946.792,294.228l-15.018-2.167-8.144,9.474Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.164, -1269.635)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M1412.53,248.3l9.888-1.579,7.534,17Z",
    transform: "translate(-459.819 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M1329.769,24.182l1.815,18.478L1321.47,24.37Z",
    transform: "translate(-407.023 349.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M1700.79,301.974l68.688.354-67.372,13.39Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 921.647, -1144.453)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M2000.34,311.7l15.9-1.122-11.892-4.907Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 887.633, -1314.779)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M2000.34,318.469l10.4,3.151,5.5-4.272Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 894.256, -1316.186)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M2025.1,321.619l4.177-2.6,1.32-1.672Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.272, -1330.228)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M2008.57,305.669l11.892,4.907-12.842-3.012Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 886.756, -1318.907)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M2007.62,310.18l12.842,3.012-1.319,1.672Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.314, -1319.451)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1280,189.367l14.867-.624L1280,204.6Z",
    transform: "translate(-382.979 254.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1294.867,188.743l3.467,14.89L1280,204.6Z",
    transform: "translate(-382.979 254.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1294.867,167.727l-14.867.624,15.081-15.855Z",
    transform: "translate(-382.979 275.584)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M1335.19,1281.63l20.107,1.223-4.711,87.185Z",
    transform: "translate(-414.978 -379.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1371.83,1371.273l4.71-87.185,16.775-.328Z",
    transform: "translate(-436.221 -380.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1586.01,266.236l-55.72-3.959,5.9-4.2Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 917.305, -1042.467)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1680.8,317.743l-16.754-4.079,4.9-8.2Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 928.057, -1124.037)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1594.94,305.466l-4.9,8.2-53.64.982Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 943.444, -1051.645)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1370.178,1538.52l10.282,25.805-10.451.029Z",
    transform: "translate(-435.166 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1341.24,1599.93l12.089.029,10.451-.029Z",
    transform: "translate(-418.485 -563.622)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1353.329,1564.355l-12.089-.029,12.258-25.805Z",
    transform: "translate(-418.485 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1436.06,246.724l9.93.086-2.4,16.914Z",
    transform: "translate(-469.219 228.74)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1893.271,302.474l-4.643,5.1L1863.26,309.7Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 902.346, -1236.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1893.271,302.474,1863.26,309.7l.416-7.081Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 902.346, -1236.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M1771.292,302.817l-.416,7.081-66.956,6.309Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 921.749, -1146.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M1315.89,135.549l9.669-12.283-3.189,15.76Z",
    transform: "translate(-403.788 292.532)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M1322.074,155.973l-6.694,11.755.214-15.231Z",
    transform: "translate(-403.492 275.584)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M1334.5,123.266l3.589,1.177-6.778,14.583Z",
    transform: "translate(-412.728 292.532)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M1341.69,68.155l.8,24.335-3.589-1.177Z",
    transform: "translate(-417.129 324.484)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1294.85,832.634l29.259,63.125-16.472-6.325Z",
    transform: "translate(-391.589 -118.752)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M1544.32,258.076l42.656,3.523,7.169,4.637Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 915.614, -1050.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M1361.32,879.844l-2.29-74.66,21.153,81.433Z",
    transform: "translate(-428.8 -102.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M1359.03,801.758l23.133-2.483-1.979,83.917Z",
    transform: "translate(-428.8 -99.411)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1347.548,42.968l-4.513-.308-1.815-18.478Z",
    transform: "translate(-418.474 349.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M1350.053,68.463l-3.715,24.027-.8-24.335Z",
    transform: "translate(-420.979 324.484)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M1316.78,7.053l10.27,7.2-8.3.188Z",
    transform: "translate(-404.304 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1297.426,14.439,1280,9.254l15.455-2.2Z",
    transform: "translate(-382.979 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1893.845,294.742l-29.6.144.068-5.748Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 894.664, -1235.606)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M1703.437,268.162l66.107,8.814-68.755,5.394Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 902.472, -1140.377)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1864.41,289.138l33.029,1.228-3.5,4.376Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 894.644, -1235.698)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M1769.545,289.138l-.067,5.748-68.687-.354Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 914.368, -1142.905)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1295.455,2.964,1280,5.164V0Z",
    transform: "translate(-382.979 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M1341.24,1564.325l.282-25.469,11.976-.336Z",
    transform: "translate(-418.485 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M1982.855,297.453l13.539,3.915-16.935,2.161Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.491, -1301.947)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M2027.683,311.823l-15.7-.748,3.269-4.305Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 886.855, -1321.513)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M1979.46,308.931l16.935-2.161-3.269,4.305Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.775, -1303.07)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M1926.966,298.58l-3.336,2.955,8.144-9.474Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.164, -1269.635)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M1955.089,297.453l-3.4,6.076-20.124-1.823Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.264, -1274.787)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M1888.628,310.53l3.337-2.955-28.7,5.082Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 905.239, -1237.267)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1955.089,294.327l-23.519,4.253,4.807-6.519Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 888.207, -1274.137)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M1351.154,68.888l2.635,3.268-6.35,20.759Z",
    transform: "translate(-422.08 324.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M2011.98,317.015l15.7.748-5.084,2.811Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 892.665, -1322.747)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1353.789,76.665l-2.328,14.445-4.021,6.314Z",
    transform: "translate(-422.08 319.551)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1341.91,1512.221l2.244-19.641,9.732,19.3Z",
    transform: "translate(-418.874 -501.382)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1357.579,1492.02l-.6,19.54-9.732-19.3Z",
    transform: "translate(-421.97 -501.057)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1350.586,1370.038l-10.329.235-5.068-88.643Z",
    transform: "translate(-414.978 -379.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M1370.67,1018.639l-6.19-35.783,18.863,6.774Z",
    transform: "translate(-431.96 -205.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M1962.714,292.372l-.992,1.955-18.712-2.266Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 886.827, -1280.625)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M1951.694,300.832l4.387-8.031-24.511,6.208Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 888.625, -1274.227)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M1645.83,260.879l30.545-4.046L1653,265.515Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 902.672, -1107.842)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M1686.266,256.833l-4.8,4.761-18.573,3.922Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 900.616, -1117.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M1943.01,288.864l2.206-2.317,17.5,2.628Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 883.7, -1279.961)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M1956.081,289.175l-17.5-2.628-7.013,8.836Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.079, -1273.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M1979.46,300.832l17.662-3.6-13.275-4.434Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.853, -1301.386)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M1979.46,306.951l13.665,2.144,4-5.741Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 888.837, -1302.658)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M1987.54,294.756l.992-1.955,13.274,4.434Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 881.879, -1305.968)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M2001.806,299.933l-.727,1.435-13.54-3.915Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 884.517, -1306.529)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M2020.487,303.354,2032.576,309l-12.816-4.207Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 883.98, -1325.513)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M2042.334,317.628l.383-.847-5.467,3.658Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.486, -1337.05)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M2028.066,309l-12.089-5.642-4,5.741Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 884.917, -1321.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M2019.76,306.77l12.816,4.207-.382.847Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.917, -1325.925)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M2011.98,316.879l10.619,3.559,5.467-3.658Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 892.533, -1322.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M1370.41,1538.52l14.308,1.013-4.026,24.792Z",
    transform: "translate(-435.398 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M1370.41,1511.56l.6-19.54,13.711,20.552Z",
    transform: "translate(-435.398 -501.057)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M1664.05,324.975l16.754,4.079,6.639,4.074Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 939.121, -1126.389)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M1703.92,325.978l66.956-6.309-60.317,10.383Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 931.305, -1148.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M1353.418,982.856l6.19,35.783-14.207,3.253Z",
    transform: "translate(-420.898 -205.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M1359.607,1068.01l1.61,90.988-15.817-87.736Z",
    transform: "translate(-420.898 -255.221)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M1333.735,1013.165l-8.455-45.36,16.472,6.325Z",
    transform: "translate(-409.232 -197.123)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M1355.3,1163.486l-20.107-1.223,4.29-86.513Z",
    transform: "translate(-414.978 -259.708)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M1891.425,307.575l-29.1,5.546.391-.464Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 905.351, -1236.74)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M1780.037,319.669l-.391.464-59.926,9.919Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 929.401, -1157.321)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M1772.832,274.571l.366,2.406-66.107-8.814Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 901.712, -1143.949)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M1863.54,283.413l35.6,1.317-2.206,2.317Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.502, -1234.514)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M1711.893,256.833,1772.832,268l-65.742-6.409Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 895.288, -1142.584)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M1896.934,287.047l-33.029-1.228-.366-2.406Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.502, -1234.514)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M1327.05,14.251l-10.27-7.2L1328.4,15.66Z",
    transform: "translate(-404.304 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M1341.22,24.182l1.349,1.409,4.979,17.377Z",
    transform: "translate(-418.474 349.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M1393.315,1283.76l-12.77,87.454-8.715.059Z",
    transform: "translate(-436.221 -380.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M1371.83,1491.939l8.715-.059,5,20.611Z",
    transform: "translate(-436.221 -500.976)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M1590.04,324.975l-8.211,3.192-45.429-2.21Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 954.508, -1053.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1676.114,333.128l-31.6-4.962,8.211-3.192Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 941.476, -1115.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M2033.661,307.5l-16.241-1.188,3.248-4.234Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 883.54, -1324.032)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M1983.28,303.741l17.594-1.661-3.248,4.234Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 887.655, -1304.671)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M1986.667,291.9l14.207,4.279-17.594,1.662Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 881.879, -1303.443)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M2017.42,312.156l16.241,1.188-5.072,2.8Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.253, -1325.247)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M1959.1,291.9l-3.387,5.941-19.977-1.718Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 887.61, -1276.482)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M1959.1,288.795l-23.364,4.223,5.261-6.47Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 884.577, -1275.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M1891.425,304.311l1.752-2.366-30.848,7.912Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 902.159, -1236.061)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M1933.322,293.017l-1.752,2.366,7.013-8.836Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.079, -1273.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M1581.829,329.521l-38.571.6-6.858-2.805Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 955.833, -1054.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M1427.58,338.4l45.727-11.088,6.858,2.805Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 968.951, -992.564)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M1391.883,998.976l-.71,31.66-11.964-2.651Z",
    transform: "translate(-440.5 -215.196)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M1379.21,1068.01l11.964,2.652L1380.819,1159Z",
    transform: "translate(-440.5 -255.221)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M1393.394,1074.32l6.421,88.009-16.775.328Z",
    transform: "translate(-442.721 -258.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M1325.69,1279.53l3.992.882,5.068,88.643Z",
    transform: "translate(-409.47 -377.858)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M1406.641,736.913l-5.391-45.2,13.2,44.175Z",
    transform: "translate(-453.279 -37.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M1318.847,203.633l-3.467-14.89,3.189,1.225Z",
    transform: "translate(-403.492 254.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M1318.569,173.749l-3.189-1.225,6.694-11.755Z",
    transform: "translate(-403.492 270.787)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M1323.277,206.468l-.029-1.146-.277-13.665Z",
    transform: "translate(-407.893 252.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M1544.32,258.076l9.442,1.167,33.213,2.357Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 915.614, -1050.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M1459.69,246.928l45,5.851-9.442-1.167Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 919.494, -1001.084)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M1983.28,302.165l14.346,2.573,3.925-5.377Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 886.113, -1304.343)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M2006.224,295.033l-.677,1.143L1991.34,291.9Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 880.908, -1308.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M1991.34,290.036l.975-1.348,13.909,4.485Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 879.088, -1307.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1983.28,295.977l18.271-2.8-13.909-4.485Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 880.06, -1303.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M1967.338,287.447l-.975,1.348-18.1-2.248Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 883.067, -1282.938)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M1955.717,295.977l4.362-7.289-24.339,5.571Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.791, -1276.095)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M1344.154,1491.994l-2.244,19.641,1.454-20.065Z",
    transform: "translate(-418.874 -500.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M1334.75,1369.056l-.79-.424-8.27-89.1Z",
    transform: "translate(-409.47 -377.858)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M2034.048,305.069l-12.7-5.708-3.925,5.377Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 881.998, -1323.704)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M2049.072,313.8l.386-.857L2044,316.6Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 886.497, -1340.416)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M2025.15,302.08l13.38,4.565-.387.857Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.608, -1328.416)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M2025.827,299.361l12.7,5.708-13.38-4.565Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 881.066, -1328.088)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M2017.42,312.156l11.169,3.991,5.459-3.66Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.253, -1325.247)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M1960.079,285.273l-17.725-2.475-6.614,8.046Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.451, -1275.386)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M1967.338,285.273l-19.078-.9,1.353-1.575Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 880.941, -1282.486)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M1900.493,282.8l-1.353,1.575-35.6-1.317Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.154, -1234.44)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M1405.34,1283.238l2.42-.378-15.19,87.832Z",
    transform: "translate(-448.246 -379.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1718.52,256.833l2.521,4.756L1779.459,268Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 893.91, -1149.066)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1782.938,274.565l-58.417-6.413,58.951,9.817Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 899.606, -1153.833)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1590.637,266.112l9.366-2.9-33.213-2.357Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 914.48, -1063.501)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1623.54,263.781l42.433-2.192-2.521-4.756Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 905.359, -1095.201)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M1632.906,260.879l-9.366,2.9,39.912-6.948Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 905.359, -1095.201)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M1893.178,301.945l-30.39,6.66-.458,1.253Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 902.159, -1236.061)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M1779.646,319.046l.458-1.253-60.384,11.171Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 928.336, -1157.095)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M1328.744,164.955l-5.774,8.794,3.5-12.979Z",
    transform: "translate(-407.893 270.787)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M1333.579,144.834l-2.269-4.185,6.778-14.583Z",
    transform: "translate(-412.728 290.908)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M1389.333,468.667l-1.588,46.125-5.845.151Z",
    transform: "translate(-442.06 92.272)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M1390.031,626.245l-8.131-47.451,14.3,47.3Z",
    transform: "translate(-442.06 28.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M1381.9,578.585l5.845-.151,8.459,47.453Z",
    transform: "translate(-442.06 28.63)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M1401.25,691.51l6.173-.15,7.03,44.324Z",
    transform: "translate(-453.279 -36.843)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M1342.29,126.777l-5.581,18.057,4.509-18.768Z",
    transform: "translate(-415.859 290.908)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M1347.44,117.355l4.021-6.314-2.95,7.024Z",
    transform: "translate(-422.08 299.62)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M1357.772,72.156l-2.635-3.268-.828.483Z",
    transform: "translate(-426.063 324.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M1357.772,72.823l-3.462-2.785,1.135,17.23Z",
    transform: "translate(-426.063 323.393)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M1348.582,45.4l.828-.483-4.979-17.377Z",
    transform: "translate(-420.335 348.035)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M1352.94,87.268l-1.134-17.23-1.815,24.254Z",
    transform: "translate(-423.559 323.393)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M1591.291,323.1l-9.413-6.862L1552.72,323.7Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 947.587, -1062.199)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M1445.99,246.81l-9.93-.086,8.522,1.255Z",
    transform: "translate(-473.461 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M1456.34,248.1l46.412,4.682-45-5.851Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 919.897, -999.184)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M1400.012,466.6l-4.2,46.992,1.589-46.125Z",
    transform: "translate(-450.125 93.468)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M1411.352,353.7l-9.148,47.444-2.614.867Z",
    transform: "translate(-452.316 158.929)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M1676.114,331.7l3.009-9.189-34.613,4.227Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 940.079, -1115.011)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M1666.135,318.876l-44.025-2.635,9.413,6.862Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 939.223, -1101.551)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M1784.256,310.3l.08-5.431-57.456,7.414Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 920.143, -1159.597)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M1780.1,317.793l-57.376,1.983-3.009,9.189Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 928.336, -1157.095)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M1619.858,270.344,1617.19,279l45.1-10.845Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 912.544, -1092.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M1407.68,1074.32l5.66,16.657.76,71.352Z",
    transform: "translate(-457.007 -258.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M1421.15,1113.96l3.181,70.974-2.42.378Z",
    transform: "translate(-464.817 -281.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1328.352,15.66l-11.619-8.607-.034.092Z",
    transform: "translate(-404.257 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M1295.455,2.964,1280,0l15.422,3.056Z",
    transform: "translate(-382.979 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M1294.85,832.634l12.787,56.8-7.354-1.54Z",
    transform: "translate(-391.589 -118.752)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M1297.976,887.894l-7.106-55.037,1.673-.223Z",
    transform: "translate(-389.281 -118.752)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M1407.76,1282.86l-14.316,87.605-.874.227Z",
    transform: "translate(-448.246 -379.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M1337.092,1075.75l-4.29,86.513-1.731-72.079Z",
    transform: "translate(-412.589 -259.708)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M1329.682,1182.179l-3.992-.882,2.261-71.2Z",
    transform: "translate(-409.47 -279.624)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M2028.357,303.085l-15.527-.92,3.387-4.45Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 881.617, -1320.903)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M1727.94,291.494l57.01,5.62.5-5.611Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 912.431, -1158.586)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M1724.52,268.152l1.437,9.809,57.514.009Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 899.606, -1153.833)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M1666.135,304.528l.445-13.034-44.471,10.4Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 925.188, -1098.568)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M1663.728,291.494l-46.538,1.037,2.068,9.362Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 925.782, -1095.778)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M1617.19,279l46.538-1.037-1.437-9.809Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 912.544, -1092.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M1784.335,297.114l-57.01-5.62-.445,13.034Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 912.559, -1157.985)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M2012.83,308.3l15.527.92-5.2,2.988Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 887.623, -1322.179)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M1328.256,16.811l.1-1.024L1316.7,7.272Z",
    transform: "translate(-404.257 359.784)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M1344.3,27.536l-.1,1.024,4.248,16.836Z",
    transform: "translate(-420.202 348.035)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M1422.418,246.724l-9.888,1.579,7.993-.39Z",
    transform: "translate(-459.819 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M1431.55,247.912l10.417.066-8.522-1.255Z",
    transform: "translate(-470.846 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M1980.79,300.059l16.851-2.344-3.387,4.45Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.479, -1302.732)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1984.278,288.513l13.363,3.867-16.851,2.344Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 880.26, -1301.623)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M1295.422,3.056,1280,0V.526Z",
    transform: "translate(-382.979 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1581.878,316.241l-21.46,1.056-7.7,6.4Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 947.587, -1062.199)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1592.5,303.323l-2.068-9.362L1571.04,304.38Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 932.744, -1069.903)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1958.263,288.513l-3.488,6.211-18.855-1.963Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.669, -1276.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1893.81,300.018l.075-1.4-30.465,8.056Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 900.142, -1236.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1958.263,285.2l-22.343,4.248,6.539-6.649Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.429, -1275.488)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1935.74,290.844l6.614-8.046-6.538,6.649Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.451, -1275.386)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M1566.79,260.853l5.53,12.176,18.317-6.917Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 914.48, -1063.501)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1579.95,280.285l15.649,1.737,2.668-8.653Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 919.991, -1072.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M1590.432,291.565l-15.648-1.737-3.744,12.155Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 930.4, -1069.405)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M2020.89,297.715l12.568,4.42-.428.949Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 880.645, -1325.474)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M2042.608,309.183l.428-.949-5.627,3.937Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 884.62, -1336.111)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M2012.83,308.263l10.329,3.908,5.627-3.937Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 887.583, -1322.171)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1414.08,797.864l7.812-1.023.819,88.383Z",
    transform: "translate(-460.717 -98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M1409.37,883.192l1.979-83.917,8.631,87.36Z",
    transform: "translate(-457.987 -99.411)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M1980.79,298.262l13.464,2.106,4.08-5.752Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 883.721, -1302.359)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M2021.583,294.615l11.875,5.723-12.568-4.42Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 878.887, -1325.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M2003.146,291.077l-.693,1.3-13.363-3.867Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 879.26, -1306.331)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M2028.786,300.338l-11.875-5.723-4.08,5.752Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 879.859, -1320.529)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M1968.242,283.641l-.958,1.558-15.8-2.4Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 880.553, -1284.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M1989.09,286.363l.958-1.558,13.1,4.122Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 877.158, -1305.884)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M1980.79,292.574l17.544-3.647-13.1-4.122Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 878.158, -1301.176)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M1954.775,292.574l4.446-7.769-23.3,5.806Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 883.567, -1275.73)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M1964,283.219l-16.762-.843-3.072-.306Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 881.021, -1280.079)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M1897.422,282.069l3.072.306-36.953.258Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.741, -1234.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M1959.221,283.219l-19.834-1.15-3.467,6.956Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.015, -1275.4)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M1406.63,251.148l10.472-1.6-7.993.39Z",
    transform: "translate(-456.398 219.313)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M1381.212,245.844l2.479-1.206-20.9-4.235Z",
    transform: "translate(-430.98 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M1392.57,1491.567l.874-.227,4.013,18.842Z",
    transform: "translate(-448.246 -500.663)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M1397.566,1512.491l-5-20.611,4.887,18.615Z",
    transform: "translate(-448.246 -500.976)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M1325.28,967.8l8.455,45.36-7.3,4.152Z",
    transform: "translate(-409.232 -197.123)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M1335.323,1075.75l-6.022,14.434-1.281-10.282Z",
    transform: "translate(-410.821 -259.708)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M1316.285,1015.191l-8.5-51.051,7.354,1.54Z",
    transform: "translate(-399.086 -194.998)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M1412.987,1077.719l.353,13.258-5.66-16.657Z",
    transform: "translate(-457.007 -258.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M1409.37,998.976l10.61,3.443-6.013,31.617Z",
    transform: "translate(-457.987 -215.196)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M1407.68,1030.636l.71-31.66,4.6,35.06Z",
    transform: "translate(-457.007 -215.196)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M1325.69,1279.53l8.27,89.1,3.03.244Z",
    transform: "translate(-409.47 -377.858)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M1315.769,191.657l-5.219,3.45,5.526,11.361Z",
    transform: "translate(-400.692 252.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M1321.543,170.729l-10.993,12.244,5.219-3.449Z",
    transform: "translate(-400.692 265.013)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1313.751,211.227l-5.526-11.361-1.685,13.941Z",
    transform: "translate(-398.367 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1361.427,240.4l-.988,2.884,19.409,2.557Z",
    transform: "translate(-429.618 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1313.751,226.9l-7.211,2.579,22.649,5.978Z",
    transform: "translate(-398.367 232.444)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M1340.085,231l-16.455-6.818,15.468,9.7Z",
    transform: "translate(-408.275 234.025)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M1323.63,224.177l.03,1.145,15.438,8.557Z",
    transform: "translate(-408.275 234.025)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M1414.958,353.663l-.63-.026-8.518,47.47Z",
    transform: "translate(-455.922 158.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M1426.08,333.413l53.215-8.257,7.7-6.4Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 964.279, -990.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M1387.63,1370.566l2.95-.1,14.317-87.605Z",
    transform: "translate(-445.382 -379.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M1336.989,1368.638l-4.16-89.517-7.139.172Z",
    transform: "translate(-409.47 -377.62)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M1893.885,298.622l-13.854,7.143-16.611.913Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 900.142, -1236.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M1863.5,304.868l-.08,5.431,16.611-.913Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 903.684, -1237.032)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M1883.267,291.671l-19.153-.156-.5,5.611Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 896.088, -1235.53)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M1883.227,286.195l14.2-4.126-33.882.565Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.741, -1234.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M1883.227,286.974l-19.687-3.561.534,3.4Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.502, -1234.514)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M1883.267,291.887l-19.657,5.455,16.531,4.518Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 896.299, -1235.575)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M1292.837,199.866,1280,203.388l11.152,10.418Z",
    transform: "translate(-382.979 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M1291.152,218.666,1280,208.248v11.785Z",
    transform: "translate(-382.979 243.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M1916.809,299.536l-13.859,6.23,13.854-7.143Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 895.377, -1258.697)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M1935.924,289.938l0-.914,3.467-6.956Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.015, -1275.4)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M1404.9,1282.1l-6.866-.55-10.4,88.257Z",
    transform: "translate(-445.382 -379.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M1351.805,70.038l-1.547.369-.269,23.886Z",
    transform: "translate(-423.559 323.393)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M1346.9,47.177l1.546-.369L1344.2,29.972Z",
    transform: "translate(-420.202 346.623)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M1316.626,174.572l-6.076,8.4,10.993-12.244Z",
    transform: "translate(-400.692 265.013)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M1346.118,1509.21l2.282-17.4-3.03-.244Z",
    transform: "translate(-420.88 -500.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M1341.91,1511.635l2.2-2.425-.748-17.64Z",
    transform: "translate(-418.874 -500.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M1342.29,127.757l-2.235.908-3.345,17.149Z",
    transform: "translate(-415.859 289.928)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M1333.271,129.918l-8.261,20.992,4.917-3.843Z",
    transform: "translate(-409.076 288.675)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M1347.174,70.915l-2.5,24.794,2.235-.908Z",
    transform: "translate(-420.474 322.884)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M1340.623,29.972l-2.593,3.307,5.295,13.9Z",
    transform: "translate(-416.624 346.623)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M1916.809,300.8l-1.387,8.824-12.472-2.594Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 896.61, -1258.959)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M1934.017,300.8l12.585,4.433-13.972,4.391Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 893.032, -1275.792)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M1417.1,249.552l-10.472,1.6,8.622,15.993Z",
    transform: "translate(-456.398 219.313)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M1439.416,249.618,1429,249.552l-1.849,17.59Z",
    transform: "translate(-468.295 219.313)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M1485.828,254.392l-46.412-4.682-12.266,17.523Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 924.994, -982.966)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M1427.15,273.694l64.208-.665-5.53-12.176Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 931.313, -984.309)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M1486.994,302.9l-60.464-11.49-.45,26.148Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 948.772, -987.386)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M1487.614,301.983l3.744-12.155-64.208.665Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 947.745, -987.802)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M1416.139,1184.934l-3.181-70.974-5.937,7.06Z",
    transform: "translate(-456.624 -281.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M1409.272,1194.124l6.866.551-9.119-63.914Z",
    transform: "translate(-456.624 -291.603)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M1376.991,1491.035l-7.711-.4,8.749,15.1Z",
    transform: "translate(-434.743 -500.257)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M1390.1,1506.144l5.925,4.038-4.013-18.842Z",
    transform: "translate(-446.814 -500.663)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M1387.63,1491.441l1.038,14.7,1.912-14.8Z",
    transform: "translate(-445.382 -500.663)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M1406.31,741.578l11.077-5.894-7.03-44.324Z",
    transform: "translate(-456.212 -36.843)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M1325.69,1191.593l7.139-.172.765-63.561Z",
    transform: "translate(-409.47 -289.921)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M1327.951,1110.1l-2.261,71.2,7.9-63.733Z",
    transform: "translate(-409.47 -279.624)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M1324.37,26.257l2.593-3.307-12.493-5.089Z",
    transform: "translate(-402.964 353.644)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M1314.47,11.722l12.493,5.089-11.556-9.539Z",
    transform: "translate(-402.964 359.784)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M1295.422,3.781,1280,1.251l14.484,6.98Z",
    transform: "translate(-382.979 363.275)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M1392.708,625.887l-8.459-47.453-8.379.824Z",
    transform: "translate(-438.563 28.63)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M1975.663,315.2l-.143,4.9-11.74.253Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 897.444, -1295.193)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M1963.78,318.12l.882-6.775,11,1.619Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 895.26, -1294.729)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M1932.63,315.736l13.972-4.391-.882,6.775Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 899.015, -1277.063)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M1392.621,1279.782,1378.3,1278.5l3.921,89.539Z",
    transform: "translate(-439.973 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M1373.07,1278.5l-3.791,89.144,7.711.395Z",
    transform: "translate(-434.743 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M1342.68,1278.761l4.16,89.517,10.808-89.778Z",
    transform: "translate(-419.321 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M1352.58,1368.278l7.017-.634,3.79-89.144Z",
    transform: "translate(-425.06 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M1924.585,282.069l-14.195,4.126,11.413,1.394Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 885.092, -1260.921)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M1917.489,293.281l-11.413-1.394-3.127,9.973Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 891.557, -1257.885)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M1915.422,306.377l2.068-11.173-14.539,8.579Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 893.439, -1258.285)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M1948.516,301.987l-12.585-4.433.681-2.35Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.463, -1276.989)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M1936.611,287.588l-.681,2.35,3.462-7.869Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 882.014, -1275.406)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M1382.74,628.608l9.968-1.583L1375.87,580.4Z",
    transform: "translate(-438.563 27.493)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M1402.187,691.36l-9.968,1.583,5.921,48.635Z",
    transform: "translate(-448.043 -36.843)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M1347.15,1509.547l9.846-3.408-7.564-13.989Z",
    transform: "translate(-421.912 -501.132)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M1360.144,1505.263l-.546-14.624-7.017.635Z",
    transform: "translate(-425.06 -500.257)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M1369.28,1490.64l.547,14.624,8.2.475Z",
    transform: "translate(-434.743 -500.257)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M1303.59,189.5l2.925-1.225,6.076-8.4Z",
    transform: "translate(-396.657 259.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M1329.189,239.019l-22.649-5.978,4.446,10.246Z",
    transform: "translate(-398.367 228.885)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M1291.152,233.041,1280,234.408l15.6,8.879Z",
    transform: "translate(-382.979 228.885)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M1354.733,249.824l-19.41-2.557-18.2,4.268Z",
    transform: "translate(-404.501 220.637)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M1937.55,295.2l11.98,3.042-.076,3.74Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.268, -1277.908)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M1976.881,307.8l-11-1.619.076-3.74Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.958, -1294.847)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M1932.63,306.377l14.048-8.131L1934.7,295.2Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.861, -1275.117)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M1932.63,310.575l13.09,2.385.958-10.516Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 893.967, -1275.99)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M1966.06,302.444l12.085,2.263-1.16,3.1Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.937, -1294.949)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M1976.823,304.707l-12.085-2.263-.958,10.516Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 890.212, -1293.656)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M1963.78,316.082l11.74-.253,1.3-8Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 893.266, -1294.305)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M1993.023,307.83l-1.3,8,.143-4.9Z",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 889.899, -1310.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M1416.43,881.84l7.644,3.384-.819-88.383Z",
    transform: "translate(-462.08 -98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M1417.387,796.841l-11.077,5.894,4.253,79.1Z",
    transform: "translate(-456.212 -98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M1280,1.251V7.759l14.484.472Z",
    transform: "translate(-382.979 363.275)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M1418.977,1002.5l-7.644-3.384-3.694,37.538Z",
    transform: "translate(-456.983 -215.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M1407.64,1041.325l5.324-2.538,6.013-31.617Z",
    transform: "translate(-456.983 -219.946)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M1413.317,1095.668l-.353-13.258-5.324,2.538Z",
    transform: "translate(-456.983 -263.57)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M1407.02,1106.229l5.938-7.06-5.677-10.72Z",
    transform: "translate(-456.624 -267.071)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M1297.312,831.373l-6.442.753,7.106,55.037Z",
    transform: "translate(-389.281 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M1343.445,1122.1l-.765,63.561,14.447-67.734Z",
    transform: "translate(-419.321 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M1377.06,1117.93l.521,67.473,14.321,1.281Z",
    transform: "translate(-439.254 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M1342.68,1185.664l14.968-.261-.521-67.473Z",
    transform: "translate(-419.321 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M1389.65,1123.321l-12.59-5.391,14.842,68.755Z",
    transform: "translate(-439.254 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M1286.24,831.928l-1.672.223-4.568-.735Z",
    transform: "translate(-382.979 -118.046)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M1280,831.391l4.568.735,6.442-.753Z",
    transform: "translate(-382.979 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M1280,818.885V809.8l6.24,9.594Z",
    transform: "translate(-382.979 -105.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M1295.6,245.173l-15.6-8.879V249.4Z",
    transform: "translate(-382.979 226.999)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M1328.02,1085.63l1.281,10.282,3.568-8.2Z",
    transform: "translate(-410.821 -265.437)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M1331.07,1098.782l5.644,7.463-2.076-15.665Z",
    transform: "translate(-412.589 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M1316.285,1015.191l4.849,2.08L1307.78,964.14Z",
    transform: "translate(-399.086 -194.998)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M1335.26,71.51l3.954,24.2,2.5-24.794Z",
    transform: "translate(-415.018 322.884)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M1335.26,52.334l6.459-.6-5.295-13.9Z",
    transform: "translate(-415.018 342.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M1366.42,748.178l16.762-4.415-5.921-48.635Z",
    transform: "translate(-433.085 -39.028)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M1280,203.388l12.837-3.522L1280,204.7Z",
    transform: "translate(-382.979 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M1289.913,201.091,1280,204.7l12.837-4.83Z",
    transform: "translate(-382.979 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M1375.87,518.21l8.379-.824-7.106-44.246Z",
    transform: "translate(-438.563 89.678)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M1386.006,513.6l4.2-46.992-11.308,2.747Z",
    transform: "translate(-440.32 93.468)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M1390.208,401.107l8.518-47.47L1378.9,403.853Z",
    transform: "translate(-440.32 158.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M1327.97,97.631l7.018-1.1-3.954-24.2Z",
    transform: "translate(-410.792 322.063)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M1333.271,129.918l-7.018,1.1-1.244,19.892Z",
    transform: "translate(-409.076 288.675)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M1321.134,1017.271l-5.908-51.306-7.446-1.825Z",
    transform: "translate(-399.086 -194.998)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M1306.864,887.163l7.446,1.825-8.11-57.615Z",
    transform: "translate(-398.17 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M1306.14,156.2l7.93-3.775,1.244-19.892Z",
    transform: "translate(-398.135 287.156)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M1304.661,183.65l-1.071,5.85,9-9.625Z",
    transform: "translate(-396.657 259.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M1280,198.314l9.913-3.6,1.072-5.85Z",
    transform: "translate(-382.979 254.502)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M1385.06,269.455l17.687-.111-8.623-15.993Z",
    transform: "translate(-443.892 217.11)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M1317.12,255.063l28.549,14.392,9.064-16.1Z",
    transform: "translate(-404.501 217.11)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M1364.894,695.128l-19.8.913,8.963,52.137Z",
    transform: "translate(-420.718 -39.028)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M1331.5,749.439l-8.963-52.137L1306.2,753.64Z",
    transform: "translate(-398.17 -40.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M1294.484,17.211,1280,16.739l14.241,12.782Z",
    transform: "translate(-382.979 354.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M1324.034,37.841l-10.144,3.915,8.98,10.579Z",
    transform: "translate(-402.629 342.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M1313.89,30.172l10.144-3.915-9.9-8.4Z",
    transform: "translate(-402.629 353.644)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M1291.009,753.64l16.342-56.338-27.351.622Z",
    transform: "translate(-382.979 -40.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M1280,698.783v55.734l11.009-.018Z",
    transform: "translate(-382.979 -41.147)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M1375,1037.551l13.716-.9,3.693-37.538Z",
    transform: "translate(-438.059 -215.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M1331.408,1019.79H1346.3l-20.8-51.306Z",
    transform: "translate(-409.359 -197.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M1388.716,1088.45l-13.716.9,13.455,16.884Z",
    transform: "translate(-438.059 -267.071)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M1354.452,1090.58H1339.56l2.076,15.665Z",
    transform: "translate(-417.512 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M1344.5,1106.245l13.682-4.172-.866-11.493Z",
    transform: "translate(-420.376 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M1375,1090.58l.866,11.493,12.59,5.391Z",
    transform: "translate(-438.059 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M1333.724,889.376l-2.219-68-25.3,4.2Z",
    transform: "translate(-398.17 -112.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M1306.2,831.373l8.11,57.615,19.414,6.184Z",
    transform: "translate(-398.17 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M1390.5,989.889l-18.8-6.689,1.387,45.122Z",
    transform: "translate(-436.146 -206.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M1383.182,810.868l-16.762,4.415,2.219,68Z",
    transform: "translate(-433.085 -106.133)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M1371.7,883.284l18.8,6.689-4.253-79.1Z",
    transform: "translate(-436.146 -106.133)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M1346.3,1019.79l-1.387-45.122-19.414-6.184Z",
    transform: "translate(-409.359 -197.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M1280,190.491v7.823l10.984-9.455Z",
    transform: "translate(-382.979 254.502)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M1333.02,584.874l5.072,47.243,19.8-.914Z",
    transform: "translate(-413.72 24.896)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M1351.026,580.4l-18.006,1.882,24.876,46.33Z",
    transform: "translate(-413.72 27.493)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M1303.45,133.962l1.13,22.243,9.173-23.667Z",
    transform: "translate(-396.575 287.156)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M1280,159.8l10.984-1.632-1.13-22.243Z",
    transform: "translate(-382.979 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M1313.754,99.4l-8.018-24.018-2.286,25.442Z",
    transform: "translate(-396.575 320.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M1310.991,47.157l-2.1,11.86,11.081-1.281Z",
    transform: "translate(-399.729 336.659)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M1316.907,97.631l3.063-25.3-11.081,1.281Z",
    transform: "translate(-399.729 322.063)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M1385.06,291.522l.777,33.768,16.909-33.879Z",
    transform: "translate(-443.892 195.043)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M1386.91,325.29l16.46-7.731.45-26.148Z",
    transform: "translate(-444.964 195.043)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M1378.9,403.853l19.825-50.216-16.46,7.731Z",
    transform: "translate(-440.32 158.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M1302.28,584.874l-22.28.771,27.351,46.473Z",
    transform: "translate(-382.979 24.896)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M1280,586.708v47.1l27.351-.622Z",
    transform: "translate(-382.979 23.833)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M1341.24,1599.9h22.54l9.392-.025Z",
    transform: "translate(-418.485 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M1280,144.4v15.4l9.854-23.875Z",
    transform: "translate(-382.979 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M1280,48.331l12.14,10.686,2.1-11.86Z",
    transform: "translate(-382.979 336.659)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M1294.241,29.521,1280,16.739V30.7Z",
    transform: "translate(-382.979 354.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M1342.16,1599.87l-.92.025,31.932-.025Z",
    transform: "translate(-418.485 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M1280,62.289l12.14-1.652L1280,49.951Z",
    transform: "translate(-382.979 335.039)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M1292.14,75.38,1280,77.032l9.854,23.79Z",
    transform: "translate(-382.979 320.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M1289.854,103.1,1280,79.312V92.226Z",
    transform: "translate(-382.979 318.016)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M1352.035,291.674l-23.935,5.088,24.712,28.68Z",
    transform: "translate(-410.867 194.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M1295.6,257.425l-15.6,4.228,20.212,15.252Z",
    transform: "translate(-382.979 214.748)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M1345.669,271.817l-28.549-14.392,4.614,19.48Z",
    transform: "translate(-404.501 214.748)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M1300.212,282.739,1280,267.487v20.7Z",
    transform: "translate(-382.979 208.914)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M1349.748,473.14l-21.128,4.51,19.855,40.56Z",
    transform: "translate(-411.168 89.678)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M1328.62,483.873l1.849,42.442,18.006-1.882Z",
    transform: "translate(-411.168 83.456)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M1300.431,483.873,1280,486.215l22.28,40.1Z",
    transform: "translate(-382.979 83.456)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M1302.28,529.546l-22.28-40.1v40.87Z",
    transform: "translate(-382.979 80.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M1410.528,1552.089l-6.219-13.913-.109-2Z",
    transform: "translate(-454.989 -526.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M1394.88,1565.723l4.026-24.792,6.219,13.913Z",
    transform: "translate(-449.585 -529.415)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M1404.272,1584.894l-9.392.025,10.245-10.879Z",
    transform: "translate(-449.585 -548.611)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M1341.238,1584.111l-1.588-11.421.668,11.446Z",
    transform: "translate(-417.564 -547.829)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M1339.65,1553.342l.949-14.022-.281,25.469Z",
    transform: "translate(-417.564 -528.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M1342.8,1533.55l-2.2,2.425L1339.65,1550Z",
    transform: "translate(-417.564 -525.136)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M1280,384.507v44.1l20.431-2.342Z",
    transform: "translate(-382.979 141.067)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M1289.854,135.927,1280,142.762V144.4Z",
    transform: "translate(-382.979 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M1289.854,120.921,1280,110.045v13.206Z",
    transform: "translate(-382.979 300.197)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M1280,142.762l9.854-6.835-9.854,2.33Z",
    transform: "translate(-382.979 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M1352.813,332.463l-24.712-28.68,1.315,32.2Z",
    transform: "translate(-410.867 187.87)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M1301.527,343.5,1280,316.747V345.22Z",
    transform: "translate(-382.979 180.354)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M1329.717,380.422l-1.1,43.471,21.128-4.51Z",
    transform: "translate(-411.168 143.436)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M1300.212,303.783,1280,309.231l21.527,26.757Z",
    transform: "translate(-382.979 187.87)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M1354.627,372.034l-23.4,3.525,20.031,38.961Z",
    transform: "translate(-412.682 148.299)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M1301.527,380.422,1280,382.139l20.431,41.755Z",
    transform: "translate(-382.979 143.436)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M1406.179,1543.538l4.349,8.551-6.329-15.909Z",
    transform: "translate(-454.989 -526.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M1396.025,1530.608l-5.925-4.038,7.9,11.4Z",
    transform: "translate(-446.814 -521.089)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M1343.154,1542.072l-.353-8.522L1339.65,1550Z",
    transform: "translate(-417.564 -525.136)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M1378.719,1525.915l-8.2-.475-.046,8.455Z",
    transform: "translate(-435.432 -520.434)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M1378.719,1526.57l-8.249,7.98,16.153,3.416Z",
    transform: "translate(-435.432 -521.089)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M1347.5,1542.072l9.446-3.475-9.8-5.047Z",
    transform: "translate(-421.912 -525.136)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M1356.949,1533.895l.046-8.455-9.846,3.408Z",
    transform: "translate(-421.912 -520.434)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M1343.43,1599.87h0Z",
    transform: "translate(-419.755 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M1413.259,1562.241l-4.349-8.552,7.484,8.866Z",
    transform: "translate(-457.72 -536.813)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M1418.083,1574.04l3.135.315-3.988,10.539Z",
    transform: "translate(-462.544 -548.611)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M1421.218,1574.79l.13,10.539h-4.118Z",
    transform: "translate(-462.544 -549.046)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M1403.159,1553.69l-4.169,8.085,11.652.781Z",
    transform: "translate(-451.968 -536.813)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M1382.454,1557.061l4.169-8.085-16.153-3.416Z",
    transform: "translate(-435.432 -532.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M1339.65,1561.755l3.093.74.412-8.665Z",
    transform: "translate(-417.564 -536.894)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M1356.868,1545.56l-9.858,12.14,21.843-.639Z",
    transform: "translate(-421.831 -532.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M1339.65,1572.69l1.588,11.421,1.5-10.682Z",
    transform: "translate(-417.564 -547.829)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M1347.01,1557.7l9.858-12.14-9.446,3.475Z",
    transform: "translate(-421.831 -532.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M1368.638,1584.251l.214-11.32-21.843.639Z",
    transform: "translate(-421.831 -547.968)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M1410.477,1585.329l-.13-10.539-11.867,10.539Z",
    transform: "translate(-451.673 -549.046)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M1410.347,1573.712l-11.652-.781-.214,11.32Z",
    transform: "translate(-451.673 -547.968)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M1346.56,1585.132h21.817l-21.628-10.682Z",
    transform: "translate(-421.57 -548.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M1344.745,1599.87h0Z",
    transform: "translate(-419.755 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M1343.43,1585.132h1.315l.189-10.682Z",
    transform: "translate(-419.755 -548.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M1380.374,1599.87h0Z",
    transform: "translate(-421.57 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 6.459,
    y2: 0.595,
    transform: "translate(920.242 393.799)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 5.295,
    y1: 13.898,
    transform: "translate(921.405 379.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 14.493,
    x2: 1.164,
    transform: "translate(920.242 379.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y1: 7.823,
    transform: "translate(897.021 444.993)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x1: 10.984,
    y2: 9.455,
    transform: "translate(897.021 443.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 10.984,
    y2: 1.632,
    transform: "translate(897.021 443.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 6.694,
    y2: 11.755,
    transform: "translate(911.888 431.557)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y1: 15.231,
    x2: 0.214,
    transform: "translate(911.888 428.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 6.48,
    y1: 3.477,
    transform: "translate(912.102 428.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 14.867,
    y2: 0.624,
    transform: "translate(897.021 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 14.867,
    y2: 15.855,
    transform: "translate(897.021 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y2: 15.231,
    transform: "translate(897.021 443.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 15.081,
    y2: 15.855,
    transform: "translate(897.021 428.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y1: 18.895,
    transform: "translate(897.021 425.041)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 15.081,
    y1: 3.04,
    transform: "translate(897.021 425.041)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 38.739,
    y2: 5.371,
    transform: "translate(897.021 526.738)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 5.921,
    y2: 36.981,
    transform: "translate(929.839 526.738)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 32.818,
    y2: 31.61,
    transform: "translate(897.021 532.109)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 22.28,
    y2: 0.771,
    transform: "translate(897.021 609.771)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 27.352,
    y1: 46.473,
    transform: "translate(897.021 610.541)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 5.072,
    y1: 47.243,
    transform: "translate(919.3 609.771)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y1: 0.71,
    x2: 18.51,
    transform: "translate(929.461 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y1: 48.161,
    x2: 10.379,
    transform: "translate(929.461 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 8.131,
    y1: 47.451,
    transform: "translate(939.84 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x1: 8.211,
    y2: 3.192,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 965.515, 560.832)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 45.429,
    y2: 2.209,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 955.11, 516.6)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y1: 0.982,
    x2: 53.64,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 956.07, 516.396)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 9.413,
    y2: 6.862,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 967.148, 550.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y1: 7.457,
    x2: 29.158,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 961.086, 522.341)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y1: 0.596,
    x2: 38.571,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 954.375, 523.767)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x1: 4.9,
    y2: 8.198,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 975.242, 567.159)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    y1: 9.18,
    x2: 58.54,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 964.088, 514.691)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x1: 2.647,
    y2: 14.208,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 993.784, 579.001)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y1: 1.467,
    x2: 10.539,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 977.695, 571.646)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    y1: 15.676,
    x2: 13.186,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 991.593, 568.692)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 4.803,
    y2: 4.761,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.991, 580.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    y1: 3.922,
    x2: 18.573,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 990.473, 563.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    y1: 8.682,
    x2: 23.376,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 995.129, 562.433)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x1: 0.458,
    y2: 1.253,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 987.498, 649.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    y1: 11.171,
    x2: 60.384,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 975.039, 591.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    y1: 9.919,
    x2: 59.926,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 973.813, 591.379)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    y1: 7.06,
    x2: 5.938,
    transform: "translate(950.396 832.098)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 5.677,
    y2: 10.72,
    transform: "translate(950.656 821.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x1: 0.261,
    y2: 17.779,
    transform: "translate(950.396 821.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 3.992,
    y2: 0.882,
    transform: "translate(916.22 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x1: 2.261,
    y2: 71.196,
    transform: "translate(916.22 830.476)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 1.731,
    y2: 72.079,
    transform: "translate(918.481 830.476)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 11.963,
    y2: 2.652,
    transform: "translate(938.709 812.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    y1: 88.337,
    x2: 10.354,
    transform: "translate(940.319 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x2: 1.609,
    y2: 90.988,
    transform: "translate(938.709 812.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x1: 8.715,
    y2: 0.059,
    transform: "translate(935.608 990.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x2: 4.996,
    y2: 20.611,
    transform: "translate(944.324 990.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    x2: 13.711,
    y2: 20.553,
    transform: "translate(935.608 990.963)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x1: 4.349,
    y1: 8.551,
    transform: "translate(951.19 1016.877)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x2: 7.484,
    y2: 8.866,
    transform: "translate(951.19 1016.877)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    x2: 3.135,
    y2: 0.315,
    transform: "translate(955.539 1025.429)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y2: 6.508,
    transform: "translate(897.021 364.526)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x1: 14.485,
    y1: 0.472,
    transform: "translate(897.021 371.034)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x1: 14.485,
    y1: 6.98,
    transform: "translate(897.021 364.526)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    y2: 42.739,
    transform: "translate(897.021 489.369)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x1: 38.739,
    y1: 37.368,
    transform: "translate(897.021 489.369)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    y2: 34.046,
    transform: "translate(897.021 532.109)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x1: 32.818,
    y2: 2.436,
    transform: "translate(897.021 563.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    y2: 44.097,
    transform: "translate(897.021 525.574)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    x1: 20.431,
    y2: 2.342,
    transform: "translate(897.021 567.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    x2: 20.431,
    y2: 41.755,
    transform: "translate(897.021 525.574)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    y2: 46.938,
    transform: "translate(897.021 608.746)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x1: 32.44,
    y1: 46.631,
    transform: "translate(897.021 608.746)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x1: 32.44,
    y2: 0.307,
    transform: "translate(897.021 655.376)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    y2: 47.095,
    transform: "translate(897.021 610.541)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x1: 27.352,
    y2: 0.622,
    transform: "translate(897.021 657.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x2: 6.858,
    y2: 2.805,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 955.11, 516.6)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    y1: 1.056,
    x2: 21.46,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 962.686, 529.871)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x1: 7.698,
    y2: 6.401,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 960.052, 522.56)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x2: 63.834,
    y2: 4.46,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 967.351, 508.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    x2: 5.387,
    y2: 11.754,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 986.636, 564.238)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    x2: 68.688,
    y2: 0.354,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 979.886, 581.955)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    y1: 13.39,
    x2: 67.372,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 979.813, 583.315)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_167",
    "data-name": "Line 167",
    x2: 1.315,
    y2: 13.745,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 979.886, 581.955)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    x2: 0.353,
    y2: 13.258,
    transform: "translate(955.98 818.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    x1: 5.66,
    y1: 16.657,
    transform: "translate(950.673 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    x1: 5.307,
    y1: 3.4,
    transform: "translate(950.673 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 2.538,
    x2: 5.324,
    transform: "translate(950.656 818.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x1: 2.282,
    y2: 17.397,
    transform: "translate(925.238 991.018)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    x1: 3.03,
    y1: 0.244,
    transform: "translate(924.49 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x2: 0.748,
    y2: 17.64,
    transform: "translate(924.49 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    x2: 1.315,
    transform: "translate(923.674 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_186",
    "data-name": "Line 186",
    y1: 10.682,
    x2: 0.189,
    transform: "translate(924.99 1025.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    y1: 10.682,
    x2: 1.504,
    transform: "translate(923.674 1025.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    x1: 9.913,
    y2: 3.605,
    transform: "translate(897.021 449.211)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    x1: 1.072,
    y2: 5.85,
    transform: "translate(906.933 443.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    x1: 3.954,
    y1: 24.198,
    transform: "translate(920.242 394.395)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    y1: 24.794,
    x2: 2.504,
    transform: "translate(924.196 393.799)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    x1: 2.593,
    y2: 3.307,
    transform: "translate(921.405 376.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    x1: 12.493,
    y1: 5.089,
    transform: "translate(911.505 371.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    x1: 9.9,
    y1: 8.395,
    transform: "translate(911.505 371.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    x2: 3.467,
    y2: 14.89,
    transform: "translate(911.888 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    x1: 18.334,
    y2: 0.965,
    transform: "translate(897.021 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    x2: 21.817,
    transform: "translate(924.99 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    x2: 21.628,
    y2: 10.682,
    transform: "translate(925.179 1025.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    x1: 9.854,
    y1: 10.876,
    transform: "translate(897.021 410.242)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    y2: 13.206,
    transform: "translate(897.021 410.242)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x1: 9.854,
    y2: 2.33,
    transform: "translate(897.021 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    x1: 12.837,
    y2: 3.522,
    transform: "translate(897.021 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    y1: 4.83,
    x2: 12.837,
    transform: "translate(897.021 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    y1: 1.308,
    transform: "translate(897.021 451.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    x2: 15.455,
    y2: 2.964,
    transform: "translate(897.021 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    x1: 15.422,
    y1: 3.056,
    transform: "translate(897.021 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    y1: 0.092,
    x2: 0.034,
    transform: "translate(912.442 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    y1: 2.201,
    x2: 15.455,
    transform: "translate(897.021 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    y2: 5.164,
    transform: "translate(897.021 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    y1: 3.45,
    x2: 5.219,
    transform: "translate(909.858 444.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    x2: 5.526,
    y2: 11.361,
    transform: "translate(909.858 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_234",
    "data-name": "Line 234",
    x2: 0.307,
    y2: 14.811,
    transform: "translate(915.077 444.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_238",
    "data-name": "Line 238",
    y1: 2.579,
    x2: 7.211,
    transform: "translate(908.173 459.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_239",
    "data-name": "Line 239",
    x2: 22.649,
    y2: 5.978,
    transform: "translate(908.173 461.926)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    "data-name": "Line 240",
    x2: 15.439,
    y2: 8.557,
    transform: "translate(915.384 459.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    x2: 16.153,
    y2: 21.337,
    transform: "translate(897.021 393.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    y1: 0.872,
    x2: 18.641,
    transform: "translate(897.021 392.872)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    x1: 2.488,
    y2: 22.209,
    transform: "translate(913.173 392.872)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    y1: 4.79,
    x2: 17.426,
    transform: "translate(897.021 374.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    y2: 9.976,
    transform: "translate(897.021 369.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x2: 17.426,
    y2: 5.185,
    transform: "translate(897.021 369.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x1: 10.27,
    y1: 7.198,
    transform: "translate(912.476 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x1: 11.619,
    y1: 8.607,
    transform: "translate(912.476 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x1: 1.349,
    y1: 1.409,
    transform: "translate(922.746 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    x2: 11.152,
    y2: 10.418,
    transform: "translate(897.021 451.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    x1: 1.685,
    y2: 13.94,
    transform: "translate(908.173 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    x2: 16.153,
    y2: 0.37,
    transform: "translate(897.021 414.711)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x1: 16.153,
    y2: 9.96,
    transform: "translate(897.021 415.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    y2: 10.33,
    transform: "translate(897.021 414.711)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x1: 11.152,
    y2: 1.367,
    transform: "translate(897.021 461.926)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x2: 15.598,
    y2: 8.879,
    transform: "translate(897.021 463.293)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x2: 4.446,
    y2: 10.246,
    transform: "translate(908.173 461.926)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x1: 15.598,
    y2: 4.228,
    transform: "translate(897.021 472.173)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x2: 20.212,
    y2: 15.252,
    transform: "translate(897.021 476.401)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x2: 4.614,
    y2: 19.48,
    transform: "translate(912.619 472.173)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x2: 6.971,
    y2: 23.976,
    transform: "translate(931.81 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 41.761,
    y2: 20.054,
    transform: "translate(897.021 468.942)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x1: 34.789,
    y2: 3.922,
    transform: "translate(897.021 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    y1: 5.088,
    x2: 23.935,
    transform: "translate(917.233 486.564)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    x2: 24.713,
    y2: 28.68,
    transform: "translate(917.233 491.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    x2: 0.777,
    y2: 33.768,
    transform: "translate(941.168 486.564)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    x1: 20.212,
    y2: 5.448,
    transform: "translate(897.021 491.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x2: 21.527,
    y2: 26.757,
    transform: "translate(897.021 497.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 1.315,
    y2: 32.205,
    transform: "translate(917.233 491.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x2: 10.001,
    y2: 43.497,
    transform: "translate(929.839 563.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x1: 16.052,
    y2: 1.023,
    transform: "translate(923.788 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x1: 6.051,
    y2: 44.52,
    transform: "translate(923.788 563.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 26.767,
    y2: 42.084,
    transform: "translate(897.021 566.155)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 26.767,
    y2: 0.507,
    transform: "translate(897.021 608.239)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    y2: 42.59,
    transform: "translate(897.021 566.155)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    x2: 22.28,
    y2: 40.099,
    transform: "translate(897.021 569.671)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    x2: 1.849,
    y2: 42.442,
    transform: "translate(917.451 567.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    y1: 47.444,
    x2: 9.148,
    transform: "translate(949.887 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    y1: 0.867,
    x2: 2.614,
    transform: "translate(947.274 560.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    y1: 48.311,
    x2: 11.762,
    transform: "translate(947.274 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x1: 1.588,
    y2: 46.125,
    transform: "translate(945.685 560.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    y1: 0.151,
    x2: 5.845,
    transform: "translate(939.84 607.064)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x1: 7.434,
    y2: 46.277,
    transform: "translate(939.84 560.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x2: 45.005,
    y2: 5.851,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 981.448, 478.047)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x1: 9.442,
    y1: 1.167,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 984.259, 513.806)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 33.213,
    y2: 2.357,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 985.082, 523.284)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x2: 42.656,
    y2: 3.523,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 984.259, 513.806)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x1: 2.668,
    y2: 8.653,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 984.34, 545.094)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    y1: 10.845,
    x2: 45.101,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 986.485, 544.638)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    y1: 2.192,
    x2: 42.433,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 987.039, 547.248)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x2: 2.29,
    y2: 74.66,
    transform: "translate(930.23 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x1: 29.259,
    y1: 63.125,
    transform: "translate(903.261 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x1: 26.969,
    y2: 11.535,
    transform: "translate(903.261 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 6.24,
    y2: 9.594,
    transform: "translate(897.021 704.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    y1: 1.941,
    x2: 33.209,
    transform: "translate(897.021 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x1: 4.849,
    y1: 2.088,
    transform: "translate(917.199 820.193)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 13.354,
    y2: 53.14,
    transform: "translate(908.694 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 8.505,
    y2: 51.051,
    transform: "translate(908.694 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x2: 10.283,
    y2: 25.805,
    transform: "translate(935.012 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x1: 10.451,
    y2: 0.029,
    transform: "translate(934.844 1036.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x1: 0.168,
    y2: 25.835,
    transform: "translate(934.844 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    x2: 12.14,
    y2: 10.686,
    transform: "translate(897.021 384.99)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    y1: 11.86,
    x2: 2.101,
    transform: "translate(909.161 383.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    y1: 1.174,
    x2: 14.241,
    transform: "translate(897.021 383.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x1: 6.076,
    y2: 8.4,
    transform: "translate(909.858 439.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    x1: 10.993,
    y2: 12.244,
    transform: "translate(909.858 435.742)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    x1: 4.916,
    y2: 3.843,
    transform: "translate(915.934 435.742)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    y2: 15.399,
    transform: "translate(897.021 429.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    x1: 9.854,
    y2: 23.875,
    transform: "translate(897.021 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    "data-name": "Line 379",
    x1: 9.854,
    y2: 8.476,
    transform: "translate(897.021 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x1: 9.854,
    y2: 6.835,
    transform: "translate(897.021 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    y2: 1.641,
    transform: "translate(897.021 427.953)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    x2: 8.203,
    y2: 0.475,
    transform: "translate(935.083 1005.006)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    x1: 0.046,
    y2: 8.455,
    transform: "translate(935.037 1005.006)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    x1: 8.249,
    y2: 7.98,
    transform: "translate(935.037 1005.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_391",
    "data-name": "Line 391",
    x2: 8.018,
    y2: 24.018,
    transform: "translate(909.161 395.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_392",
    "data-name": "Line 392",
    y1: 25.443,
    x2: 2.286,
    transform: "translate(906.875 395.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_393",
    "data-name": "Line 393",
    y1: 1.424,
    x2: 10.304,
    transform: "translate(906.875 419.694)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    y1: 1.652,
    x2: 12.14,
    transform: "translate(897.021 395.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_398",
    "data-name": "Line 398",
    x2: 9.854,
    y2: 23.79,
    transform: "translate(897.021 397.328)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    "data-name": "Line 401",
    y2: 12.914,
    transform: "translate(897.021 397.328)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    y1: 4.505,
    transform: "translate(897.021 423.448)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    x1: 1.135,
    y1: 17.23,
    transform: "translate(928.247 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    y1: 24.254,
    x2: 1.815,
    transform: "translate(926.431 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_405",
    "data-name": "Line 405",
    y1: 7.024,
    x2: 2.95,
    transform: "translate(926.431 410.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_409",
    "data-name": "Line 409",
    y1: 0.526,
    transform: "translate(897.021 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_410",
    "data-name": "Line 410",
    x1: 15.422,
    y1: 2.53,
    transform: "translate(897.021 364.526)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412",
    "data-name": "Line 412",
    x2: 1.971,
    y2: 7.386,
    transform: "translate(912.476 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_414",
    "data-name": "Line 414",
    y1: 4.269,
    x2: 18.204,
    transform: "translate(912.619 467.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_416",
    "data-name": "Line 416",
    y2: 20.967,
    transform: "translate(897.021 393.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_417",
    "data-name": "Line 417",
    x1: 18.641,
    y1: 13.732,
    transform: "translate(897.021 379.14)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_418",
    "data-name": "Line 418",
    y1: 14.604,
    transform: "translate(897.021 379.14)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_420",
    "data-name": "Line 420",
    x2: 11.652,
    y2: 8.515,
    transform: "translate(912.442 367.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_422",
    "data-name": "Line 422",
    x1: 8.299,
    y2: 0.188,
    transform: "translate(914.447 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_424",
    "data-name": "Line 424",
    y2: 11.785,
    transform: "translate(897.021 451.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    "data-name": "Line 425",
    y2: 13.108,
    transform: "translate(897.021 463.293)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_426",
    "data-name": "Line 426",
    y2: 9.776,
    transform: "translate(897.021 459.167)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_427",
    "data-name": "Line 427",
    x2: 34.789,
    y2: 5.854,
    transform: "translate(897.021 459.167)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_429",
    "data-name": "Line 429",
    x2: 28.549,
    y2: 14.392,
    transform: "translate(912.619 472.173)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_431",
    "data-name": "Line 431",
    y2: 20.7,
    transform: "translate(897.021 476.401)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_432",
    "data-name": "Line 432",
    x1: 41.761,
    y2: 0.374,
    transform: "translate(897.021 488.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_433",
    "data-name": "Line 433",
    y2: 20.427,
    transform: "translate(897.021 468.942)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_435",
    "data-name": "Line 435",
    y1: 3.525,
    x2: 23.397,
    transform: "translate(918.548 520.333)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_437",
    "data-name": "Line 437",
    y2: 28.473,
    transform: "translate(897.021 497.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_438",
    "data-name": "Line 438",
    x1: 21.527,
    y2: 1.717,
    transform: "translate(897.021 523.857)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_440",
    "data-name": "Line 440",
    y1: 2.78,
    x2: 17.435,
    transform: "translate(929.839 560.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_442",
    "data-name": "Line 442",
    y2: 40.87,
    transform: "translate(897.021 569.671)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_443",
    "data-name": "Line 443",
    x1: 4.202,
    y2: 46.992,
    transform: "translate(945.685 560.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_445",
    "data-name": "Line 445",
    x2: 46.412,
    y2: 4.682,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 980.011, 476.913)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_446",
    "data-name": "Line 446",
    y1: 1.169,
    x2: 1.408,
    transform: "translate(971.121 467.762)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_449",
    "data-name": "Line 449",
    x2: 58.418,
    y2: 6.413,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 995.862, 588.754)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_450",
    "data-name": "Line 450",
    x2: 58.951,
    y2: 9.817,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 995.862, 588.754)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_451",
    "data-name": "Line 451",
    x2: 0.534,
    y2: 3.405,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.735, 647.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    x1: 16.472,
    y1: 6.325,
    transform: "translate(916.048 770.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_456",
    "data-name": "Line 456",
    x2: 12.787,
    y2: 56.8,
    transform: "translate(903.261 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_459",
    "data-name": "Line 459",
    x1: 2.244,
    y2: 19.641,
    transform: "translate(923.036 991.198)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_460",
    "data-name": "Line 460",
    x2: 9.732,
    y2: 19.304,
    transform: "translate(925.28 991.198)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_461",
    "data-name": "Line 461",
    x1: 11.976,
    y2: 0.336,
    transform: "translate(923.036 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_465",
    "data-name": "Line 465",
    x1: 14.241,
    y1: 12.782,
    transform: "translate(897.021 371.034)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_466",
    "data-name": "Line 466",
    y1: 13.956,
    transform: "translate(897.021 371.034)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_468",
    "data-name": "Line 468",
    y2: 12.338,
    transform: "translate(897.021 384.99)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_469",
    "data-name": "Line 469",
    x1: 5.774,
    y2: 8.794,
    transform: "translate(915.077 435.742)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    x1: 10.144,
    y2: 3.915,
    transform: "translate(911.262 379.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    "data-name": "Line 472",
    x1: 8.98,
    y1: 10.579,
    transform: "translate(911.262 383.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_475",
    "data-name": "Line 475",
    x1: 0.244,
    y2: 12.31,
    transform: "translate(911.262 371.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_477",
    "data-name": "Line 477",
    y1: 0.369,
    x2: 1.546,
    transform: "translate(926.7 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_478",
    "data-name": "Line 478",
    x1: 0.269,
    y2: 23.886,
    transform: "translate(926.431 393.799)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_481",
    "data-name": "Line 481",
    x1: 3.463,
    y1: 2.785,
    transform: "translate(928.247 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_482",
    "data-name": "Line 482",
    x1: 2.328,
    y2: 14.445,
    transform: "translate(929.381 396.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_485",
    "data-name": "Line 485",
    y1: 1.225,
    x2: 2.925,
    transform: "translate(906.933 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_487",
    "data-name": "Line 487",
    x1: 11.556,
    y1: 9.539,
    transform: "translate(912.442 367.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_488",
    "data-name": "Line 488",
    y1: 4.45,
    x2: 0.937,
    transform: "translate(911.505 367.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_491",
    "data-name": "Line 491",
    x1: 2.635,
    y1: 3.268,
    transform: "translate(929.074 392.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_492",
    "data-name": "Line 492",
    y1: 20.759,
    x2: 6.349,
    transform: "translate(925.36 396.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_493",
    "data-name": "Line 493",
    y1: 24.027,
    x2: 3.715,
    transform: "translate(925.36 392.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_497",
    "data-name": "Line 497",
    x1: 3.505,
    y2: 12.979,
    transform: "translate(915.077 431.557)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_498",
    "data-name": "Line 498",
    x2: 2.269,
    y2: 4.185,
    transform: "translate(918.582 431.557)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_501",
    "data-name": "Line 501",
    x1: 0.798,
    y1: 24.335,
    transform: "translate(924.562 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_502",
    "data-name": "Line 502",
    x1: 4.513,
    y1: 0.308,
    transform: "translate(924.562 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_505",
    "data-name": "Line 505",
    x1: 8.598,
    y1: 0.717,
    transform: "translate(913.173 415.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_506",
    "data-name": "Line 506",
    y1: 12.283,
    x2: 9.669,
    transform: "translate(912.102 415.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_507",
    "data-name": "Line 507",
    y1: 13,
    x2: 1.072,
    transform: "translate(912.102 415.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_511",
    "data-name": "Line 511",
    x1: 1.815,
    y1: 18.478,
    transform: "translate(922.746 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_512",
    "data-name": "Line 512",
    x1: 10.114,
    y1: 18.29,
    transform: "translate(914.447 374.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_515",
    "data-name": "Line 515",
    x2: 0.029,
    y2: 1.145,
    transform: "translate(915.354 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_516",
    "data-name": "Line 516",
    x1: 0.277,
    y1: 13.665,
    transform: "translate(915.077 444.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_519",
    "data-name": "Line 519",
    x1: 1.214,
    y1: 18.522,
    transform: "translate(914.447 374.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_521",
    "data-name": "Line 521",
    x2: 15.468,
    y2: 9.703,
    transform: "translate(915.354 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_523",
    "data-name": "Line 523",
    x1: 17.687,
    y2: 0.111,
    transform: "translate(941.168 486.454)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_524",
    "data-name": "Line 524",
    x1: 8.623,
    y1: 15.993,
    transform: "translate(950.232 470.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_525",
    "data-name": "Line 525",
    y1: 16.104,
    x2: 9.064,
    transform: "translate(941.168 470.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_529",
    "data-name": "Line 529",
    y1: 7.731,
    x2: 16.46,
    transform: "translate(941.945 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_530",
    "data-name": "Line 530",
    x1: 0.45,
    y2: 26.148,
    transform: "translate(958.405 486.454)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_531",
    "data-name": "Line 531",
    x1: 16.909,
    y2: 33.879,
    transform: "translate(941.945 486.454)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_535",
    "data-name": "Line 535",
    y1: 37.742,
    x2: 3.021,
    transform: "translate(935.76 488.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_537",
    "data-name": "Line 537",
    y1: 25.299,
    x2: 33.121,
    transform: "translate(935.76 501.439)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_538",
    "data-name": "Line 538",
    x1: 9.846,
    y2: 11.189,
    transform: "translate(959.035 501.439)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_539",
    "data-name": "Line 539",
    y1: 14.109,
    x2: 23.275,
    transform: "translate(935.76 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_543",
    "data-name": "Line 543",
    x1: 20.031,
    y1: 38.961,
    transform: "translate(918.548 523.857)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_544",
    "data-name": "Line 544",
    y1: 42.486,
    x2: 3.366,
    transform: "translate(938.58 520.333)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_547",
    "data-name": "Line 547",
    x1: 1.097,
    y2: 43.471,
    transform: "translate(917.451 523.857)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_549",
    "data-name": "Line 549",
    y1: 50.216,
    x2: 19.826,
    transform: "translate(938.58 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_551",
    "data-name": "Line 551",
    y1: 51.09,
    x2: 29.196,
    transform: "translate(929.839 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_553",
    "data-name": "Line 553",
    x1: 21.128,
    y2: 4.51,
    transform: "translate(917.451 562.819)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_554",
    "data-name": "Line 554",
    x1: 19.855,
    y1: 40.56,
    transform: "translate(917.451 567.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_555",
    "data-name": "Line 555",
    x1: 1.273,
    y2: 45.07,
    transform: "translate(937.306 562.819)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_559",
    "data-name": "Line 559",
    y1: 0.824,
    x2: 8.379,
    transform: "translate(937.306 607.064)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_560",
    "data-name": "Line 560",
    x2: 7.106,
    y2: 44.246,
    transform: "translate(938.58 562.819)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_563",
    "data-name": "Line 563",
    x2: 0.63,
    y2: 0.026,
    transform: "translate(958.405 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_564",
    "data-name": "Line 564",
    y1: 47.47,
    x2: 8.518,
    transform: "translate(949.887 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_567",
    "data-name": "Line 567",
    y1: 1.583,
    x2: 9.967,
    transform: "translate(944.177 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_568",
    "data-name": "Line 568",
    x2: 16.838,
    y2: 46.628,
    transform: "translate(937.306 607.889)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_569",
    "data-name": "Line 569",
    x2: 6.87,
    y2: 48.212,
    transform: "translate(937.306 607.889)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_573",
    "data-name": "Line 573",
    x1: 5.673,
    y1: 47.138,
    transform: "translate(923.788 608.239)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_575",
    "data-name": "Line 575",
    x2: 8.459,
    y2: 47.453,
    transform: "translate(945.685 607.064)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_576",
    "data-name": "Line 576",
    x2: 14.304,
    y2: 47.301,
    transform: "translate(939.84 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_579",
    "data-name": "Line 579",
    x1: 18.006,
    y2: 1.882,
    transform: "translate(919.3 607.889)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_580",
    "data-name": "Line 580",
    x2: 24.876,
    y2: 46.33,
    transform: "translate(919.3 609.771)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_583",
    "data-name": "Line 583",
    x1: 2.067,
    y1: 9.362,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 975.876, 546.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_584",
    "data-name": "Line 584",
    y1: 10.419,
    x2: 19.393,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 971.844, 527.924)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_587",
    "data-name": "Line 587",
    y1: 2.902,
    x2: 9.366,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 987.734, 547.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_588",
    "data-name": "Line 588",
    x1: 39.912,
    y2: 6.948,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 991.691, 546.259)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_589",
    "data-name": "Line 589",
    x1: 30.545,
    y2: 4.046,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 993.639, 555.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_593",
    "data-name": "Line 593",
    x1: 0.445,
    y2: 13.034,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 986.473, 591.763)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_594",
    "data-name": "Line 594",
    y1: 10.399,
    x2: 44.471,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 977.32, 548.7)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_595",
    "data-name": "Line 595",
    x2: 44.025,
    y2: 2.635,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 967.148, 550.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_599",
    "data-name": "Line 599",
    y1: 9.189,
    x2: 3.009,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 973.099, 591.53)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_600",
    "data-name": "Line 600",
    y1: 4.227,
    x2: 34.613,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 966.528, 560.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_601",
    "data-name": "Line 601",
    x2: 31.604,
    y2: 4.962,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 962.394, 561.496)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_605",
    "data-name": "Line 605",
    x2: 0.366,
    y2: 2.406,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.735, 647.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_606",
    "data-name": "Line 606",
    x2: 66.108,
    y2: 8.814,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 994.334, 581.59)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_607",
    "data-name": "Line 607",
    x2: 65.742,
    y2: 6.409,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 994.334, 581.59)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_611",
    "data-name": "Line 611",
    y1: 7.081,
    x2: 0.416,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 993.734, 648.809)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_612",
    "data-name": "Line 612",
    y1: 6.309,
    x2: 66.956,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 972.887, 584.788)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_615",
    "data-name": "Line 615",
    x1: 1.437,
    y1: 9.809,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 995.862, 588.754)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_616",
    "data-name": "Line 616",
    x2: 57.514,
    y2: 0.009,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 986.566, 592.199)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_619",
    "data-name": "Line 619",
    x1: 0.067,
    y2: 5.748,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.443, 648.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_620",
    "data-name": "Line 620",
    y1: 5.394,
    x2: 68.755,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 985.163, 580.834)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_623",
    "data-name": "Line 623",
    y1: 0.464,
    x2: 0.391,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 986.727, 649.899)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_624",
    "data-name": "Line 624",
    y1: 10.383,
    x2: 60.317,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 974.267, 591.282)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_627",
    "data-name": "Line 627",
    x2: 2.521,
    y2: 4.756,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.99, 585.299)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_628",
    "data-name": "Line 628",
    x2: 60.939,
    y2: 11.169,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.99, 585.299)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_631",
    "data-name": "Line 631",
    y1: 5.431,
    x2: 0.08,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 992.906, 649.054)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_632",
    "data-name": "Line 632",
    y1: 7.414,
    x2: 57.455,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 980.976, 592.931)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_633",
    "data-name": "Line 633",
    y1: 1.983,
    x2: 57.376,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 975.664, 594.061)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_637",
    "data-name": "Line 637",
    y1: 0.15,
    x2: 6.173,
    transform: "translate(947.971 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_638",
    "data-name": "Line 638",
    x2: 7.03,
    y2: 44.324,
    transform: "translate(954.144 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_639",
    "data-name": "Line 639",
    x2: 13.203,
    y2: 44.175,
    transform: "translate(947.971 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_643",
    "data-name": "Line 643",
    y1: 1.023,
    x2: 7.812,
    transform: "translate(953.363 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_644",
    "data-name": "Line 644",
    x2: 0.819,
    y2: 88.383,
    transform: "translate(961.174 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_645",
    "data-name": "Line 645",
    x2: 8.631,
    y2: 87.36,
    transform: "translate(953.363 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_649",
    "data-name": "Line 649",
    x1: 23.133,
    y2: 2.483,
    transform: "translate(930.23 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_650",
    "data-name": "Line 650",
    x1: 1.979,
    y2: 83.917,
    transform: "translate(951.383 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_651",
    "data-name": "Line 651",
    x1: 21.153,
    y1: 81.433,
    transform: "translate(930.23 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_655",
    "data-name": "Line 655",
    x2: 10.61,
    y2: 3.443,
    transform: "translate(951.383 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_656",
    "data-name": "Line 656",
    y1: 31.617,
    x2: 6.013,
    transform: "translate(955.98 787.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_657",
    "data-name": "Line 657",
    x2: 4.597,
    y2: 35.06,
    transform: "translate(951.383 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_661",
    "data-name": "Line 661",
    y1: 0.017,
    x2: 14.892,
    transform: "translate(922.048 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_662",
    "data-name": "Line 662",
    x2: 20.8,
    y2: 51.298,
    transform: "translate(916.14 770.967)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_663",
    "data-name": "Line 663",
    x2: 5.908,
    y2: 51.314,
    transform: "translate(916.14 770.967)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_667",
    "data-name": "Line 667",
    y1: 14.434,
    x2: 6.022,
    transform: "translate(918.481 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_668",
    "data-name": "Line 668",
    x1: 1.282,
    y1: 10.283,
    transform: "translate(917.199 820.193)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_669",
    "data-name": "Line 669",
    y1: 4.152,
    x2: 7.303,
    transform: "translate(917.199 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_673",
    "data-name": "Line 673",
    x1: 13.716,
    y2: 0.887,
    transform: "translate(936.941 821.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_674",
    "data-name": "Line 674",
    x1: 13.455,
    y1: 16.892,
    transform: "translate(936.941 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_677",
    "data-name": "Line 677",
    x2: 5.643,
    y2: 7.463,
    transform: "translate(918.481 830.476)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_678",
    "data-name": "Line 678",
    x2: 2.076,
    y2: 15.657,
    transform: "translate(922.048 822.282)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_679",
    "data-name": "Line 679",
    y1: 8.194,
    x2: 3.568,
    transform: "translate(918.481 822.282)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_683",
    "data-name": "Line 683",
    x1: 20.107,
    y1: 1.223,
    transform: "translate(920.212 902.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_684",
    "data-name": "Line 684",
    y1: 86.513,
    x2: 4.29,
    transform: "translate(920.212 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_685",
    "data-name": "Line 685",
    x1: 15.817,
    y1: 87.736,
    transform: "translate(924.502 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_689",
    "data-name": "Line 689",
    x1: 12.59,
    y1: 5.391,
    transform: "translate(937.806 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_690",
    "data-name": "Line 690",
    x1: 14.842,
    y1: 68.755,
    transform: "translate(937.806 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_691",
    "data-name": "Line 691",
    x2: 2.252,
    y2: 63.364,
    transform: "translate(950.396 839.157)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_695",
    "data-name": "Line 695",
    x1: 7.139,
    y2: 0.172,
    transform: "translate(916.22 901.5)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_696",
    "data-name": "Line 696",
    y1: 63.561,
    x2: 0.765,
    transform: "translate(923.359 837.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_697",
    "data-name": "Line 697",
    y1: 63.733,
    x2: 7.904,
    transform: "translate(916.22 837.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_701",
    "data-name": "Line 701",
    x2: 0.761,
    y2: 71.352,
    transform: "translate(956.333 832.098)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_702",
    "data-name": "Line 702",
    x2: 6.421,
    y2: 88.009,
    transform: "translate(950.673 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_705",
    "data-name": "Line 705",
    y1: 0.261,
    x2: 14.968,
    transform: "translate(923.359 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_706",
    "data-name": "Line 706",
    x2: 0.521,
    y2: 67.473,
    transform: "translate(937.806 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_707",
    "data-name": "Line 707",
    y1: 67.734,
    x2: 14.447,
    transform: "translate(923.359 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_711",
    "data-name": "Line 711",
    x2: 6.866,
    y2: 0.55,
    transform: "translate(952.648 902.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_712",
    "data-name": "Line 712",
    x2: 9.119,
    y2: 63.914,
    transform: "translate(950.396 839.157)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_715",
    "data-name": "Line 715",
    x1: 7.018,
    y2: 0.635,
    transform: "translate(927.52 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_716",
    "data-name": "Line 716",
    y1: 89.144,
    x2: 3.79,
    transform: "translate(934.537 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_717",
    "data-name": "Line 717",
    y1: 89.778,
    x2: 10.808,
    transform: "translate(927.52 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_721",
    "data-name": "Line 721",
    y1: 0.378,
    x2: 2.42,
    transform: "translate(957.094 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_722",
    "data-name": "Line 722",
    y1: 87.832,
    x2: 15.191,
    transform: "translate(944.324 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_723",
    "data-name": "Line 723",
    y1: 87.454,
    x2: 12.77,
    transform: "translate(944.324 903.45)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_727",
    "data-name": "Line 727",
    x1: 14.321,
    y1: 1.282,
    transform: "translate(938.327 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_728",
    "data-name": "Line 728",
    x2: 3.921,
    y2: 89.539,
    transform: "translate(938.327 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_729",
    "data-name": "Line 729",
    x1: 10.4,
    y2: 88.257,
    transform: "translate(942.248 902.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_733",
    "data-name": "Line 733",
    y1: 0.227,
    x2: 0.874,
    transform: "translate(944.324 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_734",
    "data-name": "Line 734",
    x2: 4.013,
    y2: 18.842,
    transform: "translate(945.198 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    x2: 4.887,
    y2: 18.615,
    transform: "translate(944.324 990.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_739",
    "data-name": "Line 739",
    x1: 6.328,
    y1: 15.909,
    transform: "translate(949.211 1009.52)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_740",
    "data-name": "Line 740",
    x1: 1.979,
    y1: 7.358,
    transform: "translate(949.211 1009.52)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_743",
    "data-name": "Line 743",
    x1: 14.308,
    y1: 1.013,
    transform: "translate(935.012 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_744",
    "data-name": "Line 744",
    x1: 4.026,
    y2: 24.792,
    transform: "translate(945.294 1011.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_747",
    "data-name": "Line 747",
    x2: 5.925,
    y2: 4.038,
    transform: "translate(943.286 1005.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_748",
    "data-name": "Line 748",
    x1: 1.912,
    y2: 14.804,
    transform: "translate(943.286 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_751",
    "data-name": "Line 751",
    x2: 7.711,
    y2: 0.395,
    transform: "translate(934.537 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_752",
    "data-name": "Line 752",
    x2: 8.749,
    y2: 15.098,
    transform: "translate(934.537 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_753",
    "data-name": "Line 753",
    x2: 1.038,
    y2: 14.703,
    transform: "translate(942.248 990.778)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_757",
    "data-name": "Line 757",
    x2: 0.353,
    y2: 8.522,
    transform: "translate(925.238 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_758",
    "data-name": "Line 758",
    x1: 3.152,
    y2: 16.447,
    transform: "translate(922.086 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_759",
    "data-name": "Line 759",
    x1: 3.505,
    y2: 7.925,
    transform: "translate(922.086 1016.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_763",
    "data-name": "Line 763",
    x1: 2.202,
    y2: 2.425,
    transform: "translate(923.036 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_764",
    "data-name": "Line 764",
    x1: 1.454,
    y2: 20.065,
    transform: "translate(923.036 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_767",
    "data-name": "Line 767",
    x1: 9.446,
    y2: 3.475,
    transform: "translate(925.591 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_768",
    "data-name": "Line 768",
    x2: 9.799,
    y2: 5.047,
    transform: "translate(925.238 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_771",
    "data-name": "Line 771",
    y1: 3.408,
    x2: 9.846,
    transform: "translate(925.238 1005.006)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_772",
    "data-name": "Line 772",
    x2: 7.564,
    y2: 13.989,
    transform: "translate(927.52 991.018)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_775",
    "data-name": "Line 775",
    x1: 0.95,
    y2: 14.022,
    transform: "translate(922.086 1010.839)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_776",
    "data-name": "Line 776",
    y1: 25.469,
    x2: 0.282,
    transform: "translate(922.754 1010.839)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_777",
    "data-name": "Line 777",
    x1: 0.668,
    y1: 11.447,
    transform: "translate(922.086 1024.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_781",
    "data-name": "Line 781",
    y1: 0.025,
    x2: 9.392,
    transform: "translate(945.294 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_782",
    "data-name": "Line 782",
    x1: 10.245,
    y2: 10.879,
    transform: "translate(945.294 1025.429)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_783",
    "data-name": "Line 783",
    x1: 0.853,
    y2: 10.854,
    transform: "translate(954.686 1025.429)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_787",
    "data-name": "Line 787",
    x1: 3.988,
    y2: 10.539,
    transform: "translate(954.686 1025.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_789",
    "data-name": "Line 789",
    x1: 16.153,
    y1: 3.416,
    transform: "translate(935.037 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_790",
    "data-name": "Line 790",
    x1: 7.904,
    y1: 11.396,
    transform: "translate(943.286 1005.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_793",
    "data-name": "Line 793",
    x2: 22.54,
    transform: "translate(922.754 1036.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_794",
    "data-name": "Line 794",
    y1: 0.025,
    x2: 31.932,
    transform: "translate(922.754 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_797",
    "data-name": "Line 797",
    y1: 11.32,
    x2: 0.214,
    transform: "translate(946.807 1024.962)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_798",
    "data-name": "Line 798",
    y1: 0.639,
    x2: 21.843,
    transform: "translate(925.179 1024.962)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_801",
    "data-name": "Line 801",
    x2: 0.13,
    y2: 10.539,
    transform: "translate(958.674 1025.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_802",
    "data-name": "Line 802",
    x1: 11.867,
    y2: 10.539,
    transform: "translate(946.807 1025.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_803",
    "data-name": "Line 803",
    x2: 11.997,
    transform: "translate(946.807 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_807",
    "data-name": "Line 807",
    y1: 9.625,
    x2: 9.001,
    transform: "translate(906.933 439.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_809",
    "data-name": "Line 809",
    x1: 11.081,
    y2: 1.281,
    transform: "translate(909.161 394.395)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_811",
    "data-name": "Line 811",
    y1: 3.775,
    x2: 7.929,
    transform: "translate(908.005 439.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_812",
    "data-name": "Line 812",
    x1: 1.244,
    y2: 19.892,
    transform: "translate(915.934 419.694)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_813",
    "data-name": "Line 813",
    y1: 23.667,
    x2: 9.173,
    transform: "translate(908.005 419.694)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_817",
    "data-name": "Line 817",
    x1: 7.018,
    y2: 1.101,
    transform: "translate(917.178 418.593)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_818",
    "data-name": "Line 818",
    x1: 8.261,
    y2: 20.992,
    transform: "translate(915.934 418.593)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_821",
    "data-name": "Line 821",
    y1: 0.908,
    x2: 2.236,
    transform: "translate(924.196 417.685)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_823",
    "data-name": "Line 823",
    y1: 6.314,
    x2: 4.021,
    transform: "translate(925.36 410.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_825",
    "data-name": "Line 825",
    x1: 3.345,
    y2: 17.149,
    transform: "translate(920.851 418.593)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_826",
    "data-name": "Line 826",
    x1: 5.58,
    y2: 18.057,
    transform: "translate(920.851 417.685)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_829",
    "data-name": "Line 829",
    y1: 0.483,
    x2: 0.828,
    transform: "translate(928.247 392.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_831",
    "data-name": "Line 831",
    x1: 3.589,
    y1: 1.177,
    transform: "translate(921.771 415.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_832",
    "data-name": "Line 832",
    x1: 2.79,
    y2: 23.158,
    transform: "translate(921.771 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_835",
    "data-name": "Line 835",
    x2: 16.455,
    y2: 6.818,
    transform: "translate(915.354 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_836",
    "data-name": "Line 836",
    x1: 0.987,
    y2: 2.884,
    transform: "translate(930.822 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_839",
    "data-name": "Line 839",
    x2: 30.1,
    y2: 12.443,
    transform: "translate(938.781 488.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_841",
    "data-name": "Line 841",
    y1: 2.746,
    x2: 11.308,
    transform: "translate(938.58 560.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_843",
    "data-name": "Line 843",
    y1: 0.914,
    x2: 19.805,
    transform: "translate(924.372 656.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_845",
    "data-name": "Line 845",
    x2: 15.649,
    y2: 1.737,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 974.321, 531.225)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_846",
    "data-name": "Line 846",
    x1: 3.744,
    y2: 12.155,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 973.542, 527.563)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_849",
    "data-name": "Line 849",
    y1: 6.917,
    x2: 18.317,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 981.087, 529.787)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_851",
    "data-name": "Line 851",
    x1: 46.538,
    y2: 1.037,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 976.89, 546.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_853",
    "data-name": "Line 853",
    x1: 7.169,
    y1: 4.637,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 989.682, 556.262)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_855",
    "data-name": "Line 855",
    x2: 57.01,
    y2: 5.62,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 986.566, 592.199)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_856",
    "data-name": "Line 856",
    x1: 0.504,
    y2: 5.611,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.41, 647.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_859",
    "data-name": "Line 859",
    x2: 6.639,
    y2: 4.074,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 966.715, 586.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_861",
    "data-name": "Line 861",
    x2: 5.391,
    y2: 45.197,
    transform: "translate(947.971 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_863",
    "data-name": "Line 863",
    x2: 0.273,
    y2: 0.08,
    transform: "translate(929.957 702.267)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_864",
    "data-name": "Line 864",
    y1: 2.403,
    x2: 23.406,
    transform: "translate(929.957 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_867",
    "data-name": "Line 867",
    x1: 18.863,
    y1: 6.774,
    transform: "translate(932.52 777.007)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_869",
    "data-name": "Line 869",
    x1: 32.936,
    y2: 2.021,
    transform: "translate(897.021 702.267)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_871",
    "data-name": "Line 871",
    x2: 8.963,
    y2: 52.137,
    transform: "translate(924.372 657.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_872",
    "data-name": "Line 872",
    x1: 16.342,
    y2: 56.338,
    transform: "translate(908.03 657.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_873",
    "data-name": "Line 873",
    y1: 4.201,
    x2: 25.305,
    transform: "translate(908.03 709.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_877",
    "data-name": "Line 877",
    x1: 0.71,
    y2: 31.66,
    transform: "translate(950.673 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_879",
    "data-name": "Line 879",
    x2: 1.387,
    y2: 45.114,
    transform: "translate(935.554 777.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_880",
    "data-name": "Line 880",
    x2: 19.414,
    y2: 6.184,
    transform: "translate(916.14 770.967)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_883",
    "data-name": "Line 883",
    x1: 7.446,
    y1: 1.825,
    transform: "translate(908.694 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_885",
    "data-name": "Line 885",
    x2: 0.866,
    y2: 11.501,
    transform: "translate(936.941 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_887",
    "data-name": "Line 887",
    x1: 14.207,
    y2: 3.252,
    transform: "translate(924.502 812.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_889",
    "data-name": "Line 889",
    y1: 0.328,
    x2: 16.775,
    transform: "translate(940.319 903.45)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_891",
    "data-name": "Line 891",
    x2: 3.181,
    y2: 70.974,
    transform: "translate(956.333 832.098)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_893",
    "data-name": "Line 893",
    y1: 4.173,
    x2: 13.682,
    transform: "translate(924.125 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_895",
    "data-name": "Line 895",
    x2: 4.16,
    y2: 89.518,
    transform: "translate(923.359 901.5)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_897",
    "data-name": "Line 897",
    y1: 87.606,
    x2: 14.317,
    transform: "translate(945.198 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_899",
    "data-name": "Line 899",
    y1: 25.805,
    x2: 12.258,
    transform: "translate(922.754 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_901",
    "data-name": "Line 901",
    x1: 0.109,
    y1: 1.996,
    transform: "translate(949.211 1009.52)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_903",
    "data-name": "Line 903",
    x1: 0.597,
    y2: 19.54,
    transform: "translate(935.012 990.963)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_905",
    "data-name": "Line 905",
    x2: 12.089,
    y2: 0.029,
    transform: "translate(922.754 1036.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_907",
    "data-name": "Line 907",
    x1: 2.95,
    y2: 0.101,
    transform: "translate(942.248 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_909",
    "data-name": "Line 909",
    x2: 0.546,
    y2: 14.623,
    transform: "translate(934.537 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_911",
    "data-name": "Line 911",
    x1: 10.329,
    y2: 0.235,
    transform: "translate(925.28 990.963)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_913",
    "data-name": "Line 913",
    x1: 1.588,
    y1: 11.421,
    transform: "translate(922.086 1024.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_914",
    "data-name": "Line 914",
    x1: 0.92,
    y2: 0.025,
    transform: "translate(922.754 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_917",
    "data-name": "Line 917",
    x2: 6.219,
    y2: 13.913,
    transform: "translate(949.32 1011.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_919",
    "data-name": "Line 919",
    x1: 4.168,
    y2: 8.085,
    transform: "translate(947.021 1016.877)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_920",
    "data-name": "Line 920",
    x1: 11.652,
    y1: 0.782,
    transform: "translate(947.021 1024.962)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_923",
    "data-name": "Line 923",
    y1: 12.14,
    x2: 9.858,
    transform: "translate(925.179 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_924",
    "data-name": "Line 924",
    x2: 11.984,
    y2: 11.501,
    transform: "translate(935.037 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_927",
    "data-name": "Line 927",
    x1: 3.093,
    y1: 0.74,
    transform: "translate(922.086 1024.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_928",
    "data-name": "Line 928",
    y1: 8.665,
    x2: 0.412,
    transform: "translate(925.179 1016.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_931",
    "data-name": "Line 931",
    x2: 4.118,
    transform: "translate(954.686 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_933",
    "data-name": "Line 933",
    x2: 33.814,
    transform: "translate(924.99 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_935",
    "data-name": "Line 935",
    x2: 31.012,
    transform: "translate(923.674 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_937",
    "data-name": "Line 937",
    x1: 3.063,
    y2: 25.299,
    transform: "translate(917.178 394.395)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_939",
    "data-name": "Line 939",
    y1: 1.024,
    x2: 0.097,
    transform: "translate(923.998 375.571)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_941",
    "data-name": "Line 941",
    x2: 0.79,
    y2: 0.424,
    transform: "translate(924.49 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_943",
    "data-name": "Line 943",
    x1: 1.13,
    y1: 22.243,
    transform: "translate(906.875 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_945",
    "data-name": "Line 945",
    x2: 3.189,
    y2: 1.224,
    transform: "translate(911.888 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_947",
    "data-name": "Line 947",
    y1: 15.76,
    x2: 3.189,
    transform: "translate(918.582 415.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_949",
    "data-name": "Line 949",
    x2: 1.072,
    y2: 0.711,
    transform: "translate(925.36 416.974)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_951",
    "data-name": "Line 951",
    x1: 4.509,
    y2: 18.768,
    transform: "translate(920.851 416.974)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_953",
    "data-name": "Line 953",
    y1: 14.583,
    x2: 6.778,
    transform: "translate(918.582 416.974)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_955",
    "data-name": "Line 955",
    x2: 35.13,
    transform: "translate(923.674 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_957",
    "data-name": "Line 957",
    y1: 4.32,
    x2: 31.352,
    transform: "translate(938.781 484.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_958",
    "data-name": "Line 958",
    x2: 38.323,
    y2: 19.656,
    transform: "translate(931.81 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_961",
    "data-name": "Line 961",
    x2: 20.901,
    y2: 4.235,
    transform: "translate(931.81 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_962",
    "data-name": "Line 962",
    x2: 17.422,
    y2: 15.421,
    transform: "translate(952.711 469.255)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_965",
    "data-name": "Line 965",
    x1: 3.336,
    y2: 2.955,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 997.053, 674.038)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_966",
    "data-name": "Line 966",
    x1: 8.144,
    y2: 9.474,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.43, 672.683)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_967",
    "data-name": "Line 967",
    y1: 6.519,
    x2: 4.807,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.124, 675.946)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_971",
    "data-name": "Line 971",
    x1: 1.752,
    y2: 2.366,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.061, 676.81)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_972",
    "data-name": "Line 972",
    y1: 8.836,
    x2: 7.013,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.39, 675.464)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_973",
    "data-name": "Line 973",
    y1: 6.47,
    x2: 5.261,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.754, 677.179)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_977",
    "data-name": "Line 977",
    y1: 8.046,
    x2: 6.614,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.295, 676.851)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_978",
    "data-name": "Line 978",
    x1: 6.538,
    y2: 6.649,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.311, 676.925)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_979",
    "data-name": "Line 979",
    y1: 1.396,
    x2: 0.076,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.791, 678.233)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_983",
    "data-name": "Line 983",
    x1: 30.848,
    y2: 7.912,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 994.011, 648.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_984",
    "data-name": "Line 984",
    x1: 29.095,
    y2: 5.546,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 991.698, 648.842)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_987",
    "data-name": "Line 987",
    x1: 13.854,
    y2: 7.143,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.926, 664.756)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_988",
    "data-name": "Line 988",
    x1: 16.611,
    y2: 0.913,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 988.485, 649.993)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_989",
    "data-name": "Line 989",
    x1: 30.465,
    y2: 8.056,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 995.473, 648.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_993",
    "data-name": "Line 993",
    x1: 19.657,
    y2: 5.455,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.257, 647.997)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_994",
    "data-name": "Line 994",
    x1: 16.531,
    y1: 4.519,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 992.922, 649.131)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_995",
    "data-name": "Line 995",
    x1: 3.126,
    y2: 9.973,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.695, 664.167)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_999",
    "data-name": "Line 999",
    y1: 5.098,
    x2: 4.643,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.15, 673.592)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1000",
    "data-name": "Line 1000",
    x1: 25.368,
    y2: 2.127,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 988.888, 649.839)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1001",
    "data-name": "Line 1001",
    x1: 30.011,
    y2: 7.226,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 993.875, 648.779)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1005",
    "data-name": "Line 1005",
    x1: 29.595,
    y2: 0.144,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 993.961, 649.186)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1007",
    "data-name": "Line 1007",
    x1: 28.705,
    y2: 5.082,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 991.779, 649.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1009",
    "data-name": "Line 1009",
    x1: 30.39,
    y2: 6.66,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 994.107, 648.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1011",
    "data-name": "Line 1011",
    x1: 11.413,
    y1: 1.394,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.344, 667.226)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1012",
    "data-name": "Line 1012",
    x1: 14.539,
    y2: 8.579,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.332, 664.457)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1015",
    "data-name": "Line 1015",
    x2: 19.834,
    y2: 1.15,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.331, 680.252)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1016",
    "data-name": "Line 1016",
    y1: 6.956,
    x2: 3.467,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.611, 676.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1017",
    "data-name": "Line 1017",
    y1: 5.806,
    x2: 23.301,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.486, 677.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1021",
    "data-name": "Line 1021",
    y1: 4.248,
    x2: 22.343,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.961, 677.424)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1022",
    "data-name": "Line 1022",
    x2: 15.804,
    y2: 2.402,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.67, 683.321)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1025",
    "data-name": "Line 1025",
    x2: 16.762,
    y2: 0.843,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.67, 683.321)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1026",
    "data-name": "Line 1026",
    x1: 3.072,
    y1: 0.306,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.331, 680.252)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1029",
    "data-name": "Line 1029",
    y1: 4.62,
    x2: 22.09,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.681, 673.692)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1030",
    "data-name": "Line 1030",
    x2: 17.447,
    y2: 0.479,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.115, 678.134)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1033",
    "data-name": "Line 1033",
    x2: 15.018,
    y2: 2.167,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.123, 680.648)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    y1: 7.307,
    x2: 23.162,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.31, 673.133)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1037",
    "data-name": "Line 1037",
    x2: 17.498,
    y2: 2.628,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.848, 682.324)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1038",
    "data-name": "Line 1038",
    y1: 6.208,
    x2: 24.511,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.819, 676.011)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1041",
    "data-name": "Line 1041",
    y1: 4.253,
    x2: 23.519,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.907, 676.417)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1042",
    "data-name": "Line 1042",
    x2: 18.712,
    y2: 2.266,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.123, 680.648)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1045",
    "data-name": "Line 1045",
    x2: 19.078,
    y2: 0.9,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.848, 682.324)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1046",
    "data-name": "Line 1046",
    y1: 1.575,
    x2: 1.353,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.389, 681.997)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1047",
    "data-name": "Line 1047",
    x2: 17.724,
    y2: 2.475,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.67, 683.321)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1051",
    "data-name": "Line 1051",
    y1: 4.223,
    x2: 23.364,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.555, 677.646)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1052",
    "data-name": "Line 1052",
    x2: 18.103,
    y2: 2.248,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.848, 682.324)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1055",
    "data-name": "Line 1055",
    y1: 5.571,
    x2: 24.339,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.875, 677.365)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1057",
    "data-name": "Line 1057",
    x1: 35.6,
    y1: 1.317,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.735, 647.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1058",
    "data-name": "Line 1058",
    x1: 36.953,
    y2: 0.258,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.987, 647.175)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1061",
    "data-name": "Line 1061",
    x1: 33.029,
    y1: 1.228,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.457, 648.086)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1062",
    "data-name": "Line 1062",
    x1: 33.394,
    y1: 3.634,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.735, 647.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    "data-name": "Line 1065",
    x1: 2.206,
    y2: 2.317,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.389, 680.166)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1067",
    "data-name": "Line 1067",
    x1: 29.528,
    y1: 5.604,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.457, 648.086)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1069",
    "data-name": "Line 1069",
    x1: 3.5,
    y2: 4.376,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.395, 677.225)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1071",
    "data-name": "Line 1071",
    x1: 33.882,
    y2: 0.565,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.287, 647.111)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1073",
    "data-name": "Line 1073",
    y1: 4.126,
    x2: 14.195,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.38, 666.368)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1074",
    "data-name": "Line 1074",
    x1: 19.687,
    y1: 3.561,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.735, 647.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1077",
    "data-name": "Line 1077",
    y1: 5.519,
    x2: 2.782,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.752, 677.531)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1079",
    "data-name": "Line 1079",
    x1: 19.153,
    y1: 0.156,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.515, 648.458)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1081",
    "data-name": "Line 1081",
    x2: 8.455,
    y2: 45.36,
    transform: "translate(916.048 770.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1082",
    "data-name": "Line 1082",
    x1: 8.018,
    y2: 39.035,
    transform: "translate(924.502 777.007)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1085",
    "data-name": "Line 1085",
    x1: 6.19,
    y1: 35.783,
    transform: "translate(932.52 777.007)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1087",
    "data-name": "Line 1087",
    x1: 12.674,
    y2: 29.009,
    transform: "translate(938.709 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1089",
    "data-name": "Line 1089",
    y1: 34.155,
    x2: 11.337,
    transform: "translate(950.656 787.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1091",
    "data-name": "Line 1091",
    x2: 7.644,
    y2: 3.384,
    transform: "translate(954.35 783.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1092",
    "data-name": "Line 1092",
    y1: 37.538,
    x2: 3.694,
    transform: "translate(950.656 783.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1095",
    "data-name": "Line 1095",
    x2: 18.796,
    y2: 6.689,
    transform: "translate(935.554 777.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1096",
    "data-name": "Line 1096",
    x1: 17.409,
    y2: 38.425,
    transform: "translate(936.941 783.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1099",
    "data-name": "Line 1099",
    x1: 17.266,
    y2: 87.706,
    transform: "translate(942.248 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1101",
    "data-name": "Line 1101",
    x1: 4.711,
    y2: 87.185,
    transform: "translate(935.608 903.778)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1102",
    "data-name": "Line 1102",
    y1: 87.513,
    x2: 21.485,
    transform: "translate(935.608 903.45)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1105",
    "data-name": "Line 1105",
    x2: 5.068,
    y2: 88.643,
    transform: "translate(920.212 902.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1106",
    "data-name": "Line 1106",
    x2: 15.397,
    y2: 88.408,
    transform: "translate(920.212 902.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1109",
    "data-name": "Line 1109",
    x2: 9.06,
    y2: 89.526,
    transform: "translate(916.22 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1111",
    "data-name": "Line 1111",
    x2: 8.27,
    y2: 89.101,
    transform: "translate(916.22 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1113",
    "data-name": "Line 1113",
    x2: 11.299,
    y2: 89.345,
    transform: "translate(916.22 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1115",
    "data-name": "Line 1115",
    x1: 2.702,
    y1: 17.205,
    transform: "translate(923.998 376.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1117",
    "data-name": "Line 1117",
    x2: 4.248,
    y2: 16.836,
    transform: "translate(923.998 376.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1119",
    "data-name": "Line 1119",
    x1: 6.11,
    y1: 22.925,
    transform: "translate(915.661 392.872)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1121",
    "data-name": "Line 1121",
    x1: 8.9,
    y2: 0.233,
    transform: "translate(915.661 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1123",
    "data-name": "Line 1123",
    x1: 4.152,
    y1: 17.86,
    transform: "translate(924.095 375.571)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1125",
    "data-name": "Line 1125",
    x1: 4.979,
    y1: 17.377,
    transform: "translate(924.095 375.571)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1127",
    "data-name": "Line 1127",
    x1: 6.328,
    y1: 18.786,
    transform: "translate(922.746 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1129",
    "data-name": "Line 1129",
    x2: 4.253,
    y2: 79.105,
    transform: "translate(950.098 704.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1130",
    "data-name": "Line 1130",
    x1: 14.543,
    y2: 72.416,
    transform: "translate(935.554 704.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1133",
    "data-name": "Line 1133",
    x1: 16.762,
    y2: 4.415,
    transform: "translate(933.335 704.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1134",
    "data-name": "Line 1134",
    x2: 2.219,
    y2: 68.001,
    transform: "translate(933.335 709.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1137",
    "data-name": "Line 1137",
    x1: 6.824,
    y2: 84.999,
    transform: "translate(954.35 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1139",
    "data-name": "Line 1139",
    y1: 5.894,
    x2: 11.077,
    transform: "translate(950.098 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1141",
    "data-name": "Line 1141",
    x1: 5.921,
    y1: 48.635,
    transform: "translate(944.177 656.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1142",
    "data-name": "Line 1142",
    y1: 50.219,
    x2: 4.047,
    transform: "translate(950.098 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1145",
    "data-name": "Line 1145",
    x1: 10.841,
    y2: 53.05,
    transform: "translate(933.335 656.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1147",
    "data-name": "Line 1147",
    x1: 4.568,
    y1: 0.735,
    transform: "translate(897.021 713.37)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1148",
    "data-name": "Line 1148",
    x1: 6.442,
    y2: 0.753,
    transform: "translate(901.588 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1149",
    "data-name": "Line 1149",
    x1: 11.01,
    y2: 0.018,
    transform: "translate(897.021 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1153",
    "data-name": "Line 1153",
    y2: 55.734,
    transform: "translate(897.021 657.636)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1154",
    "data-name": "Line 1154",
    x1: 11.01,
    y1: 55.716,
    transform: "translate(897.021 657.636)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1156",
    "data-name": "Line 1156",
    x2: 0.496,
    y2: 46.891,
    transform: "translate(929.461 655.376)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1157",
    "data-name": "Line 1157",
    x1: 32.44,
    y2: 48.912,
    transform: "translate(897.021 655.376)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1160",
    "data-name": "Line 1160",
    y2: 48.605,
    transform: "translate(897.021 655.683)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1161",
    "data-name": "Line 1161",
    x1: 12.816,
    y2: 15.674,
    transform: "translate(924.125 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1163",
    "data-name": "Line 1163",
    y1: 1.712,
    x2: 37.613,
    transform: "translate(912.619 470.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1165",
    "data-name": "Line 1165",
    x2: 19.41,
    y2: 2.557,
    transform: "translate(930.822 467.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1167",
    "data-name": "Line 1167",
    x1: 1.252,
    y2: 16.763,
    transform: "translate(968.881 484.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1169",
    "data-name": "Line 1169",
    y1: 0.665,
    x2: 64.208,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 960.971, 468.42)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1170",
    "data-name": "Line 1170",
    x2: 60.464,
    y2: 11.49,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 960.321, 468.558)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1173",
    "data-name": "Line 1173",
    y1: 1.206,
    x2: 2.479,
    transform: "translate(950.232 469.255)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1174",
    "data-name": "Line 1174",
    x2: 18.422,
    y2: 5.441,
    transform: "translate(931.81 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1177",
    "data-name": "Line 1177",
    x1: 60.914,
    y2: 14.658,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 948.988, 470.507)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1189",
    "data-name": "Line 1189",
    x2: 7.106,
    y2: 55.038,
    transform: "translate(901.588 714.104)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1190",
    "data-name": "Line 1190",
    x2: 0.664,
    y2: 55.79,
    transform: "translate(908.03 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1193",
    "data-name": "Line 1193",
    x2: 8.11,
    y2: 57.616,
    transform: "translate(908.03 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1195",
    "data-name": "Line 1195",
    y1: 0.223,
    x2: 1.672,
    transform: "translate(901.588 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1196",
    "data-name": "Line 1196",
    x1: 5.433,
    y1: 55.26,
    transform: "translate(903.261 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1199",
    "data-name": "Line 1199",
    x2: 7.354,
    y2: 1.54,
    transform: "translate(908.694 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1201",
    "data-name": "Line 1201",
    x2: 1.151,
    y2: 49.511,
    transform: "translate(916.048 770.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1203",
    "data-name": "Line 1203",
    x2: 55.72,
    y2: 3.959,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 978.924, 508.913)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1205",
    "data-name": "Line 1205",
    x1: 49.824,
    y1: 8.16,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 984.259, 513.806)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1210",
    "data-name": "Line 1210",
    x2: 61.107,
    y2: 15.713,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 978.924, 508.913)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1213",
    "data-name": "Line 1213",
    x1: 5.53,
    y1: 12.176,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 985.082, 523.284)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1214",
    "data-name": "Line 1214",
    x2: 23.847,
    y2: 5.259,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 985.082, 523.284)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1217",
    "data-name": "Line 1217",
    x2: 16.754,
    y2: 4.079,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 967.222, 568.863)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1218",
    "data-name": "Line 1218",
    x2: 11.854,
    y2: 12.277,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 976.26, 571.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1221",
    "data-name": "Line 1221",
    x2: 23.393,
    y2: 8.153,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 967.222, 568.863)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1223",
    "data-name": "Line 1223",
    x2: 27.524,
    y2: 63.799,
    transform: "translate(908.03 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1225",
    "data-name": "Line 1225",
    y1: 47.601,
    x2: 18.014,
    transform: "translate(929.957 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1227",
    "data-name": "Line 1227",
    x1: 6.24,
    y1: 0.512,
    transform: "translate(897.021 713.37)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1229",
    "data-name": "Line 1229",
    y2: 9.082,
    transform: "translate(897.021 704.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M0,0,9.492,9.824",
    transform: "translate(971.806 467.762)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1236",
    "data-name": "Line 1236",
    y1: 6.23,
    x2: 13.859,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.033, 664.946)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1237",
    "data-name": "Line 1237",
    x2: 0.004,
    y2: 0.914,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.806, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1240",
    "data-name": "Line 1240",
    x1: 3.463,
    y2: 7.869,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.611, 676.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1242",
    "data-name": "Line 1242",
    x1: 0.387,
    y2: 0.857,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.417, 728.944)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1243",
    "data-name": "Line 1243",
    y1: 3.66,
    x2: 5.459,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.363, 723.983)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1244",
    "data-name": "Line 1244",
    y1: 2.803,
    x2: 5.072,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.524, 724.161)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1248",
    "data-name": "Line 1248",
    y1: 0.847,
    x2: 0.382,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.253, 726.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1249",
    "data-name": "Line 1249",
    y1: 3.658,
    x2: 5.467,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.196, 721.543)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1250",
    "data-name": "Line 1250",
    y1: 2.811,
    x2: 5.085,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.368, 721.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1254",
    "data-name": "Line 1254",
    y1: 2.601,
    x2: 4.177,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.267, 716.946)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1255",
    "data-name": "Line 1255",
    y1: 1.672,
    x2: 1.319,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.77, 720.685)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1256",
    "data-name": "Line 1256",
    y1: 4.272,
    x2: 5.496,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.902, 716.599)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1260",
    "data-name": "Line 1260",
    y1: 0.949,
    x2: 0.429,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.803, 725.947)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1261",
    "data-name": "Line 1261",
    y1: 3.937,
    x2: 5.627,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.723, 720.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1262",
    "data-name": "Line 1262",
    y1: 2.988,
    x2: 5.198,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.794, 721.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1266",
    "data-name": "Line 1266",
    y1: 7.769,
    x2: 4.446,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1011.406, 695.543)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1267",
    "data-name": "Line 1267",
    x1: 18.855,
    y1: 1.963,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.806, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1270",
    "data-name": "Line 1270",
    y1: 6.211,
    x2: 3.488,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.881, 695.867)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1272",
    "data-name": "Line 1272",
    y1: 1.558,
    x2: 0.958,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1012.131, 698.954)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1274",
    "data-name": "Line 1274",
    x1: 3.307,
    y2: 5.511,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.586, 692.065)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1275",
    "data-name": "Line 1275",
    x2: 18.783,
    y2: 0.891,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 994.163, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1278",
    "data-name": "Line 1278",
    x1: 4.379,
    y2: 8.198,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.215, 691.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1280",
    "data-name": "Line 1280",
    y1: 8.031,
    x2: 4.387,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.003, 695.695)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1281",
    "data-name": "Line 1281",
    x1: 20.124,
    y1: 1.823,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 997.747, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1284",
    "data-name": "Line 1284",
    y1: 6.076,
    x2: 3.395,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.091, 696.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1286",
    "data-name": "Line 1286",
    x1: 0.975,
    y2: 1.348,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.732, 700.219)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1288",
    "data-name": "Line 1288",
    x1: 3.387,
    y2: 5.941,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.708, 697.186)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1289",
    "data-name": "Line 1289",
    x2: 19.977,
    y2: 1.718,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.425, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1292",
    "data-name": "Line 1292",
    x1: 4.362,
    y2: 7.289,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.028, 696.906)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1294",
    "data-name": "Line 1294",
    x1: 11.169,
    y1: 3.991,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.364, 712.989)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1295",
    "data-name": "Line 1295",
    x1: 16.628,
    y1: 0.331,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.364, 712.989)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1298",
    "data-name": "Line 1298",
    x1: 12.703,
    y1: 5.708,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.439, 715.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1299",
    "data-name": "Line 1299",
    y1: 5.377,
    x2: 3.925,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.624, 711.871)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1302",
    "data-name": "Line 1302",
    x1: 14.346,
    y1: 2.573,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.898, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1303",
    "data-name": "Line 1303",
    y1: 2.804,
    x2: 18.271,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.641, 697.838)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1306",
    "data-name": "Line 1306",
    x2: 13.909,
    y2: 4.485,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.934, 701.172)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1308",
    "data-name": "Line 1308",
    x1: 16.241,
    y1: 1.188,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.364, 712.989)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1309",
    "data-name": "Line 1309",
    y1: 4.234,
    x2: 3.248,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.506, 712.108)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1310",
    "data-name": "Line 1310",
    x1: 12.993,
    y1: 5.422,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.181, 715.285)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1314",
    "data-name": "Line 1314",
    y1: 1.662,
    x2: 17.594,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.523, 698.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1316",
    "data-name": "Line 1316",
    x2: 14.207,
    y2: 4.279,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.414, 700.499)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1318",
    "data-name": "Line 1318",
    x1: 13.38,
    y1: 4.565,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.181, 715.285)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1320",
    "data-name": "Line 1320",
    x1: 0.677,
    y2: 1.143,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.298, 715.048)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1322",
    "data-name": "Line 1322",
    x1: 12.816,
    y1: 4.207,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.783, 713.48)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1323",
    "data-name": "Line 1323",
    x1: 12.434,
    y1: 5.053,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.783, 713.48)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1326",
    "data-name": "Line 1326",
    x1: 12.089,
    y1: 5.642,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.337, 713.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1327",
    "data-name": "Line 1327",
    y1: 1.435,
    x2: 0.727,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.186, 713.181)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1330",
    "data-name": "Line 1330",
    x1: 15.703,
    y1: 0.748,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.892, 711.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1331",
    "data-name": "Line 1331",
    y1: 4.305,
    x2: 3.269,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.103, 710.282)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1334",
    "data-name": "Line 1334",
    y1: 2.161,
    x2: 16.934,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.261, 696.915)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1335",
    "data-name": "Line 1335",
    x2: 13.665,
    y2: 2.144,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.148, 697.364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1338",
    "data-name": "Line 1338",
    x1: 10.619,
    y1: 3.559,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.892, 711.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1340",
    "data-name": "Line 1340",
    x2: 13.539,
    y2: 3.915,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.797, 699.422)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1342",
    "data-name": "Line 1342",
    x1: 16.086,
    y2: 0.098,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.988, 711.157)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1344",
    "data-name": "Line 1344",
    y1: 5.74,
    x2: 3.996,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.506, 709.983)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1346",
    "data-name": "Line 1346",
    y1: 3.597,
    x2: 17.661,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.666, 696.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1348",
    "data-name": "Line 1348",
    x2: 13.274,
    y2: 4.434,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.916, 699.987)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1350",
    "data-name": "Line 1350",
    x1: 10.404,
    y1: 3.151,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.641, 706.655)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1351",
    "data-name": "Line 1351",
    x1: 15.901,
    y2: 1.122,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.739, 706.422)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1354",
    "data-name": "Line 1354",
    x1: 11.892,
    y1: 4.907,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.372, 709.323)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1355",
    "data-name": "Line 1355",
    x1: 4.009,
    y2: 6.029,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.539, 705.401)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1358",
    "data-name": "Line 1358",
    x1: 17.46,
    y2: 4.647,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1001.742, 692.244)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1359",
    "data-name": "Line 1359",
    x2: 13.451,
    y2: 1.382,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 997.197, 693.21)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1362",
    "data-name": "Line 1362",
    x2: 13.081,
    y2: 3.551,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.125, 695.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1364",
    "data-name": "Line 1364",
    x1: 14.581,
    y1: 0.55,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 998.641, 706.655)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1365",
    "data-name": "Line 1365",
    y1: 4.133,
    x2: 3.059,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.684, 705.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1366",
    "data-name": "Line 1366",
    x1: 11.522,
    y1: 4.683,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.32, 708.788)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1370",
    "data-name": "Line 1370",
    y1: 2.751,
    x2: 16.51,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.887, 692.638)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1372",
    "data-name": "Line 1372",
    x2: 13.203,
    y2: 2.76,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.274, 695.299)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1374",
    "data-name": "Line 1374",
    x1: 12.842,
    y1: 3.012,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.32, 708.788)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1376",
    "data-name": "Line 1376",
    x1: 0.95,
    y2: 1.896,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.174, 708.394)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1378",
    "data-name": "Line 1378",
    x1: 12.569,
    y1: 4.42,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.603, 713.153)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1379",
    "data-name": "Line 1379",
    x1: 12.14,
    y1: 5.369,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.603, 713.153)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1382",
    "data-name": "Line 1382",
    x1: 11.875,
    y1: 5.723,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1011.022, 713.561)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1383",
    "data-name": "Line 1383",
    y1: 1.303,
    x2: 0.693,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.877, 712.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1386",
    "data-name": "Line 1386",
    x1: 15.527,
    y1: 0.92,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.546, 710.765)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1387",
    "data-name": "Line 1387",
    y1: 4.45,
    x2: 3.387,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.899, 709.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1390",
    "data-name": "Line 1390",
    y1: 2.344,
    x2: 16.85,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.1, 696.671)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1391",
    "data-name": "Line 1391",
    x2: 13.464,
    y2: 2.106,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.807, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1394",
    "data-name": "Line 1394",
    x1: 10.329,
    y1: 3.908,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.546, 710.765)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1396",
    "data-name": "Line 1396",
    x2: 13.363,
    y2: 3.867,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.607, 699.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1398",
    "data-name": "Line 1398",
    x1: 15.955,
    y2: 0.029,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1004.576, 710.759)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1400",
    "data-name": "Line 1400",
    y1: 5.752,
    x2: 4.08,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.173, 709.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1402",
    "data-name": "Line 1402",
    y1: 3.647,
    x2: 17.544,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1007.374, 696.4)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1404",
    "data-name": "Line 1404",
    x2: 13.098,
    y2: 4.122,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1012.331, 699.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1406",
    "data-name": "Line 1406",
    x1: 1.303,
    y2: 8,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.897, 702.047)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1407",
    "data-name": "Line 1407",
    y1: 4.904,
    x2: 0.143,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.87, 702.691)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1408",
    "data-name": "Line 1408",
    x1: 1.16,
    y2: 3.096,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.926, 702.187)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1412",
    "data-name": "Line 1412",
    x1: 1.387,
    y2: 8.824,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.625, 677.145)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1413",
    "data-name": "Line 1413",
    x2: 12.472,
    y2: 2.594,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 991.939, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1416",
    "data-name": "Line 1416",
    x1: 2.067,
    y2: 11.173,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.924, 676.656)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1418",
    "data-name": "Line 1418",
    x1: 11.741,
    y2: 0.253,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 992.631, 692.226)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1419",
    "data-name": "Line 1419",
    x1: 13.043,
    y2: 8.253,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.456, 690.563)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1422",
    "data-name": "Line 1422",
    x1: 12.085,
    y1: 2.263,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.869, 691.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1423",
    "data-name": "Line 1423",
    y1: 10.516,
    x2: 0.958,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.669, 690.093)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1426",
    "data-name": "Line 1426",
    x1: 13.09,
    y1: 2.385,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 991.995, 678.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1427",
    "data-name": "Line 1427",
    y1: 8.131,
    x2: 14.048,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.949, 677.289)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1430",
    "data-name": "Line 1430",
    x2: 11.98,
    y2: 3.042,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.354, 678.679)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1432",
    "data-name": "Line 1432",
    y1: 4.391,
    x2: 13.972,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 996.29, 678.066)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1433",
    "data-name": "Line 1433",
    y1: 6.775,
    x2: 0.882,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.011, 690.87)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1436",
    "data-name": "Line 1436",
    x2: 12.585,
    y2: 4.433,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1000.914, 678.501)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1438",
    "data-name": "Line 1438",
    x1: 10.925,
    y1: 5.359,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.869, 691.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1440",
    "data-name": "Line 1440",
    x1: 11.001,
    y1: 1.619,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 999.195, 691.733)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1441",
    "data-name": "Line 1441",
    y1: 3.74,
    x2: 0.076,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.853, 690.956)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1444",
    "data-name": "Line 1444",
    x1: 0.681,
    y2: 2.35,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.212, 678.013)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1446",
    "data-name": "Line 1446",
    x2: 11.905,
    y2: 6.783,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.354, 678.679)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1448",
    "data-name": "Line 1448",
    x1: 11.884,
    y2: 5.157,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 997.428, 691.207)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1450",
    "data-name": "Line 1450",
    x2: 19.704,
    y2: 0.311,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.123, 680.648)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1452",
    "data-name": "Line 1452",
    y1: 1.955,
    x2: 0.992,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1008.709, 699.016)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1454",
    "data-name": "Line 1454",
    y1: 2.209,
    x2: 18.519,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1002.276, 677.675)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1456",
    "data-name": "Line 1456",
    x1: 1.072,
    y2: 2.687,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1005.903, 694.741)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1458",
    "data-name": "Line 1458",
    x2: 14.056,
    y2: 2.564,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1010.607, 699.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1460",
    "data-name": "Line 1460",
    x2: 14.884,
    y2: 3.137,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1009.414, 700.499)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1462",
    "data-name": "Line 1462",
    x2: 14.266,
    y2: 2.48,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1006.797, 699.422)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1464",
    "data-name": "Line 1464",
    x1: 14.153,
    y1: 0.864,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 1003.274, 695.299)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1468",
    "data-name": "Line 1468",
    y1: 12.841,
    x2: 58.678,
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 972.881, 465.888)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1470",
    "data-name": "Line 1470",
    y1: 17.523,
    x2: 12.266,
    transform: "translate(958.854 468.931)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1472",
    "data-name": "Line 1472",
    x1: 9.93,
    y1: 0.086,
    transform: "translate(962.599 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1473",
    "data-name": "Line 1473",
    x1: 8.522,
    y1: 1.255,
    transform: "translate(962.599 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1476",
    "data-name": "Line 1476",
    y1: 1.596,
    x2: 10.472,
    transform: "translate(950.232 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1477",
    "data-name": "Line 1477",
    y1: 0.39,
    x2: 7.992,
    transform: "translate(952.711 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1480",
    "data-name": "Line 1480",
    x1: 10.417,
    y1: 0.066,
    transform: "translate(960.704 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1481",
    "data-name": "Line 1481",
    y1: 17.59,
    x2: 1.849,
    transform: "translate(958.854 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1484",
    "data-name": "Line 1484",
    y1: 1.579,
    x2: 9.888,
    transform: "translate(952.711 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1485",
    "data-name": "Line 1485",
    x1: 7.534,
    y1: 17,
    transform: "translate(962.599 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1488",
    "data-name": "Line 1488",
    y1: 1.188,
    x2: 1.895,
    transform: "translate(960.704 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M1318.739,341.088V298.349L1280,335.717Z",
    transform: "translate(-421.706 191.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M1321.761,297.834,1280,297.46l3.021,37.742Z",
    transform: "translate(-424.728 191.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M1321.761,249.737,1280,269.791l41.761.374Z",
    transform: "translate(-424.728 219.205)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M1312.44,742.317v-48.6l-32.44-.307Z",
    transform: "translate(-415.407 -38.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M1280.5,693.405,1280,740.3l32.936,2.021Z",
    transform: "translate(-415.903 -38.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M1318.739,392.647,1280,387.276l5.921,36.981Z",
    transform: "translate(-421.706 139.462)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M1312.818,434.1V400.058L1280,431.668Z",
    transform: "translate(-415.785 132.051)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M1298.641,36.03,1280,49.762l18.641.872Z",
    transform: "translate(-401.607 343.11)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M1313.209,807.015l-32.936-2.021-.273.08Z",
    transform: "translate(-416.176 -102.727)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M1405.311,335.2l-3.021-37.742-30.1,12.443Z",
    transform: "translate(-547.017 191.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M1282.488,90.918l16.153-21.337L1280,68.709Z",
    transform: "translate(-401.607 324.163)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M1296.153,91.75V70.783L1280,92.12Z",
    transform: "translate(-399.12 322.961)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M1379.38,287.18l1.252,16.763,30.1-12.443Z",
    transform: "translate(-555.459 197.496)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M1312.44,629.372V582.435L1280,629.066Z",
    transform: "translate(-415.407 26.311)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M1296.153,120.68l-16.153.37,16.153,9.96Z",
    transform: "translate(-399.12 294.031)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M1306.767,481.08,1280,523.164l26.767.507Z",
    transform: "translate(-409.734 85.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M1280,475.282l6.051,44.52,26.767-42.084Z",
    transform: "translate(-415.785 88.437)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M1312.44,581.736l-26.767-.507L1280,628.367Z",
    transform: "translate(-415.407 27.01)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M1286.971,240.4,1280,264.379l41.761-20.054Z",
    transform: "translate(-424.728 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M1314.789,236.249v-9.776L1280,232.327Z",
    transform: "translate(-417.756 232.693)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M1362.79,260.059l31.352,4.32,6.971-23.976Z",
    transform: "translate(-538.869 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M1281.214,24.63,1280,43.152l18.641-13.732Z",
    transform: "translate(-401.607 349.72)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M1280,17.475l17.426,4.79V12.29Z",
    transform: "translate(-400.393 356.875)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M1321.47,42.92l8.9.233,1.214-18.522Z",
    transform: "translate(-451.978 349.72)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M1280,121.56l1.072,13,15.081-3.04Z",
    transform: "translate(-399.12 293.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M1405.311,352.37l-33.121-25.3,9.845,11.189Z",
    transform: "translate(-547.017 174.368)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M1387.3,404.789l-5.921-36.981L1358.1,353.7Z",
    transform: "translate(-523.082 158.929)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M1306.969,816.719l6.24-9.594L1280,805.184Z",
    transform: "translate(-416.176 -102.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M1324.487,121.56l-8.6.717,9.669,12.283Z",
    transform: "translate(-443.607 293.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M1333.26,68.388l-8.9-.233,2.79,23.158Z",
    transform: "translate(-454.868 324.484)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M1318.44,91.634l8.6-.717-2.488-22.209Z",
    transform: "translate(-446.157 324.163)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M13.186,15.676,10.539,1.467,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 817.793, 571.951)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M1280,148.3l15.081,15.855v-18.9Z",
    transform: "translate(-398.048 279.779)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M63.834,0,0,4.46,2.727,15.713Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 831.066, 509.512)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M1375.214,739.317l.5-46.891-18.51-.71Z",
    transform: "translate(-511.117 -37.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M0,15.713l55.72-3.959L61.107,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 830.499, 512.18)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M0,11.754l18.573,3.922L5.387,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.914, 566.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M0,12.277l10.539,1.467L11.854,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.803, 574.504)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M1381.513,801.758l.273-.08-23.406-2.4Z",
    transform: "translate(-517.689 -99.411)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M1363.771,691.716l-5.391,45.2,23.406,2.4Z",
    transform: "translate(-517.689 -37.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M1297.14,805.184l-2.29,74.66,29.259-63.125Z",
    transform: "translate(-433.316 -102.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M1296.456,224.177,1280,231l34.789-5.854Z",
    transform: "translate(-417.756 234.025)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M1401.113,240.4l-20.9,4.235-17.422,15.421Z",
    transform: "translate(-538.869 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M22.09,4.62,0,0,4.643,5.1Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M3.307,5.511l13.2-2.76L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.857, 693.211)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M22.09,5.511,18.783,0,0,.891Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.763, 674.838)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M1387.3,404.789l-29.2-51.09,11.762,48.311Z",
    transform: "translate(-523.082 158.929)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M0,1.382,16.51,4.133,13.451,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.209, 693.498)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M14.581,0,0,.55,3.059,4.683Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.95, 706.769)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M0,13.64,63.834,9.18,5.295,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 840.045, 511.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M1354.079,626.955l5.673-47.138-16.052-1.023Z",
    transform: "translate(-489.486 28.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M1358.1,468.667l7.433,46.277,10-43.5Z",
    transform: "translate(-511.32 92.272)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M1357.2,626.245l18.51.71-10.379-48.161Z",
    transform: "translate(-511.117 28.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M1353.7,475.282l-10,43.5,16.052,1.023Z",
    transform: "translate(-489.486 88.437)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M0,3.151,14.581,2.6,10.4,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.494, 707.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M18.519,2.687,17.447,0,0,.479Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.406, 678.234)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M18.783,0l4.379,8.2L0,.891Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.763, 674.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M0,.864,1.072,3.551,14.153,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.625, 695.479)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M0,0,17.459,4.647,4.378,8.2Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.857, 693.211)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M17.459,6.029,0,1.382,13.451,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.208, 693.498)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M14.153,1.9,13.2,0,0,2.76Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.479, 695.873)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M0,0,3.5,4.376,18.519,2.209Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.938, 678.134)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M23.162,7.307,8.144,9.474,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M1429.952,248.3l-9.888-1.579-7.534,17Z",
    transform: "translate(-588.609 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M1323.285,24.182,1321.47,42.66l10.115-18.29Z",
    transform: "translate(-451.978 349.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M0,13.745l68.688-.354L1.315,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.612, 584.813)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M0,0,15.9,1.122,4.009,6.029Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.413, 706.655)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M0,3.151,10.4,0l5.5,4.272Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.494, 707.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M0,0,4.177,2.6,5.5,4.272Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.331, 717.487)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M.95,4.907,12.842,0,0,3.012Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.679, 709.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M0,4.683,12.842,1.672,11.522,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.315, 709.761)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M1294.867,189.367,1280,188.743l14.867,15.855Z",
    transform: "translate(-397.834 254.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M1283.466,188.743,1280,203.633l18.334.965Z",
    transform: "translate(-401.3 254.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M1280.214,167.727l14.867.624L1280,152.5Z",
    transform: "translate(-398.048 275.584)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M1355.3,1281.63l-20.107,1.223,4.711,87.185Z",
    transform: "translate(-481.455 -379.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M1393.315,1371.273l-4.71-87.185-16.775-.328Z",
    transform: "translate(-534.87 -380.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M55.72,0,0,3.959l5.9,4.2Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 819.001, 509.736)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M16.754,0,0,4.079l4.9,8.2Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 830.821, 569.712)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M58.539,9.18l-4.9-8.2L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 838.944, 516.6)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M1380.292,1538.52l-10.282,25.805,10.451.029Z",
    transform: "translate(-521.251 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M1363.78,1599.93l-12.089.029-10.451-.029Z",
    transform: "translate(-492.481 -563.622)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M1341.408,1564.355l12.089-.029-12.258-25.805Z",
    transform: "translate(-482.198 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M1445.99,246.724l-9.93.086,2.4,16.914Z",
    transform: "translate(-618.777 228.74)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M30.012,7.226l-4.643-5.1L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.246, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M30.012,7.226,0,0,.416,7.081Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.246, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M67.372,13.39l-.416-7.081L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.338, 586.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M1325.559,135.549l-9.669-12.283,3.189,15.76Z",
    transform: "translate(-443.607 292.532)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M1315.38,155.973l6.694,11.755-.214-15.231Z",
    transform: "translate(-439.908 275.584)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M1334.9,123.266l-3.589,1.177,6.778,14.583Z",
    transform: "translate(-462.616 292.532)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M1339.7,68.155l-.8,24.335,3.589-1.177Z",
    transform: "translate(-470.206 324.484)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M1324.109,832.634l-29.259,63.125,16.472-6.325Z",
    transform: "translate(-433.316 -118.752)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M0,8.16,42.656,4.637,49.824,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 817.776, 515.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M1377.893,879.844l2.29-74.66-21.153,81.433Z",
    transform: "translate(-516.36 -102.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M1382.163,801.758l-23.133-2.483,1.979,83.917Z",
    transform: "translate(-518.339 -99.411)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M1341.22,42.968l4.513-.308,1.815-18.478Z",
    transform: "translate(-476.24 349.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M1345.54,68.463l3.715,24.027.8-24.335Z",
    transform: "translate(-480.561 324.484)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M1327.05,7.053l-10.27,7.2,8.3.188Z",
    transform: "translate(-445.472 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M1280,14.439l17.426-5.185-15.455-2.2Z",
    transform: "translate(-400.393 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M29.6.144,0,0,.068,5.748Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.233, 649.215)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M2.647,14.208,68.755,5.394,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.167, 581.955)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M0,5.6,33.029,4.376,29.528,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.078, 649.251)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M68.755,5.748,68.688,0,0,.354Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.514, 582.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M1280,2.964l15.455,2.2V0Z",
    transform: "translate(-398.422 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M1353.5,1564.325l-.282-25.469-11.976-.336Z",
    transform: "translate(-482.198 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M3.4,6.076,16.935,2.161,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.906, 697.365)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M15.7,0,0,.748,3.269,5.053Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.894, 711.333)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M0,2.144,16.935,4.305,13.665,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.003, 697.81)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M3.336,2.955,0,0,8.144,9.474Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M23.519,6.076,20.124,0,0,1.823Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.09, 677.681)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M25.368,2.127,28.7,5.082,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.246, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M23.519,4.253,0,0,4.807,6.519Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M1350.075,68.888l-2.635,3.268,6.35,20.759Z",
    transform: "translate(-485.095 324.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M0,3.559l15.7-.748L10.619,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.644, 711.917)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M1347.44,76.665l2.328,14.445,4.021,6.314Z",
    transform: "translate(-485.095 319.551)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M1353.886,1512.221l-2.244-19.641-9.732,19.3Z",
    transform: "translate(-482.868 -501.382)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M1347.25,1492.02l.6,19.54,9.732-19.3Z",
    transform: "translate(-488.805 -501.057)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M1335.19,1370.038l10.329.235,5.068-88.643Z",
    transform: "translate(-476.745 -379.075)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M1377.154,1018.639l6.19-35.783-18.863,6.774Z",
    transform: "translate(-521.81 -205.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M19.7,1.955,18.712,0,0,2.266Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.147, 681.119)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M20.124,0l4.387,8.031L0,1.823Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.09, 677.681)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M0,4.637,30.545,8.682,7.169,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 808.907, 557.226)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M23.376,8.682l-4.8-4.761L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.417, 564.239)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M0,.311,2.206,2.628,19.7,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.235, 680.713)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M24.511,6.208,7.013,8.836,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M0,0,17.662,3.6,4.387,8.031Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.906, 697.365)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M0,2.144,13.665,0l4,5.741Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.003, 697.81)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M0,2.48.992,4.434,14.266,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.682, 699.938)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M14.266,1.435,13.54,0,0,3.915Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.086, 700.236)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M.727,5.642,12.816,0,0,4.207Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.386, 714.354)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M5.084,2.811l.383.847L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.436, 722.304)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M16.086.1,4,5.741,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.162, 711.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M0,5.053,12.816.847,12.434,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.214, 714.531)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M0,3.559,10.619,0l5.467,3.658Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.643, 711.917)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M1384.718,1538.52l-14.308,1.013,4.026,24.792Z",
    transform: "translate(-525.676 -528.017)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M1384.718,1511.56l-.6-19.54-13.711,20.552Z",
    transform: "translate(-525.676 -501.057)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M0,8.153,16.754,4.074,23.393,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 834.806, 570.559)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M0,4.074l66.956,6.309L6.639,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 831.323, 586.946)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M1351.59,982.856l-6.19,35.783,14.207,3.253Z",
    transform: "translate(-490.056 -205.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M1347.01,1068.01,1345.4,1159l15.817-87.736Z",
    transform: "translate(-491.666 -255.221)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M1333.3,1013.165l8.455-45.36-16.472,6.325Z",
    transform: "translate(-463.746 -197.123)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M1335.19,1163.486l20.107-1.223-4.29-86.513Z",
    transform: "translate(-481.455 -259.708)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M29.1,5.546,0,0,.391.464Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.781, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M60.317,10.383l-.391-.464L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.942, 593.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M65.742,2.406,66.107,0,0,8.814Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 808.341, 583.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M0,3.634,35.6,2.317,33.394,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.874, 647.984)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M4.8,11.169,65.742,0,0,6.409Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 805.988, 582.923)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M33.394,0,.366,1.228,0,3.634Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.874, 647.984)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M1318.129,14.251l10.27-7.2L1316.78,15.66Z",
    transform: "translate(-446.821 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M1347.548,24.182l-1.349,1.409-4.979,17.377Z",
    transform: "translate(-476.24 349.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M1371.83,1283.76l12.77,87.454,8.715.059Z",
    transform: "translate(-534.87 -380.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M1385.542,1491.939l-8.715-.059-5,20.611Z",
    transform: "translate(-527.096 -500.976)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M53.64,3.192,45.429,0,0,2.21Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 841.105, 517.059)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M31.6,0,0,4.962,8.211,8.153Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 836.513, 562.527)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M16.241,0,0,1.188,3.248,5.422Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.851, 713.236)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M0,2.573,17.594,4.234,14.346,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.672, 698.956)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M3.387,5.941,17.594,1.662,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.156, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M0,3.991,16.241,2.8,11.169,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.593, 713.818)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M23.364,5.941,19.977,0,0,1.718Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.309, 678.881)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M23.364,4.223,0,0,5.261,6.47Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.628, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M29.1,5.546l1.752,2.366L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.781, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M1.752,2.366,0,0,7.013,8.836Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M45.429.6,6.858,0,0,2.805Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 841.688, 517.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M0,0,45.727,11.088l6.858-2.805Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 859.298, 474.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M1379.21,998.976l.71,31.66,11.964-2.651Z",
    transform: "translate(-536.54 -215.196)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M1391.173,1068.01l-11.964,2.652L1389.564,1159Z",
    transform: "translate(-535.83 -255.221)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M1389.461,1074.32l-6.421,88.009,16.775.328Z",
    transform: "translate(-546.08 -258.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M1334.75,1279.53l-3.992.882-5.068,88.643Z",
    transform: "translate(-456.916 -377.858)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M1409.062,736.913l5.391-45.2-13.2,44.175Z",
    transform: "translate(-568.37 -37.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M1315.38,203.633l3.467-14.89-3.189,1.225Z",
    transform: "translate(-436.681 254.569)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M1318.885,173.749l3.189-1.225-6.694-11.755Z",
    transform: "translate(-439.908 270.787)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M1322.97,206.468l.029-1.146.277-13.665Z",
    transform: "translate(-444.3 252.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M0,3.523,9.442,2.357,42.656,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 813.241, 514.539)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M0,5.851,45,0,35.563,1.167Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.329, 479.264)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M0,2.573,14.346,0l3.925,5.377Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.672, 698.956)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M14.884,1.143,14.207,0,0,4.279Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.826, 701.389)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M0,3.137.975,4.485,14.884,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.709, 701.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M0,0,18.271,2.8,4.362,7.289Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.156, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M19.078,1.348,18.1,0,0,2.248Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.405, 682.792)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M19.977,0l4.362,7.289L0,1.718Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.309, 678.881)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M1341.91,1491.994l2.244,19.641-1.454-20.065Z",
    transform: "translate(-473.136 -500.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M1325.69,1369.056l.79-.424,8.27-89.1Z",
    transform: "translate(-456.916 -377.858)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M16.628,0,3.925,5.708,0,.331Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.013, 713.057)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M5.073,2.8l.386.857L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.271, 724.743)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M0,5.422,13.38.857,12.993,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.176, 716.413)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M.677,5.708,13.38,0,0,4.565Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.338, 716.234)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M0,3.991,11.169,0l5.459,3.66Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.593, 713.818)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M24.339,5.571,6.614,8.046,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.628, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M19.078,0,0,.9,1.353,2.475Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.086, 682.512)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M36.953,1.575,35.6,0,0,1.317Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.607, 647.502)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M1394.99,1283.238l-2.42-.378,15.19,87.832Z",
    transform: "translate(-558.031 -379.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M0,11.169,2.521,6.413,60.939,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.989, 587.621)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M58.417,3.4,0,9.817,58.951,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.795, 590.795)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M23.847,0l9.366,2.9L0,5.259Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.116, 524.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M0,0,42.433,2.192,39.912,6.948Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 809.159, 547.704)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M9.366,2.9,0,0,39.912,6.948Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 809.159, 547.704)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M30.848,7.912.458,1.253,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.781, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M59.926,9.919l.458,1.253L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.943, 593.44)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M1322.97,164.955l5.774,8.794-3.5-12.979Z",
    transform: "translate(-449.767 270.787)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M1335.819,144.834l2.269-4.185-6.778-14.583Z",
    transform: "translate(-462.616 290.908)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M1381.9,468.667l1.588,46.125,5.845.151Z",
    transform: "translate(-535.12 92.272)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M1388.073,626.245l8.131-47.451-14.3,47.3Z",
    transform: "translate(-541.99 28.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M1396.2,578.585l-5.845-.151-8.459,47.453Z",
    transform: "translate(-541.99 28.63)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M1414.453,691.51l-6.173-.15-7.03,44.324Z",
    transform: "translate(-568.37 -36.843)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M1336.71,126.777l5.581,18.057-4.509-18.768Z",
    transform: "translate(-469.087 290.908)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M1351.461,117.355l-4.021-6.314,2.95,7.024Z",
    transform: "translate(-482.767 299.62)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M1354.31,72.156l2.635-3.268.828.483Z",
    transform: "translate(-491.965 324.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M1354.31,72.823l3.462-2.785-1.135,17.23Z",
    transform: "translate(-491.965 323.393)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M1345.258,45.4l-.828-.483,4.979-17.377Z",
    transform: "translate(-479.451 348.035)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M1349.99,87.268l1.134-17.23,1.815,24.254Z",
    transform: "translate(-485.317 323.393)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M38.571.6,29.158,7.458,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 840.263, 523.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M1436.06,246.81l9.93-.086-8.522,1.255Z",
    transform: "translate(-614.535 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M0,4.682,46.412,0l-45,5.851Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.622, 477.887)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M1395.81,466.6l4.2,46.992-1.589-46.125Z",
    transform: "translate(-551.644 93.468)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M1399.59,353.7l9.148,47.444,2.614.867Z",
    transform: "translate(-564.572 158.929)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M31.6,0l3.009,9.189L0,4.962Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 836.513, 562.527)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M44.025,4.227,0,6.862,9.413,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 833.617, 552.289)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M57.376,1.983l.08,5.431L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.33, 594.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M60.384,11.171,3.009,9.189,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.943, 593.44)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M2.668,8.653,0,0,45.1,10.845Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.177, 546.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M1414.1,1074.32l-5.66,16.657-.76,71.352Z",
    transform: "translate(-570.72 -258.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M1424.331,1113.96l-3.181,70.974,2.42.378Z",
    transform: "translate(-586.611 -281.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M1316.7,15.66l11.619-8.607.034.092Z",
    transform: "translate(-446.741 359.911)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M1280,2.964,1295.455,0l-15.422,3.056Z",
    transform: "translate(-398.422 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M1307.637,832.634l-12.787,56.8,7.354-1.54Z",
    transform: "translate(-416.844 -118.752)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M1290.87,887.894l7.106-55.037-1.673-.223Z",
    transform: "translate(-405.51 -118.752)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M1392.57,1282.86l14.316,87.605.874.227Z",
    transform: "translate(-558.031 -379.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M1331.07,1075.75l4.29,86.513,1.731-72.079Z",
    transform: "translate(-461.519 -259.708)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M1325.69,1182.179l3.992-.882-2.261-71.2Z",
    transform: "translate(-451.848 -279.624)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M15.527,0,0,.92,3.387,5.37Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.407, 710.957)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M0,5.62,57.01,0l.5,5.611Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 812.985, 593.367)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M0,9.817,1.437.009,58.951,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.795, 590.795)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M44.025,0l.445,13.034L0,2.635Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.483, 551.41)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M46.538,10.4,0,9.362,2.068,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.335, 548.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M0,0,46.538,1.037,45.1,10.845Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.177, 546.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M57.456,7.414.445,13.034,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.329, 594.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M0,3.908l15.527-.92L10.329,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.329, 711.578)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M1316.8,16.811l-.1-1.024,11.653-8.515Z",
    transform: "translate(-446.741 359.784)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M1348.352,27.536l.1,1.024L1344.2,45.4Z",
    transform: "translate(-478.393 348.035)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M1412.53,246.724l9.888,1.579-7.993-.39Z",
    transform: "translate(-581.075 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M1441.967,247.912l-10.417.066,8.522-1.255Z",
    transform: "translate(-608.617 220.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M0,2.106,16.851,4.45,13.464,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.307, 697.596)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M3.488,6.211,16.851,2.344,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.247, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M1280,3.056,1295.422,0V.526Z",
    transform: "translate(-398.388 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M29.158,7.458,7.7,6.4,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 840.263, 523.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M21.46,1.056l-2.068,9.362L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 832.401, 530.09)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M22.343,6.211,18.855,0,0,1.963Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.167, 678.716)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M30.39,6.659l.075,1.4L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.461, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M22.343,4.248,0,0,6.539,6.649Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.246, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M0,0,6.614,8.046.076,1.4Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.628, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M0,12.176,5.53,0,23.847,6.917Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.882, 525.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M0,1.737,15.649,0l2.668,8.653Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 821.431, 531.586)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M19.392,10.419,3.744,12.155,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 832.401, 530.09)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M0,5.37,12.568.949,12.14,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.703, 714.27)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M5.2,2.988l.428.949L0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.182, 721.681)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M0,3.908,10.329,0l5.627,3.937Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.33, 711.578)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M1422.711,797.864l-7.812-1.023-.819,88.383Z",
    transform: "translate(-582.02 -98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M1419.981,883.192,1418,799.275l-8.631,87.36Z",
    transform: "translate(-577.31 -99.411)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M0,2.106,13.464,0l4.08,5.752Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.307, 697.596)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M.693,5.723,12.568,0,0,4.42Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.774, 714.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M14.056,1.3,13.363,0,0,3.867Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.229, 700.082)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M15.956.029,4.08,5.752,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.507, 710.765)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M16.762,1.558,15.8,0,0,2.4Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 786.732, 683.82)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M0,2.564.958,4.122,14.056,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.954, 699.811)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M0,0,17.544,3.647,4.446,7.769Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.247, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M18.855,0,23.3,7.769,0,1.963Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.167, 678.716)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M19.834,0,3.072.843,0,1.15Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.847, 680.491)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M33.882.565,36.953.258,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.319, 647.228)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M23.3,5.806,3.467,6.956,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.247, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M1417.1,251.148l-10.472-1.6,7.993.39Z",
    transform: "translate(-573.28 219.313)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M1365.269,245.844l-2.479-1.206,20.9-4.235Z",
    transform: "translate(-521.448 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M1397.457,1491.567l-.874-.227-4.013,18.842Z",
    transform: "translate(-547.727 -500.663)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M1392.57,1512.491l5-20.611-4.887,18.615Z",
    transform: "translate(-547.836 -500.976)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M1333.735,967.8l-8.455,45.36,7.3,4.152Z",
    transform: "translate(-455.729 -197.123)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M1328.02,1075.75l6.022,14.434,1.281-10.282Z",
    transform: "translate(-458.469 -259.708)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M1307.78,1015.191l8.5-51.051-7.354,1.54Z",
    transform: "translate(-430.925 -194.998)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M1408.033,1077.719l-.353,13.258,5.66-16.657Z",
    transform: "translate(-569.96 -258.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M1419.981,998.976l-10.61,3.443,6.013,31.617Z",
    transform: "translate(-577.31 -215.196)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M1412.987,1030.636l-.71-31.66-4.6,35.06Z",
    transform: "translate(-569.607 -215.196)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M1336.989,1279.53l-8.27,89.1-3.03.244Z",
    transform: "translate(-459.156 -377.858)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M1310.857,191.657l5.219,3.45-5.526,11.361Z",
    transform: "translate(-431.88 252.879)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M1310.55,170.729l10.993,12.244-5.219-3.449Z",
    transform: "translate(-437.347 265.013)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M1306.54,211.227l5.526-11.361,1.685,13.941Z",
    transform: "translate(-427.87 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M1378.862,240.4l.988,2.884-19.409,2.557Z",
    transform: "translate(-516.618 224.617)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M1321.978,226.9l7.211,2.579-22.649,5.978Z",
    transform: "translate(-443.309 232.444)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M1323.63,231l16.455-6.818-15.468,9.7Z",
    transform: "translate(-461.386 234.025)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M1339.1,224.177l-.03,1.145-15.438,8.557Z",
    transform: "translate(-460.399 234.025)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M1405.81,353.663l.63-.026,8.518,47.47Z",
    transform: "translate(-570.792 158.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M0,0,53.215,8.257l7.7,6.4Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 859.403, 473.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M1404.9,1370.566l-2.95-.1-14.317-87.605Z",
    transform: "translate(-553.091 -379.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M1325.69,1368.638l4.16-89.517,7.139.172Z",
    transform: "translate(-459.156 -377.62)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M30.465,8.056,16.611.913,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.461, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M.08,5.431,0,0,16.611.913Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.461, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M19.657,5.455.5,5.611,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.132, 649.132)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M19.687,0l14.2,4.126L0,3.561Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.802, 647.969)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M19.687,0,0,3.561.534.156Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.802, 647.969)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M19.657,9.973,0,4.518,16.531,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 805.552, 650.071)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M1280,199.866l12.837,3.522-11.152,10.418Z",
    transform: "translate(-395.804 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M1280,218.666l11.152-10.418v11.785Z",
    transform: "translate(-394.119 243.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M13.859,6.23,0,0,13.854,7.143Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.114, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M0,0,0,.914,3.467,7.869Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.141, 678.497)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M1387.63,1282.1l6.866-.55,10.4,88.257Z",
    transform: "translate(-553.091 -379.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M1349.99,70.038l1.547.369.269,23.886Z",
    transform: "translate(-484.183 323.393)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M1345.746,47.177l-1.546-.369,4.248-16.836Z",
    transform: "translate(-478.393 346.623)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M1315.467,174.572l6.076,8.4-10.993-12.244Z",
    transform: "translate(-437.347 265.013)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M1347.652,1509.21l-2.282-17.4,3.03-.244Z",
    transform: "translate(-478.836 -500.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M1344.112,1511.635l-2.2-2.425.748-17.64Z",
    transform: "translate(-473.094 -500.796)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M1336.71,127.757l2.235.908,3.345,17.149Z",
    transform: "translate(-469.087 289.928)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M1325.01,129.918l8.261,20.992-4.917-3.843Z",
    transform: "translate(-455.152 288.675)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M1344.67,70.915l2.5,24.794-2.235-.908Z",
    transform: "translate(-477.316 322.884)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M1340.732,29.972l2.593,3.307-5.295,13.9Z",
    transform: "translate(-470.677 346.623)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M13.859,8.824,12.472,0,0,2.594Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.652, 666.78)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M1.387,8.824,13.972,4.391,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.059, 678.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M1406.63,249.552l10.472,1.6-8.622,15.993Z",
    transform: "translate(-573.28 219.313)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M1427.15,249.618l10.417-.066,1.849,17.59Z",
    transform: "translate(-604.217 219.313)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M58.678,12.841,12.266,17.523,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 833.732, 468.559)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M0,0,64.208.665l-5.53,12.176Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 833.732, 468.559)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M60.914,14.658.45,26.148,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 859.403, 473.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M60.464,0l3.744,12.155L0,11.49Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 844.972, 470.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M1407.02,1184.934l3.181-70.974,5.938,7.06Z",
    transform: "translate(-572.481 -281.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M1413.886,1194.124l-6.866.551,9.119-63.914Z",
    transform: "translate(-572.481 -291.603)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M1370.318,1491.035l7.711-.4-8.749,15.1Z",
    transform: "translate(-518.512 -500.257)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M1396.025,1506.144l-5.925,4.038,4.013-18.842Z",
    transform: "translate(-545.257 -500.663)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M1390.58,1491.441l-1.038,14.7-1.912-14.8Z",
    transform: "translate(-538.774 -500.663)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M1417.387,741.578l-11.077-5.894,7.03-44.324Z",
    transform: "translate(-573.431 -36.843)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M1333.594,1191.593l-7.139-.172-.765-63.561Z",
    transform: "translate(-455.76 -289.921)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M1331.333,1110.1l2.261,71.2-7.9-63.733Z",
    transform: "translate(-455.76 -279.624)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M1317.063,26.257l-2.593-3.307,12.493-5.089Z",
    transform: "translate(-444.414 353.644)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M1326.963,11.722l-12.493,5.089,11.556-9.539Z",
    transform: "translate(-444.414 359.784)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M1280,3.781l15.422-2.53-14.484,6.98Z",
    transform: "translate(-398.388 363.275)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M1375.87,625.887l8.459-47.453,8.379.824Z",
    transform: "translate(-535.961 28.63)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M11.883,5.157,11.74.253,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M0,0,.882,6.775l11-1.619Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.669, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M0,2.385,13.972,6.775,13.09,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.391, 679.475)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M1378.3,1279.782l14.321-1.282-3.921,89.539Z",
    transform: "translate(-536.895 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M1373.2,1278.5l3.791,89.144-7.711.395Z",
    transform: "translate(-517.474 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M1357.648,1278.761l-4.16,89.517L1342.68,1278.5Z",
    transform: "translate(-486.954 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M1363.388,1368.278l-7.017-.634-3.79-89.144Z",
    transform: "translate(-496.854 -377.26)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M14.195,5.519,0,1.394,11.413,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.073, 667.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M14.539,8.579,3.127,9.973,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.115, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M12.472,0l2.068,11.173L0,2.594Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.652, 666.78)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M12.585,0,0,4.433l.681,2.35Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 797.475, 679.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M.681,2.35,0,0,3.462,7.869Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.139, 678.501)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M1385.837,628.608l-9.968-1.583,16.838-46.628Z",
    transform: "translate(-535.961 27.493)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M1392.22,691.36l9.968,1.583-5.921,48.635Z",
    transform: "translate(-552.31 -36.843)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M1357,1509.547l-9.846-3.408,7.564-13.989Z",
    transform: "translate(-488.18 -501.132)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M1352.58,1505.263l.546-14.624,7.017.635Z",
    transform: "translate(-493.609 -500.257)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M1378.029,1490.64l-.547,14.624-8.2.475Z",
    transform: "translate(-518.512 -500.257)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M1312.591,189.5l-2.925-1.225-6.076-8.4Z",
    transform: "translate(-425.471 259.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M1306.54,239.019l22.649-5.978-4.446,10.246Z",
    transform: "translate(-443.309 228.885)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M1284.446,233.041l11.152,1.367-15.6,8.879Z",
    transform: "translate(-398.565 228.885)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M1317.12,249.824l19.41-2.557,18.2,4.268Z",
    transform: "translate(-473.298 220.637)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M0,6.783,11.98,3.74,11.9,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 797.334, 680.089)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M11,0,0,1.619l.076,3.74Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.442, 692.07)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M0,0,14.048,8.131,2.068,11.173Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.059, 678.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M0,2.385,13.09,0l.958,10.516Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.391, 679.475)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M0,5.359,12.085,3.1,10.926,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.427, 692.144)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M13.043,8.253.958,10.516,0,0Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.669, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M0,0,11.74.253l1.3,8Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M1.3,8,0,0,.143,4.9Z",
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.981, 703.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M1424.074,881.84l-7.644,3.384.819-88.383Z",
    transform: "translate(-584.37 -98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M1406.31,796.841l11.077,5.894-4.253,79.1Z",
    transform: "translate(-573.431 -98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M1294.484,1.251V7.759L1280,8.231Z",
    transform: "translate(-397.451 363.275)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M1407.64,1002.5l7.644-3.384,3.694,37.538Z",
    transform: "translate(-575.58 -215.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M1418.977,1041.325l-5.324-2.538-6.013-31.617Z",
    transform: "translate(-575.58 -219.946)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M1407.64,1095.668l.353-13.258,5.324,2.538Z",
    transform: "translate(-569.92 -263.57)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M1412.958,1106.229l-5.937-7.06,5.677-10.72Z",
    transform: "translate(-569.3 -267.071)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M1291.534,831.373l6.442.753-7.106,55.037Z",
    transform: "translate(-405.51 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M1356.362,1122.1l.765,63.561-14.447-67.734Z",
    transform: "translate(-486.433 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M1391.9,1117.93l-.521,67.473-14.321,1.281Z",
    transform: "translate(-535.655 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M1357.648,1185.664l-14.968-.261.521-67.473Z",
    transform: "translate(-486.954 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M1379.312,1123.321l12.59-5.391-14.842,68.755Z",
    transform: "translate(-535.655 -284.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M1280,831.928l1.672.223,4.568-.735Z",
    transform: "translate(-389.207 -118.046)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M1291.009,831.391l-4.568.735-6.442-.753Z",
    transform: "translate(-393.976 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M1286.24,818.885V809.8L1280,819.4Z",
    transform: "translate(-389.207 -105.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M1280,245.173l15.6-8.879V249.4Z",
    transform: "translate(-398.565 226.999)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M1332.869,1085.63l-1.281,10.282-3.568-8.2Z",
    transform: "translate(-456.015 -265.437)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M1336.713,1098.782l-5.644,7.463,2.076-15.665Z",
    transform: "translate(-461.14 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M1312.629,1015.191l-4.849,2.08,13.354-53.131Z",
    transform: "translate(-435.775 -194.998)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M1341.719,71.51l-3.954,24.2-2.5-24.794Z",
    transform: "translate(-467.906 322.884)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M1341.719,52.334l-6.459-.6,5.295-13.9Z",
    transform: "translate(-467.906 342.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M1383.182,748.178l-16.762-4.415,5.921-48.635Z",
    transform: "translate(-522.464 -39.028)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M1292.837,203.388,1280,199.866l12.837,4.83Z",
    transform: "translate(-395.804 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M1282.925,201.091l9.913,3.6L1280,199.866Z",
    transform: "translate(-395.804 248.12)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M1384.249,518.21l-8.379-.824,7.106-44.246Z",
    transform: "translate(-527.502 89.678)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M1383.1,513.6l-4.2-46.992,11.308,2.747Z",
    transform: "translate(-534.734 93.468)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M1387.418,401.107l-8.518-47.47,19.825,50.216Z",
    transform: "translate(-543.251 158.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M1334.988,97.631l-7.018-1.1,3.954-24.2Z",
    transform: "translate(-458.112 322.063)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M1325.01,129.918l7.018,1.1,1.244,19.892Z",
    transform: "translate(-455.152 288.675)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M1307.78,1017.271l5.908-51.306,7.446-1.825Z",
    transform: "translate(-435.775 -194.998)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M1313.646,887.163l-7.446,1.825,8.11-57.615Z",
    transform: "translate(-428.286 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M1315.313,156.2l-7.93-3.775-1.244-19.892Z",
    transform: "translate(-429.264 287.156)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M1311.52,183.65l1.071,5.85-9-9.625Z",
    transform: "translate(-425.471 259.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M1290.984,198.314l-9.913-3.6-1.072-5.85Z",
    transform: "translate(-393.951 254.502)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M1402.747,269.455l-17.687-.111,8.623-15.993Z",
    transform: "translate(-549.861 217.11)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M1354.733,255.063l-28.549,14.392-9.064-16.1Z",
    transform: "translate(-473.298 217.11)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M1345.09,695.128l19.8.913-8.963,52.137Z",
    transform: "translate(-495.213 -39.028)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M1306.2,749.439l8.963-52.137L1331.5,753.64Z",
    transform: "translate(-445.481 -40.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M1280,17.211l14.484-.472-14.241,12.782Z",
    transform: "translate(-397.451 354.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M1313.89,37.841l10.144,3.915-8.98,10.579Z",
    transform: "translate(-441.241 342.06)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M1324.034,30.172l-10.144-3.915,9.9-8.4Z",
    transform: "translate(-441.241 353.644)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M1296.342,753.64,1280,697.3l27.351.622Z",
    transform: "translate(-410.318 -40.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M1291.009,698.783v55.734L1280,754.5Z",
    transform: "translate(-393.976 -41.147)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M1392.409,1037.551l-13.716-.9L1375,999.118Z",
    transform: "translate(-535.296 -215.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M1340.392,1019.79H1325.5l20.8-51.306Z",
    transform: "translate(-468.387 -197.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M1375,1088.45l13.716.9-13.455,16.884Z",
    transform: "translate(-531.603 -267.071)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M1339.56,1090.58h14.892l-2.076,15.665Z",
    transform: "translate(-482.447 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M1358.182,1106.245l-13.682-4.172.866-11.493Z",
    transform: "translate(-488.253 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M1388.455,1090.58l-.866,11.493-12.59,5.391Z",
    transform: "translate(-531.342 -268.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M1306.2,889.376l2.219-68,25.3,4.2Z",
    transform: "translate(-447.7 -112.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M1333.724,831.373l-8.11,57.615-19.414,6.184Z",
    transform: "translate(-447.7 -118.021)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M1371.7,989.889l18.8-6.689-1.387,45.122Z",
    transform: "translate(-531.996 -206.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M1366.42,810.868l16.762,4.415-2.219,68Z",
    transform: "translate(-522.464 -106.133)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M1390.5,883.284l-18.8,6.689,4.253-79.1Z",
    transform: "translate(-531.996 -106.133)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M1325.5,1019.79l1.387-45.122,19.414-6.184Z",
    transform: "translate(-468.387 -197.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M1290.984,190.491v7.823L1280,188.859Z",
    transform: "translate(-393.951 254.502)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M1357.9,584.874l-5.072,47.243-19.8-.914Z",
    transform: "translate(-483.143 24.896)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M1339.89,580.4l18.006,1.882-24.876,46.33Z",
    transform: "translate(-483.143 27.493)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M1313.754,133.962l-1.13,22.243-9.173-23.667Z",
    transform: "translate(-426.574 287.156)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M1290.984,159.8,1280,158.17l1.13-22.243Z",
    transform: "translate(-393.951 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M1303.45,99.4l8.018-24.018,2.286,25.442Z",
    transform: "translate(-426.574 320.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M1317.87,47.157l2.1,11.86-11.081-1.281Z",
    transform: "translate(-435.078 336.659)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M1311.953,97.631l-3.063-25.3,11.081,1.281Z",
    transform: "translate(-435.078 322.063)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M1402.747,291.522l-.777,33.768-16.909-33.879Z",
    transform: "translate(-549.861 195.043)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M1403.819,325.29l-16.46-7.731-.45-26.148Z",
    transform: "translate(-551.711 195.043)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M1398.725,403.853,1378.9,353.637l16.46,7.731Z",
    transform: "translate(-543.251 158.965)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M1285.072,584.874l22.28.771L1280,632.117Z",
    transform: "translate(-410.318 24.896)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M1307.351,586.708v47.1L1280,633.181Z",
    transform: "translate(-410.318 23.833)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M1373.172,1599.9h-22.54l-9.392-.025Z",
    transform: "translate(-501.872 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M1289.854,144.4v15.4L1280,135.927Z",
    transform: "translate(-392.821 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M1294.241,48.331,1282.1,59.017l-2.1-11.86Z",
    transform: "translate(-397.208 336.659)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M1280,29.521l14.241-12.782V30.7Z",
    transform: "translate(-397.208 354.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M1372.251,1599.87l.92.025-31.932-.025Z",
    transform: "translate(-501.872 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M1292.14,62.289,1280,60.637l12.14-10.686Z",
    transform: "translate(-395.106 335.039)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M1280,75.38l12.14,1.652-9.854,23.79Z",
    transform: "translate(-395.106 320.295)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M1280,103.1l9.854-23.79V92.226Z",
    transform: "translate(-392.821 318.016)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M1328.878,291.674l23.935,5.088-24.712,28.68Z",
    transform: "translate(-475.991 194.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M1284.614,257.425l15.6,4.228L1280,276.905Z",
    transform: "translate(-403.179 214.748)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M1317.12,271.817l28.549-14.392-4.614,19.48Z",
    transform: "translate(-464.234 214.748)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1280,282.739l20.212-15.252v20.7Z",
    transform: "translate(-403.179 208.914)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M1328.62,473.14l21.128,4.51-19.855,40.56Z",
    transform: "translate(-473.146 89.678)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M1348.475,483.873l-1.849,42.442-18.006-1.882Z",
    transform: "translate(-471.873 83.456)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M1281.849,483.873l20.431,2.342-22.28,40.1Z",
    transform: "translate(-405.246 83.456)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M1280,529.546l22.28-40.1v40.87Z",
    transform: "translate(-405.246 80.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M1404.2,1552.089l6.219-13.913.109-2Z",
    transform: "translate(-565.686 -526.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M1405.125,1565.723l-4.026-24.792-6.219,13.913Z",
    transform: "translate(-556.365 -529.415)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M1395.733,1584.894l9.392.025-10.245-10.879Z",
    transform: "translate(-556.365 -548.611)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M1339.65,1584.111l1.588-11.421-.668,11.446Z",
    transform: "translate(-469.271 -547.829)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M1340.6,1553.342l-.949-14.022.281,25.469Z",
    transform: "translate(-468.632 -528.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M1339.65,1533.55l2.2,2.425L1342.8,1550Z",
    transform: "translate(-470.834 -525.136)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M1300.431,384.507v44.1L1280,426.262Z",
    transform: "translate(-403.397 141.067)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M1280,135.927l9.854,6.835V144.4Z",
    transform: "translate(-392.821 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M1280,120.921l9.854-10.876v13.206Z",
    transform: "translate(-392.821 300.197)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M1289.854,142.762,1280,135.927l9.854,2.33Z",
    transform: "translate(-392.821 285.191)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M1328.1,332.463l24.712-28.68-1.315,32.2Z",
    transform: "translate(-475.991 187.87)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M1280,343.5l21.527-26.757V345.22Z",
    transform: "translate(-404.494 180.354)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M1348.651,380.422l1.1,43.471-21.128-4.51Z",
    transform: "translate(-473.146 143.436)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M1281.315,303.783l20.212,5.448L1280,335.988Z",
    transform: "translate(-404.494 187.87)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M1331.23,372.034l23.4,3.525L1334.6,414.52Z",
    transform: "translate(-479.122 148.299)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M1280,380.422l21.527,1.717L1281.1,423.893Z",
    transform: "translate(-404.494 143.436)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M1408.549,1543.538l-4.349,8.551,6.329-15.909Z",
    transform: "translate(-565.686 -526.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M1392.079,1530.608l5.925-4.038-7.9,11.4Z",
    transform: "translate(-547.236 -521.089)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M1339.65,1542.072l.353-8.522,3.151,16.447Z",
    transform: "translate(-471.187 -525.136)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M1370.47,1525.915l8.2-.475.046,8.455Z",
    transform: "translate(-519.702 -520.434)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M1378.374,1526.57l8.249,7.98-16.153,3.416Z",
    transform: "translate(-527.606 -521.089)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M1356.6,1542.072l-9.446-3.475,9.8-5.047Z",
    transform: "translate(-488.133 -525.136)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M1347.2,1533.895l-.046-8.455,9.846,3.408Z",
    transform: "translate(-488.18 -520.434)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M1378.56,1599.87h0Z",
    transform: "translate(-508.181 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M1412.045,1562.241l4.349-8.552-7.484,8.866Z",
    transform: "translate(-573.53 -536.813)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M1420.365,1574.04l-3.135.315,3.988,10.539Z",
    transform: "translate(-581.85 -548.611)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M1417.36,1574.79l-.13,10.539h4.118Z",
    transform: "translate(-581.98 -549.046)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M1406.474,1553.69l4.169,8.085-11.652.781Z",
    transform: "translate(-563.61 -536.813)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M1374.638,1557.061l-4.169-8.085,16.153-3.416Z",
    transform: "translate(-527.606 -532.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M1343.154,1561.755l-3.093.74-.412-8.665Z",
    transform: "translate(-471.187 -536.894)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M1358.995,1545.56l9.858,12.14-21.843-.639Z",
    transform: "translate(-499.978 -532.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M1342.743,1572.69l-1.588,11.421-1.5-10.682Z",
    transform: "translate(-470.775 -547.829)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M1356.868,1557.7l-9.858-12.14,9.446,3.475Z",
    transform: "translate(-487.993 -532.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M1347.225,1584.251l-.214-11.32,21.843.639Z",
    transform: "translate(-499.978 -547.968)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M1398.48,1585.329l.13-10.539,11.867,10.539Z",
    transform: "translate(-563.23 -549.046)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M1398.48,1573.712l11.652-.781.214,11.32Z",
    transform: "translate(-563.1 -547.968)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M1368.377,1585.132H1346.56l21.628-10.682Z",
    transform: "translate(-499.313 -548.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M1377.245,1599.87h0Z",
    transform: "translate(-508.181 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M1344.934,1585.132h-1.315l-.189-10.682Z",
    transform: "translate(-474.555 -548.849)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M1346.56,1599.87h0Z",
    transform: "translate(-511.311 -563.587)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1585",
    "data-name": "Line 1585",
    x2: 6.459,
    y2: 0.595,
    transform: "translate(867.354 393.799)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1586",
    "data-name": "Line 1586",
    y1: 13.898,
    x2: 5.295,
    transform: "translate(867.354 379.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1587",
    "data-name": "Line 1587",
    x1: 1.164,
    y1: 14.493,
    transform: "translate(872.648 379.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1497",
    "data-name": "Line 1497",
    y1: 7.823,
    transform: "translate(897.033 444.993)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1498",
    "data-name": "Line 1498",
    x2: 10.984,
    y2: 9.455,
    transform: "translate(886.049 443.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1499",
    "data-name": "Line 1499",
    x2: 10.984,
    y2: 1.632,
    transform: "translate(886.049 443.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1588",
    "data-name": "Line 1588",
    x2: 6.694,
    y2: 11.755,
    transform: "translate(875.472 431.557)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1589",
    "data-name": "Line 1589",
    x1: 0.214,
    y1: 15.231,
    transform: "translate(881.952 428.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1590",
    "data-name": "Line 1590",
    y1: 3.477,
    x2: 6.48,
    transform: "translate(875.472 428.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1500",
    "data-name": "Line 1500",
    x2: 14.867,
    y2: 0.624,
    transform: "translate(882.166 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1501",
    "data-name": "Line 1501",
    x2: 14.867,
    y2: 15.855,
    transform: "translate(882.166 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1502",
    "data-name": "Line 1502",
    y2: 15.231,
    transform: "translate(897.033 443.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1503",
    "data-name": "Line 1503",
    x2: 15.081,
    y2: 15.855,
    transform: "translate(881.952 428.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1504",
    "data-name": "Line 1504",
    y1: 18.895,
    transform: "translate(897.033 425.041)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1505",
    "data-name": "Line 1505",
    y1: 3.04,
    x2: 15.081,
    transform: "translate(881.952 425.041)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1506",
    "data-name": "Line 1506",
    x2: 38.739,
    y2: 5.371,
    transform: "translate(858.294 526.738)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1591",
    "data-name": "Line 1591",
    x2: 5.921,
    y2: 36.981,
    transform: "translate(858.293 526.738)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1507",
    "data-name": "Line 1507",
    x1: 32.818,
    y2: 31.61,
    transform: "translate(864.215 532.109)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1579",
    "data-name": "Line 1579",
    x2: 22.28,
    y2: 0.771,
    transform: "translate(874.754 609.771)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1580",
    "data-name": "Line 1580",
    y1: 46.473,
    x2: 27.352,
    transform: "translate(869.682 610.541)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1592",
    "data-name": "Line 1592",
    y1: 47.243,
    x2: 5.072,
    transform: "translate(869.681 609.771)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1593",
    "data-name": "Line 1593",
    x1: 18.51,
    y1: 0.71,
    transform: "translate(846.083 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1594",
    "data-name": "Line 1594",
    x1: 10.379,
    y1: 48.161,
    transform: "translate(854.214 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1595",
    "data-name": "Line 1595",
    y1: 47.451,
    x2: 8.131,
    transform: "translate(846.082 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1831",
    "data-name": "Line 1831",
    x1: 8.211,
    y1: 3.192,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 831.66, 561.496)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1596",
    "data-name": "Line 1596",
    y1: 2.209,
    x2: 45.429,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 841.105, 517.059)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1597",
    "data-name": "Line 1597",
    x2: 53.64,
    y2: 0.982,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 838.944, 516.6)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1832",
    "data-name": "Line 1832",
    y1: 6.862,
    x2: 9.413,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 833.617, 552.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1598",
    "data-name": "Line 1598",
    x2: 29.158,
    y2: 7.457,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 840.262, 523.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1599",
    "data-name": "Line 1599",
    x2: 38.571,
    y2: 0.596,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 840.262, 523.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1833",
    "data-name": "Line 1833",
    x1: 4.9,
    y1: 8.198,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 826.831, 568.863)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1600",
    "data-name": "Line 1600",
    x2: 58.54,
    y2: 9.18,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 838.945, 516.6)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1834",
    "data-name": "Line 1834",
    x1: 2.647,
    y1: 14.208,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.168, 581.955)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1835",
    "data-name": "Line 1835",
    x2: 10.539,
    y2: 1.467,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 817.794, 571.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1836",
    "data-name": "Line 1836",
    x2: 13.186,
    y2: 15.676,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 817.793, 571.952)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1837",
    "data-name": "Line 1837",
    x1: 4.803,
    y1: 4.761,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.719, 581.59)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1838",
    "data-name": "Line 1838",
    x2: 18.573,
    y2: 3.922,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.417, 564.238)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1839",
    "data-name": "Line 1839",
    x2: 23.376,
    y2: 8.682,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.417, 564.238)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1840",
    "data-name": "Line 1840",
    x1: 0.458,
    y1: 1.253,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.781, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1841",
    "data-name": "Line 1841",
    x2: 60.384,
    y2: 11.171,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.942, 593.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1842",
    "data-name": "Line 1842",
    x2: 59.926,
    y2: 9.919,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.943, 593.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1843",
    "data-name": "Line 1843",
    x1: 5.938,
    y1: 7.06,
    transform: "translate(837.72 832.098)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1844",
    "data-name": "Line 1844",
    x1: 5.677,
    y2: 10.72,
    transform: "translate(837.72 821.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1845",
    "data-name": "Line 1845",
    x2: 0.261,
    y2: 17.779,
    transform: "translate(843.397 821.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1846",
    "data-name": "Line 1846",
    x1: 3.992,
    y2: 0.882,
    transform: "translate(873.842 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1847",
    "data-name": "Line 1847",
    x2: 2.261,
    y2: 71.196,
    transform: "translate(875.573 830.476)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1848",
    "data-name": "Line 1848",
    x1: 1.731,
    y2: 72.079,
    transform: "translate(873.842 830.476)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1849",
    "data-name": "Line 1849",
    x1: 11.963,
    y2: 2.652,
    transform: "translate(843.381 812.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1850",
    "data-name": "Line 1850",
    x1: 10.354,
    y1: 88.337,
    transform: "translate(843.38 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1851",
    "data-name": "Line 1851",
    x1: 1.609,
    y2: 90.988,
    transform: "translate(853.735 812.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1852",
    "data-name": "Line 1852",
    x2: 8.715,
    y2: 0.059,
    transform: "translate(849.73 990.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1853",
    "data-name": "Line 1853",
    x1: 4.996,
    y2: 20.611,
    transform: "translate(844.734 990.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1854",
    "data-name": "Line 1854",
    x1: 13.711,
    y2: 20.553,
    transform: "translate(844.734 990.963)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2178",
    "data-name": "Line 2178",
    y1: 8.551,
    x2: 4.349,
    transform: "translate(838.515 1016.877)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2179",
    "data-name": "Line 2179",
    x1: 7.484,
    y2: 8.866,
    transform: "translate(835.38 1016.877)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2180",
    "data-name": "Line 2180",
    x1: 3.135,
    y2: 0.315,
    transform: "translate(835.38 1025.429)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1508",
    "data-name": "Line 1508",
    y2: 6.508,
    transform: "translate(897.033 364.526)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1509",
    "data-name": "Line 1509",
    y1: 0.472,
    x2: 14.485,
    transform: "translate(882.549 371.034)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1510",
    "data-name": "Line 1510",
    y1: 6.98,
    x2: 14.485,
    transform: "translate(882.549 364.526)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1511",
    "data-name": "Line 1511",
    y2: 42.739,
    transform: "translate(897.033 489.369)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1512",
    "data-name": "Line 1512",
    y1: 37.368,
    x2: 38.739,
    transform: "translate(858.294 489.369)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1513",
    "data-name": "Line 1513",
    y2: 34.046,
    transform: "translate(897.033 532.109)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1514",
    "data-name": "Line 1514",
    x2: 32.818,
    y2: 2.436,
    transform: "translate(864.215 563.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1515",
    "data-name": "Line 1515",
    y2: 44.097,
    transform: "translate(897.033 525.574)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1516",
    "data-name": "Line 1516",
    x2: 20.431,
    y2: 2.342,
    transform: "translate(876.603 567.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1517",
    "data-name": "Line 1517",
    x1: 20.431,
    y2: 41.755,
    transform: "translate(876.603 525.574)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1581",
    "data-name": "Line 1581",
    y2: 46.938,
    transform: "translate(897.033 608.746)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1582",
    "data-name": "Line 1582",
    y1: 46.631,
    x2: 32.44,
    transform: "translate(864.593 608.746)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1601",
    "data-name": "Line 1601",
    x2: 32.44,
    y2: 0.307,
    transform: "translate(864.593 655.376)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1583",
    "data-name": "Line 1583",
    y2: 47.095,
    transform: "translate(897.033 610.541)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1602",
    "data-name": "Line 1602",
    x2: 27.352,
    y2: 0.622,
    transform: "translate(869.682 657.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1603",
    "data-name": "Line 1603",
    y1: 2.805,
    x2: 6.858,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 841.688, 517.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1855",
    "data-name": "Line 1855",
    x2: 21.46,
    y2: 1.056,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 832.401, 530.09)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1604",
    "data-name": "Line 1604",
    x1: 7.698,
    y1: 6.401,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 840.263, 523.891)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1856",
    "data-name": "Line 1856",
    y1: 4.46,
    x2: 63.834,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 831.065, 509.512)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1857",
    "data-name": "Line 1857",
    y1: 11.754,
    x2: 5.387,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.914, 566.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1858",
    "data-name": "Line 1858",
    y1: 0.354,
    x2: 68.688,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.514, 582.029)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1859",
    "data-name": "Line 1859",
    x2: 67.372,
    y2: 13.39,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.339, 586.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1860",
    "data-name": "Line 1860",
    y1: 13.745,
    x2: 1.315,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.612, 584.813)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1861",
    "data-name": "Line 1861",
    x1: 0.353,
    y2: 13.258,
    transform: "translate(837.72 818.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1862",
    "data-name": "Line 1862",
    y1: 16.657,
    x2: 5.66,
    transform: "translate(837.72 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1863",
    "data-name": "Line 1863",
    y1: 3.4,
    x2: 5.307,
    transform: "translate(838.073 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1864",
    "data-name": "Line 1864",
    x1: 5.324,
    y1: 2.538,
    transform: "translate(838.073 818.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1865",
    "data-name": "Line 1865",
    x2: 2.282,
    y2: 17.397,
    transform: "translate(866.534 991.018)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1866",
    "data-name": "Line 1866",
    y1: 0.244,
    x2: 3.03,
    transform: "translate(866.534 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1867",
    "data-name": "Line 1867",
    x1: 0.748,
    y2: 17.64,
    transform: "translate(868.816 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2181",
    "data-name": "Line 2181",
    x1: 1.315,
    transform: "translate(869.064 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2182",
    "data-name": "Line 2182",
    x1: 0.189,
    y1: 10.682,
    transform: "translate(868.875 1025.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2183",
    "data-name": "Line 2183",
    x1: 1.504,
    y1: 10.682,
    transform: "translate(868.875 1025.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1518",
    "data-name": "Line 1518",
    x2: 9.913,
    y2: 3.605,
    transform: "translate(887.12 449.211)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1605",
    "data-name": "Line 1605",
    x2: 1.072,
    y2: 5.85,
    transform: "translate(886.049 443.361)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1606",
    "data-name": "Line 1606",
    y1: 24.198,
    x2: 3.954,
    transform: "translate(869.858 394.395)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1607",
    "data-name": "Line 1607",
    x1: 2.504,
    y1: 24.794,
    transform: "translate(867.354 393.799)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1608",
    "data-name": "Line 1608",
    x2: 2.593,
    y2: 3.307,
    transform: "translate(870.056 376.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1609",
    "data-name": "Line 1609",
    y1: 5.089,
    x2: 12.493,
    transform: "translate(870.055 371.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1610",
    "data-name": "Line 1610",
    y1: 8.395,
    x2: 9.9,
    transform: "translate(872.648 371.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1611",
    "data-name": "Line 1611",
    x1: 3.467,
    y2: 14.89,
    transform: "translate(878.699 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1519",
    "data-name": "Line 1519",
    x2: 18.334,
    y2: 0.965,
    transform: "translate(878.699 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2184",
    "data-name": "Line 2184",
    x1: 21.817,
    transform: "translate(847.247 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2185",
    "data-name": "Line 2185",
    x1: 21.628,
    y2: 10.682,
    transform: "translate(847.246 1025.601)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1520",
    "data-name": "Line 1520",
    y1: 10.876,
    x2: 9.854,
    transform: "translate(887.179 410.242)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1521",
    "data-name": "Line 1521",
    y2: 13.206,
    transform: "translate(897.033 410.242)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1522",
    "data-name": "Line 1522",
    x2: 9.854,
    y2: 2.33,
    transform: "translate(887.179 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1523",
    "data-name": "Line 1523",
    x2: 12.837,
    y2: 3.522,
    transform: "translate(884.196 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1524",
    "data-name": "Line 1524",
    x1: 12.837,
    y1: 4.83,
    transform: "translate(884.196 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1525",
    "data-name": "Line 1525",
    y1: 1.308,
    transform: "translate(897.033 451.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1526",
    "data-name": "Line 1526",
    x1: 15.455,
    y2: 2.964,
    transform: "translate(881.578 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1527",
    "data-name": "Line 1527",
    y1: 3.056,
    x2: 15.422,
    transform: "translate(881.611 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1612",
    "data-name": "Line 1612",
    x1: 0.034,
    y1: 0.092,
    transform: "translate(881.578 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1528",
    "data-name": "Line 1528",
    x1: 15.455,
    y1: 2.201,
    transform: "translate(881.578 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1529",
    "data-name": "Line 1529",
    y2: 5.164,
    transform: "translate(897.033 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1613",
    "data-name": "Line 1613",
    x1: 5.219,
    y1: 3.45,
    transform: "translate(878.977 444.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1614",
    "data-name": "Line 1614",
    x1: 5.526,
    y2: 11.361,
    transform: "translate(878.67 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1615",
    "data-name": "Line 1615",
    x1: 0.307,
    y2: 14.811,
    transform: "translate(878.67 444.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1616",
    "data-name": "Line 1616",
    x1: 7.211,
    y1: 2.579,
    transform: "translate(878.67 459.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1617",
    "data-name": "Line 1617",
    x1: 22.649,
    y2: 5.978,
    transform: "translate(863.231 461.926)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1618",
    "data-name": "Line 1618",
    x1: 15.439,
    y2: 8.557,
    transform: "translate(863.231 459.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1530",
    "data-name": "Line 1530",
    x1: 16.153,
    y2: 21.337,
    transform: "translate(880.88 393.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1531",
    "data-name": "Line 1531",
    x1: 18.641,
    y1: 0.872,
    transform: "translate(878.393 392.872)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1619",
    "data-name": "Line 1619",
    x2: 2.488,
    y2: 22.209,
    transform: "translate(878.393 392.872)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1532",
    "data-name": "Line 1532",
    x1: 17.426,
    y1: 4.79,
    transform: "translate(879.607 374.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1533",
    "data-name": "Line 1533",
    y2: 9.976,
    transform: "translate(897.033 369.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1534",
    "data-name": "Line 1534",
    x1: 17.426,
    y2: 5.185,
    transform: "translate(879.607 369.164)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1620",
    "data-name": "Line 1620",
    y1: 7.198,
    x2: 10.27,
    transform: "translate(871.308 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1621",
    "data-name": "Line 1621",
    y1: 8.607,
    x2: 11.619,
    transform: "translate(869.959 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1622",
    "data-name": "Line 1622",
    y1: 1.409,
    x2: 1.349,
    transform: "translate(869.959 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1535",
    "data-name": "Line 1535",
    x1: 11.152,
    y2: 10.418,
    transform: "translate(885.881 451.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1623",
    "data-name": "Line 1623",
    x2: 1.685,
    y2: 13.94,
    transform: "translate(884.196 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1536",
    "data-name": "Line 1536",
    x1: 16.153,
    y2: 0.37,
    transform: "translate(880.88 414.711)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1537",
    "data-name": "Line 1537",
    x2: 16.153,
    y2: 9.96,
    transform: "translate(880.88 415.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1538",
    "data-name": "Line 1538",
    y2: 10.33,
    transform: "translate(897.033 414.711)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1539",
    "data-name": "Line 1539",
    x2: 11.152,
    y2: 1.367,
    transform: "translate(885.881 461.926)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1540",
    "data-name": "Line 1540",
    x1: 15.598,
    y2: 8.879,
    transform: "translate(881.435 463.293)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1624",
    "data-name": "Line 1624",
    x1: 4.446,
    y2: 10.246,
    transform: "translate(881.435 461.926)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1541",
    "data-name": "Line 1541",
    x2: 15.598,
    y2: 4.228,
    transform: "translate(881.435 472.173)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1542",
    "data-name": "Line 1542",
    x1: 20.212,
    y2: 15.252,
    transform: "translate(876.821 476.401)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1625",
    "data-name": "Line 1625",
    x1: 4.614,
    y2: 19.48,
    transform: "translate(876.821 472.173)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1626",
    "data-name": "Line 1626",
    x1: 6.971,
    y2: 23.976,
    transform: "translate(855.272 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1543",
    "data-name": "Line 1543",
    x1: 41.761,
    y2: 20.054,
    transform: "translate(855.273 468.942)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1544",
    "data-name": "Line 1544",
    x2: 34.789,
    y2: 3.922,
    transform: "translate(862.244 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1627",
    "data-name": "Line 1627",
    x1: 23.935,
    y1: 5.088,
    transform: "translate(852.886 486.564)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1628",
    "data-name": "Line 1628",
    x1: 24.713,
    y2: 28.68,
    transform: "translate(852.108 491.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1629",
    "data-name": "Line 1629",
    x1: 0.777,
    y2: 33.768,
    transform: "translate(852.108 486.564)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1545",
    "data-name": "Line 1545",
    x2: 20.212,
    y2: 5.448,
    transform: "translate(876.821 491.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1546",
    "data-name": "Line 1546",
    x1: 21.527,
    y2: 26.757,
    transform: "translate(875.506 497.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1630",
    "data-name": "Line 1630",
    x1: 1.315,
    y2: 32.205,
    transform: "translate(875.506 491.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1631",
    "data-name": "Line 1631",
    x1: 10.001,
    y2: 43.497,
    transform: "translate(854.213 563.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1632",
    "data-name": "Line 1632",
    x2: 16.052,
    y2: 1.023,
    transform: "translate(854.214 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1633",
    "data-name": "Line 1633",
    x2: 6.051,
    y2: 44.52,
    transform: "translate(864.215 563.719)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1547",
    "data-name": "Line 1547",
    x1: 26.767,
    y2: 42.084,
    transform: "translate(870.266 566.155)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1584",
    "data-name": "Line 1584",
    x2: 26.767,
    y2: 0.507,
    transform: "translate(870.266 608.239)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1548",
    "data-name": "Line 1548",
    y2: 42.59,
    transform: "translate(897.033 566.155)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1549",
    "data-name": "Line 1549",
    x1: 22.28,
    y2: 40.099,
    transform: "translate(874.754 569.671)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1634",
    "data-name": "Line 1634",
    x1: 1.849,
    y2: 42.442,
    transform: "translate(874.754 567.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1635",
    "data-name": "Line 1635",
    x1: 9.148,
    y1: 47.444,
    transform: "translate(835.019 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1636",
    "data-name": "Line 1636",
    x1: 2.614,
    y1: 0.867,
    transform: "translate(844.166 560.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1637",
    "data-name": "Line 1637",
    x1: 11.762,
    y1: 48.311,
    transform: "translate(835.018 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1638",
    "data-name": "Line 1638",
    x2: 1.588,
    y2: 46.125,
    transform: "translate(846.78 560.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1639",
    "data-name": "Line 1639",
    x1: 5.845,
    y1: 0.151,
    transform: "translate(848.368 607.064)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1640",
    "data-name": "Line 1640",
    x2: 7.434,
    y2: 46.277,
    transform: "translate(846.78 560.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1868",
    "data-name": "Line 1868",
    y1: 5.851,
    x2: 45.005,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.33, 479.263)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1869",
    "data-name": "Line 1869",
    x1: 9.442,
    y2: 1.167,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 810.936, 514.049)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1870",
    "data-name": "Line 1870",
    y1: 2.357,
    x2: 33.213,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 811.277, 523.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1871",
    "data-name": "Line 1871",
    y1: 3.523,
    x2: 42.656,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 813.241, 514.539)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1872",
    "data-name": "Line 1872",
    x1: 2.668,
    y1: 8.653,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.178, 546.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1873",
    "data-name": "Line 1873",
    x2: 45.101,
    y2: 10.845,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.177, 546.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1874",
    "data-name": "Line 1874",
    x2: 42.433,
    y2: 2.192,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 809.159, 547.704)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1641",
    "data-name": "Line 1641",
    x1: 2.29,
    y2: 74.66,
    transform: "translate(861.534 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1642",
    "data-name": "Line 1642",
    y1: 63.125,
    x2: 29.259,
    transform: "translate(861.534 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1643",
    "data-name": "Line 1643",
    x2: 26.969,
    y2: 11.535,
    transform: "translate(863.824 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1644",
    "data-name": "Line 1644",
    x1: 6.24,
    y2: 9.594,
    transform: "translate(890.793 704.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1645",
    "data-name": "Line 1645",
    x1: 33.209,
    y1: 1.941,
    transform: "translate(863.824 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1875",
    "data-name": "Line 1875",
    y1: 2.088,
    x2: 4.849,
    transform: "translate(872.005 820.193)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1646",
    "data-name": "Line 1646",
    x1: 13.354,
    y2: 53.14,
    transform: "translate(872.005 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1647",
    "data-name": "Line 1647",
    x1: 8.505,
    y2: 51.051,
    transform: "translate(876.854 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2186",
    "data-name": "Line 2186",
    x1: 10.283,
    y2: 25.805,
    transform: "translate(848.759 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2187",
    "data-name": "Line 2187",
    x2: 10.451,
    y2: 0.029,
    transform: "translate(848.759 1036.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2188",
    "data-name": "Line 2188",
    x2: 0.168,
    y2: 25.835,
    transform: "translate(859.042 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1550",
    "data-name": "Line 1550",
    x1: 12.14,
    y2: 10.686,
    transform: "translate(884.893 384.99)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1648",
    "data-name": "Line 1648",
    x1: 2.101,
    y1: 11.86,
    transform: "translate(882.792 383.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1551",
    "data-name": "Line 1551",
    x1: 14.241,
    y1: 1.174,
    transform: "translate(882.792 383.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1649",
    "data-name": "Line 1649",
    x2: 6.076,
    y2: 8.4,
    transform: "translate(878.12 439.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1650",
    "data-name": "Line 1650",
    x2: 10.993,
    y2: 12.244,
    transform: "translate(873.203 435.742)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1651",
    "data-name": "Line 1651",
    x2: 4.916,
    y2: 3.843,
    transform: "translate(873.203 435.742)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1552",
    "data-name": "Line 1552",
    y2: 15.399,
    transform: "translate(897.033 429.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1553",
    "data-name": "Line 1553",
    x2: 9.854,
    y2: 23.875,
    transform: "translate(887.179 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1554",
    "data-name": "Line 1554",
    x2: 9.854,
    y2: 8.476,
    transform: "translate(887.179 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1555",
    "data-name": "Line 1555",
    x2: 9.854,
    y2: 6.835,
    transform: "translate(887.179 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1556",
    "data-name": "Line 1556",
    y2: 1.641,
    transform: "translate(897.033 427.953)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2189",
    "data-name": "Line 2189",
    x1: 8.203,
    y2: 0.475,
    transform: "translate(850.768 1005.006)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2190",
    "data-name": "Line 2190",
    x2: 0.046,
    y2: 8.455,
    transform: "translate(858.97 1005.006)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2191",
    "data-name": "Line 2191",
    x2: 8.249,
    y2: 7.98,
    transform: "translate(850.768 1005.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1652",
    "data-name": "Line 1652",
    x1: 8.018,
    y2: 24.018,
    transform: "translate(876.875 395.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1653",
    "data-name": "Line 1653",
    x1: 2.286,
    y1: 25.443,
    transform: "translate(884.893 395.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1654",
    "data-name": "Line 1654",
    x1: 10.304,
    y1: 1.424,
    transform: "translate(876.875 419.694)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1557",
    "data-name": "Line 1557",
    x1: 12.14,
    y1: 1.652,
    transform: "translate(884.893 395.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1558",
    "data-name": "Line 1558",
    x1: 9.854,
    y2: 23.79,
    transform: "translate(887.179 397.328)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1559",
    "data-name": "Line 1559",
    y2: 12.914,
    transform: "translate(897.033 397.328)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1560",
    "data-name": "Line 1560",
    y1: 4.505,
    transform: "translate(897.033 423.448)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1655",
    "data-name": "Line 1655",
    y1: 17.23,
    x2: 1.135,
    transform: "translate(864.673 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1656",
    "data-name": "Line 1656",
    x1: 1.815,
    y1: 24.254,
    transform: "translate(865.807 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1657",
    "data-name": "Line 1657",
    x1: 2.95,
    y1: 7.024,
    transform: "translate(864.673 410.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1561",
    "data-name": "Line 1561",
    y1: 0.526,
    transform: "translate(897.033 364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1562",
    "data-name": "Line 1562",
    y1: 2.53,
    x2: 15.422,
    transform: "translate(881.611 364.526)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1658",
    "data-name": "Line 1658",
    x1: 1.971,
    y2: 7.386,
    transform: "translate(879.607 366.964)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1659",
    "data-name": "Line 1659",
    x1: 18.204,
    y1: 4.269,
    transform: "translate(863.231 467.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1563",
    "data-name": "Line 1563",
    y2: 20.967,
    transform: "translate(897.033 393.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1564",
    "data-name": "Line 1564",
    y1: 13.732,
    x2: 18.641,
    transform: "translate(878.393 379.14)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1565",
    "data-name": "Line 1565",
    y1: 14.604,
    transform: "translate(897.033 379.14)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1660",
    "data-name": "Line 1660",
    x1: 11.652,
    y2: 8.515,
    transform: "translate(869.959 367.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1661",
    "data-name": "Line 1661",
    x2: 8.299,
    y2: 0.188,
    transform: "translate(871.308 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1566",
    "data-name": "Line 1566",
    y2: 11.785,
    transform: "translate(897.033 451.508)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1567",
    "data-name": "Line 1567",
    y2: 13.108,
    transform: "translate(897.033 463.293)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1568",
    "data-name": "Line 1568",
    y2: 9.776,
    transform: "translate(897.033 459.167)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1569",
    "data-name": "Line 1569",
    x1: 34.789,
    y2: 5.854,
    transform: "translate(862.244 459.167)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1662",
    "data-name": "Line 1662",
    x1: 28.549,
    y2: 14.392,
    transform: "translate(852.886 472.173)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1570",
    "data-name": "Line 1570",
    y2: 20.7,
    transform: "translate(897.033 476.401)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1571",
    "data-name": "Line 1571",
    x2: 41.761,
    y2: 0.374,
    transform: "translate(855.273 488.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1572",
    "data-name": "Line 1572",
    y2: 20.427,
    transform: "translate(897.033 468.942)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1663",
    "data-name": "Line 1663",
    x1: 23.397,
    y1: 3.525,
    transform: "translate(852.108 520.333)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1573",
    "data-name": "Line 1573",
    y2: 28.473,
    transform: "translate(897.033 497.101)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1574",
    "data-name": "Line 1574",
    x2: 21.527,
    y2: 1.717,
    transform: "translate(875.506 523.857)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1664",
    "data-name": "Line 1664",
    x1: 17.435,
    y1: 2.78,
    transform: "translate(846.78 560.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1575",
    "data-name": "Line 1575",
    y2: 40.87,
    transform: "translate(897.033 569.671)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1665",
    "data-name": "Line 1665",
    x2: 4.202,
    y2: 46.992,
    transform: "translate(844.167 560.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1876",
    "data-name": "Line 1876",
    y1: 4.682,
    x2: 46.412,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.623, 477.887)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1877",
    "data-name": "Line 1877",
    x1: 1.408,
    y1: 1.169,
    transform: "translate(821.525 467.762)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1878",
    "data-name": "Line 1878",
    y1: 6.413,
    x2: 58.418,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.465, 590.087)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1879",
    "data-name": "Line 1879",
    y1: 9.817,
    x2: 58.951,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.795, 590.795)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1880",
    "data-name": "Line 1880",
    y1: 3.405,
    x2: 0.534,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.649, 647.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1666",
    "data-name": "Line 1666",
    y1: 6.325,
    x2: 16.472,
    transform: "translate(861.534 770.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1667",
    "data-name": "Line 1667",
    x1: 12.787,
    y2: 56.8,
    transform: "translate(878.006 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1881",
    "data-name": "Line 1881",
    x2: 2.244,
    y2: 19.641,
    transform: "translate(868.774 991.198)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1882",
    "data-name": "Line 1882",
    x1: 9.732,
    y2: 19.304,
    transform: "translate(859.042 991.198)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2192",
    "data-name": "Line 2192",
    x2: 11.976,
    y2: 0.336,
    transform: "translate(859.042 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1576",
    "data-name": "Line 1576",
    y1: 12.782,
    x2: 14.241,
    transform: "translate(882.792 371.034)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1577",
    "data-name": "Line 1577",
    y1: 13.956,
    transform: "translate(897.033 371.034)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1578",
    "data-name": "Line 1578",
    y2: 12.338,
    transform: "translate(897.033 384.99)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1668",
    "data-name": "Line 1668",
    x2: 5.774,
    y2: 8.794,
    transform: "translate(873.203 435.742)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1669",
    "data-name": "Line 1669",
    x2: 10.144,
    y2: 3.915,
    transform: "translate(872.648 379.901)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1670",
    "data-name": "Line 1670",
    y1: 10.579,
    x2: 8.98,
    transform: "translate(873.812 383.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1671",
    "data-name": "Line 1671",
    x2: 0.244,
    y2: 12.31,
    transform: "translate(882.548 371.506)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1672",
    "data-name": "Line 1672",
    x1: 1.546,
    y1: 0.369,
    transform: "translate(865.807 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1673",
    "data-name": "Line 1673",
    x2: 0.269,
    y2: 23.886,
    transform: "translate(867.354 393.799)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1674",
    "data-name": "Line 1674",
    y1: 2.785,
    x2: 3.463,
    transform: "translate(862.345 393.431)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1675",
    "data-name": "Line 1675",
    x2: 2.328,
    y2: 14.445,
    transform: "translate(862.345 396.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1676",
    "data-name": "Line 1676",
    x1: 2.925,
    y1: 1.225,
    transform: "translate(884.196 447.986)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1677",
    "data-name": "Line 1677",
    y1: 9.539,
    x2: 11.556,
    transform: "translate(870.056 367.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1678",
    "data-name": "Line 1678",
    x1: 0.937,
    y1: 4.45,
    transform: "translate(881.611 367.056)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1679",
    "data-name": "Line 1679",
    y1: 3.268,
    x2: 2.635,
    transform: "translate(862.345 392.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1680",
    "data-name": "Line 1680",
    x1: 6.349,
    y1: 20.759,
    transform: "translate(862.344 396.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1681",
    "data-name": "Line 1681",
    x1: 3.715,
    y1: 24.027,
    transform: "translate(864.979 392.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1682",
    "data-name": "Line 1682",
    x2: 3.505,
    y2: 12.979,
    transform: "translate(875.472 431.557)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1683",
    "data-name": "Line 1683",
    x1: 2.269,
    y2: 4.185,
    transform: "translate(873.203 431.557)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1684",
    "data-name": "Line 1684",
    y1: 24.335,
    x2: 0.798,
    transform: "translate(868.694 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1685",
    "data-name": "Line 1685",
    y1: 0.308,
    x2: 4.513,
    transform: "translate(864.979 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1686",
    "data-name": "Line 1686",
    y1: 0.717,
    x2: 8.598,
    transform: "translate(872.283 415.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1687",
    "data-name": "Line 1687",
    x1: 9.669,
    y1: 12.283,
    transform: "translate(872.283 415.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1688",
    "data-name": "Line 1688",
    x1: 1.072,
    y1: 13,
    transform: "translate(880.88 415.081)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1689",
    "data-name": "Line 1689",
    y1: 18.478,
    x2: 1.815,
    transform: "translate(869.492 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1690",
    "data-name": "Line 1690",
    y1: 18.29,
    x2: 10.114,
    transform: "translate(869.492 374.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1691",
    "data-name": "Line 1691",
    x1: 0.029,
    y2: 1.145,
    transform: "translate(878.67 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1692",
    "data-name": "Line 1692",
    y1: 13.665,
    x2: 0.277,
    transform: "translate(878.699 444.536)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1693",
    "data-name": "Line 1693",
    y1: 18.522,
    x2: 1.214,
    transform: "translate(878.393 374.35)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1694",
    "data-name": "Line 1694",
    x1: 15.468,
    y2: 9.703,
    transform: "translate(863.231 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1695",
    "data-name": "Line 1695",
    x2: 17.687,
    y2: 0.111,
    transform: "translate(835.199 486.454)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1696",
    "data-name": "Line 1696",
    y1: 15.993,
    x2: 8.623,
    transform: "translate(835.199 470.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1697",
    "data-name": "Line 1697",
    x1: 9.064,
    y1: 16.104,
    transform: "translate(843.822 470.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1698",
    "data-name": "Line 1698",
    x1: 16.46,
    y1: 7.731,
    transform: "translate(835.649 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1883",
    "data-name": "Line 1883",
    x2: 0.45,
    y2: 26.148,
    transform: "translate(835.199 486.454)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1699",
    "data-name": "Line 1699",
    x2: 16.909,
    y2: 33.879,
    transform: "translate(835.199 486.454)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1700",
    "data-name": "Line 1700",
    x1: 3.021,
    y1: 37.742,
    transform: "translate(855.273 488.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1701",
    "data-name": "Line 1701",
    x1: 33.121,
    y1: 25.299,
    transform: "translate(825.173 501.439)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1884",
    "data-name": "Line 1884",
    x2: 9.846,
    y2: 11.189,
    transform: "translate(825.173 501.439)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1702",
    "data-name": "Line 1702",
    x1: 23.275,
    y1: 14.109,
    transform: "translate(835.019 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1703",
    "data-name": "Line 1703",
    y1: 38.961,
    x2: 20.031,
    transform: "translate(855.474 523.857)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1704",
    "data-name": "Line 1704",
    x1: 3.366,
    y1: 42.486,
    transform: "translate(852.108 520.333)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1705",
    "data-name": "Line 1705",
    x2: 1.097,
    y2: 43.471,
    transform: "translate(875.506 523.857)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1706",
    "data-name": "Line 1706",
    x1: 19.826,
    y1: 50.216,
    transform: "translate(835.648 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1707",
    "data-name": "Line 1707",
    x1: 29.196,
    y1: 51.09,
    transform: "translate(835.018 512.628)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1708",
    "data-name": "Line 1708",
    x2: 21.128,
    y2: 4.51,
    transform: "translate(855.474 562.819)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1709",
    "data-name": "Line 1709",
    y1: 40.56,
    x2: 19.855,
    transform: "translate(856.748 567.329)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1710",
    "data-name": "Line 1710",
    x2: 1.273,
    y2: 45.07,
    transform: "translate(855.474 562.819)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1711",
    "data-name": "Line 1711",
    x1: 8.379,
    y1: 0.824,
    transform: "translate(848.369 607.064)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1712",
    "data-name": "Line 1712",
    x1: 7.106,
    y2: 44.246,
    transform: "translate(848.368 562.819)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1885",
    "data-name": "Line 1885",
    x1: 0.63,
    y2: 0.026,
    transform: "translate(835.019 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1713",
    "data-name": "Line 1713",
    x1: 8.518,
    y1: 47.47,
    transform: "translate(835.649 512.602)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1714",
    "data-name": "Line 1714",
    x1: 9.967,
    y1: 1.583,
    transform: "translate(839.91 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1715",
    "data-name": "Line 1715",
    x1: 16.838,
    y2: 46.628,
    transform: "translate(839.91 607.889)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1716",
    "data-name": "Line 1716",
    x1: 6.87,
    y2: 48.212,
    transform: "translate(849.877 607.889)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1717",
    "data-name": "Line 1717",
    y1: 47.138,
    x2: 5.673,
    transform: "translate(864.593 608.239)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1718",
    "data-name": "Line 1718",
    x1: 8.459,
    y2: 47.453,
    transform: "translate(839.91 607.064)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1719",
    "data-name": "Line 1719",
    x1: 14.304,
    y2: 47.301,
    transform: "translate(839.909 607.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1720",
    "data-name": "Line 1720",
    x2: 18.006,
    y2: 1.882,
    transform: "translate(856.747 607.889)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1721",
    "data-name": "Line 1721",
    x1: 24.876,
    y2: 46.33,
    transform: "translate(849.877 609.771)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1886",
    "data-name": "Line 1886",
    x1: 2.067,
    y2: 9.362,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.335, 548.839)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1887",
    "data-name": "Line 1887",
    x2: 19.393,
    y2: 10.419,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 832.4, 530.09)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1888",
    "data-name": "Line 1888",
    x2: 9.366,
    y2: 2.902,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 809.159, 547.704)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1889",
    "data-name": "Line 1889",
    x1: 39.912,
    y1: 6.948,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 809.159, 547.704)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1890",
    "data-name": "Line 1890",
    x1: 30.545,
    y1: 4.046,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.372, 556.262)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1891",
    "data-name": "Line 1891",
    x1: 0.445,
    y1: 13.034,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.329, 594.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1892",
    "data-name": "Line 1892",
    x2: 44.471,
    y2: 10.399,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 826.906, 550.862)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1893",
    "data-name": "Line 1893",
    y1: 2.635,
    x2: 44.025,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.483, 551.41)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1894",
    "data-name": "Line 1894",
    x2: 3.009,
    y2: 9.189,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.943, 593.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1895",
    "data-name": "Line 1895",
    x2: 34.613,
    y2: 4.227,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 831.66, 561.495)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1896",
    "data-name": "Line 1896",
    y1: 4.962,
    x2: 31.604,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 836.513, 562.527)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1897",
    "data-name": "Line 1897",
    y1: 2.406,
    x2: 0.366,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.672, 647.729)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1898",
    "data-name": "Line 1898",
    y1: 8.814,
    x2: 66.108,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 808.341, 583.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1899",
    "data-name": "Line 1899",
    y1: 6.409,
    x2: 65.742,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 805.988, 582.923)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1900",
    "data-name": "Line 1900",
    x2: 0.416,
    y2: 7.081,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.247, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1901",
    "data-name": "Line 1901",
    x2: 66.956,
    y2: 6.309,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 827.338, 586.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1902",
    "data-name": "Line 1902",
    x1: 1.437,
    y2: 9.809,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.786, 590.793)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1903",
    "data-name": "Line 1903",
    y1: 0.009,
    x2: 57.514,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.496, 592.201)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1904",
    "data-name": "Line 1904",
    x1: 0.067,
    y1: 5.748,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.233, 649.215)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1905",
    "data-name": "Line 1905",
    x2: 68.755,
    y2: 5.394,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.167, 581.955)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1906",
    "data-name": "Line 1906",
    x2: 0.391,
    y2: 0.464,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.781, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1907",
    "data-name": "Line 1907",
    x2: 60.317,
    y2: 10.383,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.943, 593.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1908",
    "data-name": "Line 1908",
    y1: 4.756,
    x2: 2.521,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.716, 586.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1909",
    "data-name": "Line 1909",
    y1: 11.169,
    x2: 60.939,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.989, 587.621)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1910",
    "data-name": "Line 1910",
    x2: 0.08,
    y2: 5.431,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.46, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1911",
    "data-name": "Line 1911",
    x2: 57.455,
    y2: 7.414,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.329, 594.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1912",
    "data-name": "Line 1912",
    x2: 57.376,
    y2: 1.983,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.329, 594.473)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1722",
    "data-name": "Line 1722",
    x1: 6.173,
    y1: 0.15,
    transform: "translate(839.91 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1723",
    "data-name": "Line 1723",
    x1: 7.03,
    y2: 44.324,
    transform: "translate(832.879 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1724",
    "data-name": "Line 1724",
    x1: 13.203,
    y2: 44.175,
    transform: "translate(832.879 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1725",
    "data-name": "Line 1725",
    x1: 7.812,
    y1: 1.023,
    transform: "translate(832.879 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1913",
    "data-name": "Line 1913",
    x1: 0.819,
    y2: 88.383,
    transform: "translate(832.06 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1726",
    "data-name": "Line 1726",
    x1: 8.631,
    y2: 87.36,
    transform: "translate(832.06 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1727",
    "data-name": "Line 1727",
    x2: 23.133,
    y2: 2.483,
    transform: "translate(840.691 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1728",
    "data-name": "Line 1728",
    x2: 1.979,
    y2: 83.917,
    transform: "translate(840.691 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1729",
    "data-name": "Line 1729",
    y1: 81.433,
    x2: 21.153,
    transform: "translate(842.67 702.347)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1730",
    "data-name": "Line 1730",
    x1: 10.61,
    y2: 3.443,
    transform: "translate(832.06 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1731",
    "data-name": "Line 1731",
    x1: 6.013,
    y1: 31.617,
    transform: "translate(832.06 787.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1732",
    "data-name": "Line 1732",
    x1: 4.597,
    y2: 35.06,
    transform: "translate(838.073 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1914",
    "data-name": "Line 1914",
    x1: 14.892,
    y1: 0.017,
    transform: "translate(857.113 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1733",
    "data-name": "Line 1733",
    x1: 20.8,
    y2: 51.298,
    transform: "translate(857.113 770.967)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1734",
    "data-name": "Line 1734",
    x1: 5.908,
    y2: 51.314,
    transform: "translate(872.005 770.967)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1915",
    "data-name": "Line 1915",
    x1: 6.022,
    y1: 14.434,
    transform: "translate(869.551 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1916",
    "data-name": "Line 1916",
    y1: 10.283,
    x2: 1.282,
    transform: "translate(875.573 820.193)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1917",
    "data-name": "Line 1917",
    x1: 7.303,
    y1: 4.152,
    transform: "translate(869.551 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1918",
    "data-name": "Line 1918",
    x2: 13.716,
    y2: 0.887,
    transform: "translate(843.397 821.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1919",
    "data-name": "Line 1919",
    y1: 16.892,
    x2: 13.455,
    transform: "translate(843.658 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1920",
    "data-name": "Line 1920",
    x1: 5.643,
    y2: 7.463,
    transform: "translate(869.929 830.476)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1921",
    "data-name": "Line 1921",
    x1: 2.076,
    y2: 15.657,
    transform: "translate(869.929 822.282)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1922",
    "data-name": "Line 1922",
    x1: 3.568,
    y1: 8.194,
    transform: "translate(872.005 822.282)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1923",
    "data-name": "Line 1923",
    y1: 1.223,
    x2: 20.107,
    transform: "translate(853.735 902.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1924",
    "data-name": "Line 1924",
    x1: 4.29,
    y1: 86.513,
    transform: "translate(869.552 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1925",
    "data-name": "Line 1925",
    y1: 87.736,
    x2: 15.817,
    transform: "translate(853.735 816.042)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1926",
    "data-name": "Line 1926",
    y1: 5.391,
    x2: 12.59,
    transform: "translate(843.658 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1927",
    "data-name": "Line 1927",
    y1: 68.755,
    x2: 14.842,
    transform: "translate(841.406 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1928",
    "data-name": "Line 1928",
    x1: 2.252,
    y2: 63.364,
    transform: "translate(841.405 839.157)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1929",
    "data-name": "Line 1929",
    x2: 7.139,
    y2: 0.172,
    transform: "translate(870.694 901.5)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1930",
    "data-name": "Line 1930",
    x1: 0.765,
    y1: 63.561,
    transform: "translate(869.93 837.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1931",
    "data-name": "Line 1931",
    x1: 7.904,
    y1: 63.733,
    transform: "translate(869.929 837.939)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1932",
    "data-name": "Line 1932",
    x1: 0.761,
    y2: 71.352,
    transform: "translate(836.96 832.098)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1933",
    "data-name": "Line 1933",
    x1: 6.421,
    y2: 88.009,
    transform: "translate(836.959 815.441)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1934",
    "data-name": "Line 1934",
    x1: 14.968,
    y1: 0.261,
    transform: "translate(855.727 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1935",
    "data-name": "Line 1935",
    x1: 0.521,
    y2: 67.473,
    transform: "translate(855.727 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1936",
    "data-name": "Line 1936",
    x1: 14.447,
    y1: 67.734,
    transform: "translate(856.248 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1937",
    "data-name": "Line 1937",
    x1: 6.866,
    y2: 0.55,
    transform: "translate(834.54 902.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1938",
    "data-name": "Line 1938",
    x1: 9.119,
    y2: 63.914,
    transform: "translate(834.539 839.157)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1939",
    "data-name": "Line 1939",
    x2: 7.018,
    y2: 0.635,
    transform: "translate(859.517 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1940",
    "data-name": "Line 1940",
    x1: 3.79,
    y1: 89.144,
    transform: "translate(855.726 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1941",
    "data-name": "Line 1941",
    x1: 10.808,
    y1: 89.778,
    transform: "translate(855.726 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1942",
    "data-name": "Line 1942",
    x1: 2.42,
    y1: 0.378,
    transform: "translate(834.54 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1943",
    "data-name": "Line 1943",
    x1: 15.191,
    y1: 87.832,
    transform: "translate(834.539 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1944",
    "data-name": "Line 1944",
    x1: 12.77,
    y1: 87.454,
    transform: "translate(836.96 903.45)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1945",
    "data-name": "Line 1945",
    y1: 1.282,
    x2: 14.321,
    transform: "translate(841.406 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1946",
    "data-name": "Line 1946",
    x1: 3.921,
    y2: 89.539,
    transform: "translate(851.806 901.24)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1947",
    "data-name": "Line 1947",
    x2: 10.4,
    y2: 88.257,
    transform: "translate(841.406 902.521)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1948",
    "data-name": "Line 1948",
    x1: 0.874,
    y1: 0.227,
    transform: "translate(848.856 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1949",
    "data-name": "Line 1949",
    x1: 4.013,
    y2: 18.842,
    transform: "translate(844.843 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1950",
    "data-name": "Line 1950",
    x1: 4.887,
    y2: 18.615,
    transform: "translate(844.843 990.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2193",
    "data-name": "Line 2193",
    y1: 15.909,
    x2: 6.328,
    transform: "translate(838.514 1009.52)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2194",
    "data-name": "Line 2194",
    y1: 7.358,
    x2: 1.979,
    transform: "translate(842.864 1009.52)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2195",
    "data-name": "Line 2195",
    y1: 1.013,
    x2: 14.308,
    transform: "translate(844.733 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2196",
    "data-name": "Line 2196",
    x2: 4.026,
    y2: 24.792,
    transform: "translate(844.734 1011.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2197",
    "data-name": "Line 2197",
    x1: 5.925,
    y2: 4.038,
    transform: "translate(844.843 1005.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1951",
    "data-name": "Line 1951",
    x2: 1.912,
    y2: 14.804,
    transform: "translate(848.856 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1952",
    "data-name": "Line 1952",
    x1: 7.711,
    y2: 0.395,
    transform: "translate(851.806 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1953",
    "data-name": "Line 1953",
    x1: 8.749,
    y2: 15.098,
    transform: "translate(850.768 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1954",
    "data-name": "Line 1954",
    x1: 1.038,
    y2: 14.703,
    transform: "translate(850.768 990.778)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2198",
    "data-name": "Line 2198",
    x1: 0.353,
    y2: 8.522,
    transform: "translate(868.463 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2199",
    "data-name": "Line 2199",
    x2: 3.152,
    y2: 16.447,
    transform: "translate(868.816 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2200",
    "data-name": "Line 2200",
    x2: 3.505,
    y2: 7.925,
    transform: "translate(868.463 1016.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2201",
    "data-name": "Line 2201",
    x2: 2.202,
    y2: 2.425,
    transform: "translate(868.816 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1955",
    "data-name": "Line 1955",
    x2: 1.454,
    y2: 20.065,
    transform: "translate(869.564 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2202",
    "data-name": "Line 2202",
    x2: 9.446,
    y2: 3.475,
    transform: "translate(859.017 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2203",
    "data-name": "Line 2203",
    x1: 9.799,
    y2: 5.047,
    transform: "translate(859.017 1008.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2204",
    "data-name": "Line 2204",
    x1: 9.846,
    y1: 3.408,
    transform: "translate(858.97 1005.006)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1956",
    "data-name": "Line 1956",
    x1: 7.564,
    y2: 13.989,
    transform: "translate(858.97 991.018)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2205",
    "data-name": "Line 2205",
    x2: 0.95,
    y2: 14.022,
    transform: "translate(871.018 1010.839)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2206",
    "data-name": "Line 2206",
    x1: 0.282,
    y1: 25.469,
    transform: "translate(871.018 1010.839)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2207",
    "data-name": "Line 2207",
    y1: 11.447,
    x2: 0.668,
    transform: "translate(871.299 1024.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2208",
    "data-name": "Line 2208",
    x1: 9.392,
    y1: 0.025,
    transform: "translate(839.368 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2209",
    "data-name": "Line 2209",
    x2: 10.245,
    y2: 10.879,
    transform: "translate(838.515 1025.429)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2210",
    "data-name": "Line 2210",
    x2: 0.853,
    y2: 10.854,
    transform: "translate(838.515 1025.429)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2211",
    "data-name": "Line 2211",
    x2: 3.988,
    y2: 10.539,
    transform: "translate(835.38 1025.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2212",
    "data-name": "Line 2212",
    y1: 3.416,
    x2: 16.153,
    transform: "translate(842.864 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2213",
    "data-name": "Line 2213",
    y1: 11.396,
    x2: 7.904,
    transform: "translate(842.864 1005.481)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2214",
    "data-name": "Line 2214",
    x1: 22.54,
    transform: "translate(848.759 1036.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2215",
    "data-name": "Line 2215",
    x1: 31.932,
    y1: 0.025,
    transform: "translate(839.367 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2216",
    "data-name": "Line 2216",
    x1: 0.214,
    y1: 11.32,
    transform: "translate(847.032 1024.962)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2217",
    "data-name": "Line 2217",
    x1: 21.843,
    y1: 0.639,
    transform: "translate(847.032 1024.962)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2218",
    "data-name": "Line 2218",
    x1: 0.13,
    y2: 10.539,
    transform: "translate(835.25 1025.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2219",
    "data-name": "Line 2219",
    x2: 11.867,
    y2: 10.539,
    transform: "translate(835.38 1025.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2220",
    "data-name": "Line 2220",
    x1: 11.997,
    transform: "translate(835.25 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1735",
    "data-name": "Line 1735",
    x1: 9.001,
    y1: 9.625,
    transform: "translate(878.12 439.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1736",
    "data-name": "Line 1736",
    x2: 11.081,
    y2: 1.281,
    transform: "translate(873.812 394.395)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1737",
    "data-name": "Line 1737",
    x1: 7.929,
    y1: 3.775,
    transform: "translate(878.119 439.585)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1738",
    "data-name": "Line 1738",
    x2: 1.244,
    y2: 19.892,
    transform: "translate(876.876 419.694)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1739",
    "data-name": "Line 1739",
    x1: 9.173,
    y1: 23.667,
    transform: "translate(876.875 419.694)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1740",
    "data-name": "Line 1740",
    x2: 7.018,
    y2: 1.101,
    transform: "translate(869.858 418.593)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1741",
    "data-name": "Line 1741",
    x2: 8.261,
    y2: 20.992,
    transform: "translate(869.858 418.593)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1742",
    "data-name": "Line 1742",
    x1: 2.236,
    y1: 0.908,
    transform: "translate(867.622 417.685)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1743",
    "data-name": "Line 1743",
    x1: 4.021,
    y1: 6.314,
    transform: "translate(864.672 410.661)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1744",
    "data-name": "Line 1744",
    x2: 3.345,
    y2: 17.149,
    transform: "translate(869.858 418.593)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1745",
    "data-name": "Line 1745",
    x2: 5.58,
    y2: 18.057,
    transform: "translate(867.623 417.685)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1746",
    "data-name": "Line 1746",
    x1: 0.828,
    y1: 0.483,
    transform: "translate(864.979 392.948)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1747",
    "data-name": "Line 1747",
    y1: 1.177,
    x2: 3.589,
    transform: "translate(868.694 415.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1748",
    "data-name": "Line 1748",
    x2: 2.79,
    y2: 23.158,
    transform: "translate(869.492 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1749",
    "data-name": "Line 1749",
    x1: 16.455,
    y2: 6.818,
    transform: "translate(862.244 458.202)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1750",
    "data-name": "Line 1750",
    x2: 0.987,
    y2: 2.884,
    transform: "translate(862.244 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1751",
    "data-name": "Line 1751",
    x1: 30.1,
    y2: 12.443,
    transform: "translate(825.173 488.996)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1752",
    "data-name": "Line 1752",
    x1: 11.308,
    y1: 2.746,
    transform: "translate(844.166 560.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1753",
    "data-name": "Line 1753",
    x1: 19.805,
    y1: 0.914,
    transform: "translate(849.877 656.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1957",
    "data-name": "Line 1957",
    y1: 1.737,
    x2: 15.649,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 821.432, 531.586)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1958",
    "data-name": "Line 1958",
    x1: 3.744,
    y1: 12.155,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 832.401, 530.09)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1959",
    "data-name": "Line 1959",
    x2: 18.317,
    y2: 6.917,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 819.732, 531.225)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1960",
    "data-name": "Line 1960",
    x1: 46.538,
    y1: 1.037,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 818.178, 546.893)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1961",
    "data-name": "Line 1961",
    x1: 7.169,
    y2: 4.637,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 808.907, 557.226)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1962",
    "data-name": "Line 1962",
    y1: 5.62,
    x2: 57.01,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 812.985, 593.367)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1963",
    "data-name": "Line 1963",
    x1: 0.504,
    y1: 5.611,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.133, 649.131)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1964",
    "data-name": "Line 1964",
    y1: 4.074,
    x2: 6.639,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 831.323, 586.947)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1754",
    "data-name": "Line 1754",
    x1: 5.391,
    y2: 45.197,
    transform: "translate(840.691 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1755",
    "data-name": "Line 1755",
    x1: 0.273,
    y2: 0.08,
    transform: "translate(863.824 702.267)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1756",
    "data-name": "Line 1756",
    x1: 23.406,
    y1: 2.403,
    transform: "translate(840.691 699.864)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1757",
    "data-name": "Line 1757",
    y1: 6.774,
    x2: 18.863,
    transform: "translate(842.67 777.007)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1758",
    "data-name": "Line 1758",
    x2: 32.936,
    y2: 2.021,
    transform: "translate(864.097 702.267)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1759",
    "data-name": "Line 1759",
    x1: 8.963,
    y2: 52.137,
    transform: "translate(860.719 657.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1760",
    "data-name": "Line 1760",
    x2: 16.342,
    y2: 56.338,
    transform: "translate(869.681 657.014)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1761",
    "data-name": "Line 1761",
    x1: 25.305,
    y1: 4.201,
    transform: "translate(860.718 709.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1762",
    "data-name": "Line 1762",
    x2: 0.71,
    y2: 31.66,
    transform: "translate(842.67 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1763",
    "data-name": "Line 1763",
    x1: 1.387,
    y2: 45.114,
    transform: "translate(857.113 777.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1764",
    "data-name": "Line 1764",
    x1: 19.414,
    y2: 6.184,
    transform: "translate(858.5 770.967)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1765",
    "data-name": "Line 1765",
    y1: 1.825,
    x2: 7.446,
    transform: "translate(877.913 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1965",
    "data-name": "Line 1965",
    x1: 0.866,
    y2: 11.501,
    transform: "translate(856.247 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1966",
    "data-name": "Line 1966",
    x2: 14.207,
    y2: 3.252,
    transform: "translate(855.344 812.789)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1967",
    "data-name": "Line 1967",
    x1: 16.775,
    y1: 0.328,
    transform: "translate(836.959 903.45)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1968",
    "data-name": "Line 1968",
    x1: 3.181,
    y2: 70.974,
    transform: "translate(834.539 832.098)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1969",
    "data-name": "Line 1969",
    x1: 13.682,
    y1: 4.173,
    transform: "translate(856.247 833.766)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1970",
    "data-name": "Line 1970",
    x1: 4.16,
    y2: 89.518,
    transform: "translate(866.534 901.5)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1971",
    "data-name": "Line 1971",
    x1: 14.317,
    y1: 87.606,
    transform: "translate(834.539 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2221",
    "data-name": "Line 2221",
    x1: 12.258,
    y1: 25.805,
    transform: "translate(859.042 1010.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2222",
    "data-name": "Line 2222",
    y1: 1.996,
    x2: 0.109,
    transform: "translate(844.733 1009.52)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1972",
    "data-name": "Line 1972",
    x2: 0.597,
    y2: 19.54,
    transform: "translate(858.445 990.963)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2223",
    "data-name": "Line 2223",
    x1: 12.089,
    y2: 0.029,
    transform: "translate(859.21 1036.308)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1973",
    "data-name": "Line 1973",
    x2: 2.95,
    y2: 0.101,
    transform: "translate(848.856 990.677)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1974",
    "data-name": "Line 1974",
    x1: 0.546,
    y2: 14.623,
    transform: "translate(858.97 990.383)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1975",
    "data-name": "Line 1975",
    x2: 10.329,
    y2: 0.235,
    transform: "translate(858.445 990.963)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2224",
    "data-name": "Line 2224",
    y1: 11.421,
    x2: 1.588,
    transform: "translate(870.379 1024.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2225",
    "data-name": "Line 2225",
    x2: 0.92,
    y2: 0.025,
    transform: "translate(870.379 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2226",
    "data-name": "Line 2226",
    x1: 6.219,
    y2: 13.913,
    transform: "translate(838.515 1011.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2227",
    "data-name": "Line 2227",
    x2: 4.168,
    y2: 8.085,
    transform: "translate(842.864 1016.877)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2228",
    "data-name": "Line 2228",
    y1: 0.782,
    x2: 11.652,
    transform: "translate(835.38 1024.962)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2229",
    "data-name": "Line 2229",
    x1: 9.858,
    y1: 12.14,
    transform: "translate(859.016 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2230",
    "data-name": "Line 2230",
    x1: 11.984,
    y2: 11.501,
    transform: "translate(847.032 1013.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2231",
    "data-name": "Line 2231",
    y1: 0.74,
    x2: 3.093,
    transform: "translate(868.875 1024.861)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2232",
    "data-name": "Line 2232",
    x1: 0.412,
    y1: 8.665,
    transform: "translate(868.463 1016.936)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2233",
    "data-name": "Line 2233",
    x1: 4.118,
    transform: "translate(835.25 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2234",
    "data-name": "Line 2234",
    x1: 33.814,
    transform: "translate(835.25 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2235",
    "data-name": "Line 2235",
    x1: 31.012,
    transform: "translate(839.368 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1766",
    "data-name": "Line 1766",
    x2: 3.063,
    y2: 25.299,
    transform: "translate(873.812 394.395)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1767",
    "data-name": "Line 1767",
    x1: 0.097,
    y1: 1.024,
    transform: "translate(869.959 375.571)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1976",
    "data-name": "Line 1976",
    x1: 0.79,
    y2: 0.424,
    transform: "translate(868.774 990.774)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1768",
    "data-name": "Line 1768",
    y1: 22.243,
    x2: 1.13,
    transform: "translate(886.049 421.118)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1769",
    "data-name": "Line 1769",
    x1: 3.189,
    y2: 1.224,
    transform: "translate(878.977 443.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1770",
    "data-name": "Line 1770",
    x1: 3.189,
    y1: 15.76,
    transform: "translate(872.283 415.798)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1771",
    "data-name": "Line 1771",
    x1: 1.072,
    y2: 0.711,
    transform: "translate(867.622 416.974)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1772",
    "data-name": "Line 1772",
    x2: 4.509,
    y2: 18.768,
    transform: "translate(868.694 416.974)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1773",
    "data-name": "Line 1773",
    x1: 6.778,
    y1: 14.583,
    transform: "translate(868.694 416.974)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2236",
    "data-name": "Line 2236",
    x1: 35.13,
    transform: "translate(835.25 1036.283)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1774",
    "data-name": "Line 1774",
    x1: 31.352,
    y1: 4.32,
    transform: "translate(823.92 484.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1775",
    "data-name": "Line 1775",
    x1: 38.323,
    y2: 19.656,
    transform: "translate(823.92 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1776",
    "data-name": "Line 1776",
    x1: 20.901,
    y2: 4.235,
    transform: "translate(841.342 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1777",
    "data-name": "Line 1777",
    x1: 17.422,
    y2: 15.421,
    transform: "translate(823.92 469.255)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1977",
    "data-name": "Line 1977",
    x1: 3.336,
    y1: 2.955,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1978",
    "data-name": "Line 1978",
    x1: 8.144,
    y1: 9.474,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1979",
    "data-name": "Line 1979",
    x2: 4.807,
    y2: 6.519,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.301)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1980",
    "data-name": "Line 1980",
    x1: 1.752,
    y1: 2.366,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.301)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1981",
    "data-name": "Line 1981",
    x2: 7.013,
    y2: 8.836,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1982",
    "data-name": "Line 1982",
    x2: 5.261,
    y2: 6.47,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.628, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1983",
    "data-name": "Line 1983",
    x2: 6.614,
    y2: 8.046,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.628, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1984",
    "data-name": "Line 1984",
    x1: 6.538,
    y1: 6.649,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.247, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1985",
    "data-name": "Line 1985",
    x2: 0.076,
    y2: 1.396,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.629, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1986",
    "data-name": "Line 1986",
    x1: 30.848,
    y1: 7.912,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.782, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1987",
    "data-name": "Line 1987",
    x1: 29.095,
    y1: 5.546,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.781, 649.995)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1988",
    "data-name": "Line 1988",
    x1: 13.854,
    y1: 7.143,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.115, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1989",
    "data-name": "Line 1989",
    x1: 16.611,
    y1: 0.913,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.462, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1990",
    "data-name": "Line 1990",
    x1: 30.465,
    y1: 8.056,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.46, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1991",
    "data-name": "Line 1991",
    x1: 19.657,
    y1: 5.455,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.132, 649.131)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1992",
    "data-name": "Line 1992",
    x1: 16.531,
    y2: 4.519,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 805.551, 650.071)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1993",
    "data-name": "Line 1993",
    x1: 3.126,
    y1: 9.973,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.114, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1994",
    "data-name": "Line 1994",
    x2: 4.643,
    y2: 5.098,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1995",
    "data-name": "Line 1995",
    x1: 25.368,
    y1: 2.127,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.246, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1996",
    "data-name": "Line 1996",
    x1: 30.011,
    y1: 7.226,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.246, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1997",
    "data-name": "Line 1997",
    x1: 29.595,
    y1: 0.144,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.233, 649.216)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1998",
    "data-name": "Line 1998",
    x1: 28.705,
    y1: 5.082,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 807.246, 650.281)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1999",
    "data-name": "Line 1999",
    x1: 30.39,
    y1: 6.66,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 806.461, 650.183)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2000",
    "data-name": "Line 2000",
    x1: 11.413,
    y2: 1.394,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.073, 667.515)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2001",
    "data-name": "Line 2001",
    x1: 14.539,
    y1: 8.579,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.114, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2002",
    "data-name": "Line 2002",
    y1: 1.15,
    x2: 19.834,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.848, 680.491)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2003",
    "data-name": "Line 2003",
    x2: 3.467,
    y2: 6.956,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.247, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2004",
    "data-name": "Line 2004",
    x2: 23.301,
    y2: 5.806,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.247, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2005",
    "data-name": "Line 2005",
    x2: 22.343,
    y2: 4.248,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.247, 678.307)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2006",
    "data-name": "Line 2006",
    y1: 2.402,
    x2: 15.804,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 786.732, 683.82)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2007",
    "data-name": "Line 2007",
    y1: 0.843,
    x2: 16.762,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.208, 683.496)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2008",
    "data-name": "Line 2008",
    x1: 3.072,
    y2: 0.306,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.023, 680.315)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2009",
    "data-name": "Line 2009",
    x2: 22.09,
    y2: 4.62,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.652)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2010",
    "data-name": "Line 2010",
    y1: 0.479,
    x2: 17.447,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.407, 678.234)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2011",
    "data-name": "Line 2011",
    y1: 2.167,
    x2: 15.018,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.051, 681.099)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2012",
    "data-name": "Line 2012",
    x2: 23.162,
    y2: 7.307,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 799.891, 674.653)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2013",
    "data-name": "Line 2013",
    y1: 2.628,
    x2: 17.498,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.776, 682.871)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2014",
    "data-name": "Line 2014",
    x2: 24.511,
    y2: 6.208,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2015",
    "data-name": "Line 2015",
    x2: 23.519,
    y2: 4.253,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.307, 677.302)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2016",
    "data-name": "Line 2016",
    y1: 2.266,
    x2: 18.712,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.147, 681.119)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2017",
    "data-name": "Line 2017",
    y1: 0.9,
    x2: 19.078,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.085, 682.511)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2018",
    "data-name": "Line 2018",
    x2: 1.353,
    y2: 1.575,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 786.206, 682.324)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2019",
    "data-name": "Line 2019",
    y1: 2.475,
    x2: 17.724,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 786.804, 683.835)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2020",
    "data-name": "Line 2020",
    x2: 23.364,
    y2: 4.223,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.629, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2021",
    "data-name": "Line 2021",
    y1: 2.248,
    x2: 18.103,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.404, 682.792)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2022",
    "data-name": "Line 2022",
    x2: 24.339,
    y2: 5.571,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.628, 678.524)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2023",
    "data-name": "Line 2023",
    x1: 35.6,
    y2: 1.317,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.607, 647.502)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2024",
    "data-name": "Line 2024",
    x1: 36.953,
    y1: 0.258,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.32, 647.228)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2025",
    "data-name": "Line 2025",
    x1: 33.029,
    y2: 1.228,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.799, 648.342)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2026",
    "data-name": "Line 2026",
    x1: 33.394,
    y2: 3.634,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.874, 647.984)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2027",
    "data-name": "Line 2027",
    x1: 2.206,
    y1: 2.317,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.931, 680.648)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2028",
    "data-name": "Line 2028",
    x1: 29.528,
    y2: 5.604,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.079, 649.251)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2029",
    "data-name": "Line 2029",
    x1: 3.5,
    y1: 4.376,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.939, 678.134)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2030",
    "data-name": "Line 2030",
    x1: 33.882,
    y1: 0.565,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.32, 647.229)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2031",
    "data-name": "Line 2031",
    x2: 14.195,
    y2: 4.126,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.709, 667.225)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2032",
    "data-name": "Line 2032",
    x1: 19.687,
    y2: 3.561,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.802, 647.969)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2033",
    "data-name": "Line 2033",
    x2: 2.782,
    y2: 5.519,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.7, 678.679)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2034",
    "data-name": "Line 2034",
    x1: 19.153,
    y2: 0.156,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.691, 648.491)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1778",
    "data-name": "Line 1778",
    x1: 8.455,
    y2: 45.36,
    transform: "translate(869.551 770.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1779",
    "data-name": "Line 1779",
    x2: 8.018,
    y2: 39.035,
    transform: "translate(861.534 777.007)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1780",
    "data-name": "Line 1780",
    y1: 35.783,
    x2: 6.19,
    transform: "translate(855.344 777.007)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1781",
    "data-name": "Line 1781",
    x2: 12.674,
    y2: 29.009,
    transform: "translate(842.671 783.781)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1782",
    "data-name": "Line 1782",
    x1: 11.337,
    y1: 34.155,
    transform: "translate(832.06 787.224)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1783",
    "data-name": "Line 1783",
    x1: 7.644,
    y2: 3.384,
    transform: "translate(832.06 783.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1784",
    "data-name": "Line 1784",
    x1: 3.694,
    y1: 37.538,
    transform: "translate(839.704 783.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1785",
    "data-name": "Line 1785",
    x1: 18.796,
    y2: 6.689,
    transform: "translate(839.704 777.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1786",
    "data-name": "Line 1786",
    x2: 17.409,
    y2: 38.425,
    transform: "translate(839.704 783.84)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2035",
    "data-name": "Line 2035",
    x2: 17.266,
    y2: 87.706,
    transform: "translate(834.539 903.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2036",
    "data-name": "Line 2036",
    x2: 4.711,
    y2: 87.185,
    transform: "translate(853.735 903.778)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2037",
    "data-name": "Line 2037",
    x1: 21.485,
    y1: 87.513,
    transform: "translate(836.96 903.45)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2038",
    "data-name": "Line 2038",
    x1: 5.068,
    y2: 88.643,
    transform: "translate(868.774 902.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2039",
    "data-name": "Line 2039",
    x1: 15.397,
    y2: 88.408,
    transform: "translate(858.445 902.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2040",
    "data-name": "Line 2040",
    x1: 9.06,
    y2: 89.526,
    transform: "translate(868.774 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2041",
    "data-name": "Line 2041",
    x1: 8.27,
    y2: 89.101,
    transform: "translate(869.564 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2042",
    "data-name": "Line 2042",
    x1: 11.299,
    y2: 89.345,
    transform: "translate(866.534 901.672)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1787",
    "data-name": "Line 1787",
    y1: 17.205,
    x2: 2.702,
    transform: "translate(867.354 376.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1788",
    "data-name": "Line 1788",
    x1: 4.248,
    y2: 16.836,
    transform: "translate(865.807 376.594)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1789",
    "data-name": "Line 1789",
    y1: 22.925,
    x2: 6.11,
    transform: "translate(872.283 392.872)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1790",
    "data-name": "Line 1790",
    x2: 8.9,
    y2: 0.233,
    transform: "translate(869.492 392.639)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1791",
    "data-name": "Line 1791",
    y1: 17.86,
    x2: 4.152,
    transform: "translate(865.807 375.571)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1792",
    "data-name": "Line 1792",
    y1: 17.377,
    x2: 4.979,
    transform: "translate(864.979 375.571)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1793",
    "data-name": "Line 1793",
    y1: 18.786,
    x2: 6.328,
    transform: "translate(864.979 374.162)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1794",
    "data-name": "Line 1794",
    x1: 4.253,
    y2: 79.105,
    transform: "translate(839.704 704.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1795",
    "data-name": "Line 1795",
    x2: 14.543,
    y2: 72.416,
    transform: "translate(843.956 704.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1796",
    "data-name": "Line 1796",
    x2: 16.762,
    y2: 4.415,
    transform: "translate(843.956 704.735)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1797",
    "data-name": "Line 1797",
    x1: 2.219,
    y2: 68.001,
    transform: "translate(858.5 709.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1798",
    "data-name": "Line 1798",
    x2: 6.824,
    y2: 84.999,
    transform: "translate(832.879 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1799",
    "data-name": "Line 1799",
    x1: 11.077,
    y1: 5.894,
    transform: "translate(832.879 698.841)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1800",
    "data-name": "Line 1800",
    y1: 48.635,
    x2: 5.921,
    transform: "translate(843.956 656.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1801",
    "data-name": "Line 1801",
    x1: 4.047,
    y1: 50.219,
    transform: "translate(839.909 654.517)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1802",
    "data-name": "Line 1802",
    x2: 10.841,
    y2: 53.05,
    transform: "translate(849.877 656.1)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1803",
    "data-name": "Line 1803",
    y1: 0.735,
    x2: 4.568,
    transform: "translate(892.466 713.37)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1804",
    "data-name": "Line 1804",
    x2: 6.442,
    y2: 0.753,
    transform: "translate(886.023 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1805",
    "data-name": "Line 1805",
    x2: 11.01,
    y2: 0.018,
    transform: "translate(886.024 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1806",
    "data-name": "Line 1806",
    y2: 55.734,
    transform: "translate(897.033 657.636)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1807",
    "data-name": "Line 1807",
    y1: 55.716,
    x2: 11.01,
    transform: "translate(886.024 657.636)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1808",
    "data-name": "Line 1808",
    x1: 0.496,
    y2: 46.891,
    transform: "translate(864.097 655.376)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1809",
    "data-name": "Line 1809",
    x2: 32.44,
    y2: 48.912,
    transform: "translate(864.593 655.376)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1810",
    "data-name": "Line 1810",
    y2: 48.605,
    transform: "translate(897.033 655.683)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2043",
    "data-name": "Line 2043",
    x2: 12.816,
    y2: 15.674,
    transform: "translate(857.113 822.265)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1811",
    "data-name": "Line 1811",
    x1: 37.613,
    y1: 1.712,
    transform: "translate(843.822 470.461)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1812",
    "data-name": "Line 1812",
    x1: 19.41,
    y2: 2.557,
    transform: "translate(843.822 467.904)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2044",
    "data-name": "Line 2044",
    x2: 1.252,
    y2: 16.763,
    transform: "translate(823.921 484.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2045",
    "data-name": "Line 2045",
    x2: 64.208,
    y2: 0.665,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 833.733, 468.558)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1813",
    "data-name": "Line 1813",
    y1: 11.49,
    x2: 60.464,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 844.972, 470.947)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1814",
    "data-name": "Line 1814",
    x1: 2.479,
    y1: 1.206,
    transform: "translate(841.343 469.255)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1815",
    "data-name": "Line 1815",
    x1: 18.422,
    y2: 5.441,
    transform: "translate(843.822 465.02)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1816",
    "data-name": "Line 1816",
    x1: 60.914,
    y1: 14.658,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 859.403, 473.555)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1817",
    "data-name": "Line 1817",
    x1: 7.106,
    y2: 55.038,
    transform: "translate(885.36 714.104)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1818",
    "data-name": "Line 1818",
    x1: 0.664,
    y2: 55.79,
    transform: "translate(885.359 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1819",
    "data-name": "Line 1819",
    x1: 8.11,
    y2: 57.616,
    transform: "translate(877.913 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1820",
    "data-name": "Line 1820",
    x1: 1.672,
    y1: 0.223,
    transform: "translate(890.793 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1821",
    "data-name": "Line 1821",
    y1: 55.26,
    x2: 5.433,
    transform: "translate(885.36 713.882)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1822",
    "data-name": "Line 1822",
    x1: 7.354,
    y2: 1.54,
    transform: "translate(878.006 769.142)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1823",
    "data-name": "Line 1823",
    x1: 1.151,
    y2: 49.511,
    transform: "translate(876.854 770.682)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2046",
    "data-name": "Line 2046",
    y1: 3.959,
    x2: 55.72,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 819.002, 509.736)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2047",
    "data-name": "Line 2047",
    x1: 49.824,
    y2: 8.16,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 817.776, 515.503)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2048",
    "data-name": "Line 2048",
    y1: 15.713,
    x2: 61.107,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 830.499, 512.18)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2049",
    "data-name": "Line 2049",
    x1: 5.53,
    y2: 12.176,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 820.882, 525.816)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2050",
    "data-name": "Line 2050",
    y1: 5.259,
    x2: 23.847,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 814.116, 524.378)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2051",
    "data-name": "Line 2051",
    y1: 4.079,
    x2: 16.754,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 830.822, 569.711)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2052",
    "data-name": "Line 2052",
    y1: 12.277,
    x2: 11.854,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 829.802, 574.504)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2053",
    "data-name": "Line 2053",
    y1: 8.153,
    x2: 23.393,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 834.807, 570.558)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1824",
    "data-name": "Line 1824",
    x1: 27.524,
    y2: 63.799,
    transform: "translate(858.5 713.352)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1825",
    "data-name": "Line 1825",
    x1: 18.014,
    y1: 47.601,
    transform: "translate(846.083 654.667)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1826",
    "data-name": "Line 1826",
    y1: 0.512,
    x2: 6.24,
    transform: "translate(890.793 713.37)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1827",
    "data-name": "Line 1827",
    y2: 9.082,
    transform: "translate(897.033 704.288)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2054",
    "data-name": "Line 2054",
    x1: 9.492,
    y2: 9.824,
    transform: "translate(812.757 467.762)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2055",
    "data-name": "Line 2055",
    x2: 13.859,
    y2: 6.23,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.115, 666.241)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2056",
    "data-name": "Line 2056",
    y1: 0.914,
    x2: 0.004,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.141, 678.497)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2057",
    "data-name": "Line 2057",
    x1: 3.463,
    y1: 7.869,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.14, 678.501)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2058",
    "data-name": "Line 2058",
    x1: 0.387,
    y1: 0.857,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.474, 729.122)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2059",
    "data-name": "Line 2059",
    x2: 5.459,
    y2: 3.66,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.271, 724.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2060",
    "data-name": "Line 2060",
    x2: 5.072,
    y2: 2.803,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.271, 724.744)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2061",
    "data-name": "Line 2061",
    x2: 0.382,
    y2: 0.847,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.628, 726.693)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2062",
    "data-name": "Line 2062",
    x2: 5.467,
    y2: 3.658,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.436, 722.303)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2063",
    "data-name": "Line 2063",
    x2: 5.085,
    y2: 2.811,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.436, 722.304)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2064",
    "data-name": "Line 2064",
    x2: 4.177,
    y2: 2.601,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.331, 717.487)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2065",
    "data-name": "Line 2065",
    x2: 1.319,
    y2: 1.672,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.919, 721.032)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2066",
    "data-name": "Line 2066",
    x2: 5.496,
    y2: 4.272,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.331, 717.487)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2067",
    "data-name": "Line 2067",
    x2: 0.429,
    y2: 0.949,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.179, 726.144)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2068",
    "data-name": "Line 2068",
    x2: 5.627,
    y2: 3.937,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.182, 721.681)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2069",
    "data-name": "Line 2069",
    x2: 5.198,
    y2: 2.988,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.182, 721.681)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2070",
    "data-name": "Line 2070",
    x2: 4.446,
    y2: 7.769,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.247, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2071",
    "data-name": "Line 2071",
    x1: 18.855,
    y2: 1.963,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.167, 678.715)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2072",
    "data-name": "Line 2072",
    x2: 3.488,
    y2: 6.211,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.247, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2073",
    "data-name": "Line 2073",
    x2: 0.958,
    y2: 1.558,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 783.447, 699.278)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2074",
    "data-name": "Line 2074",
    x1: 3.307,
    y1: 5.511,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.857, 693.21)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2075",
    "data-name": "Line 2075",
    y1: 0.891,
    x2: 18.783,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 800.762, 674.837)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2076",
    "data-name": "Line 2076",
    x1: 4.379,
    y1: 8.198,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.857, 693.211)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2077",
    "data-name": "Line 2077",
    x2: 4.387,
    y2: 8.031,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.906, 697.364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2078",
    "data-name": "Line 2078",
    x1: 20.124,
    y2: 1.823,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.09, 677.681)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2079",
    "data-name": "Line 2079",
    x2: 3.395,
    y2: 6.076,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.906, 697.364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2080",
    "data-name": "Line 2080",
    x1: 0.975,
    y1: 1.348,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 784.64, 700.499)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2081",
    "data-name": "Line 2081",
    x1: 3.387,
    y1: 5.941,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.156, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2082",
    "data-name": "Line 2082",
    y1: 1.718,
    x2: 19.977,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.309, 678.881)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2083",
    "data-name": "Line 2083",
    x1: 4.362,
    y1: 7.289,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.156, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2084",
    "data-name": "Line 2084",
    x1: 11.169,
    y2: 3.991,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.594, 713.818)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2085",
    "data-name": "Line 2085",
    x1: 16.628,
    y2: 0.331,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.014, 713.057)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2086",
    "data-name": "Line 2086",
    x1: 12.703,
    y2: 5.708,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.198, 716.896)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2087",
    "data-name": "Line 2087",
    x2: 3.925,
    y2: 5.377,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.689, 712.989)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2088",
    "data-name": "Line 2088",
    x1: 14.346,
    y2: 2.573,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.672, 698.956)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2089",
    "data-name": "Line 2089",
    x2: 18.271,
    y2: 2.804,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.155, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2090",
    "data-name": "Line 2090",
    y1: 4.485,
    x2: 13.909,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.507, 702.104)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2091",
    "data-name": "Line 2091",
    x1: 16.241,
    y2: 1.188,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.852, 713.235)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2092",
    "data-name": "Line 2092",
    x2: 3.248,
    y2: 4.234,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.689, 712.989)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2093",
    "data-name": "Line 2093",
    x1: 12.993,
    y2: 5.422,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.176, 716.413)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2094",
    "data-name": "Line 2094",
    x2: 17.594,
    y2: 1.662,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.156, 698.421)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2095",
    "data-name": "Line 2095",
    y1: 4.279,
    x2: 14.207,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.826, 701.389)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2096",
    "data-name": "Line 2096",
    x1: 13.38,
    y2: 4.565,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.338, 716.235)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2097",
    "data-name": "Line 2097",
    x1: 0.677,
    y1: 1.143,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.873, 715.285)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2098",
    "data-name": "Line 2098",
    x1: 12.816,
    y2: 4.207,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.386, 714.354)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2099",
    "data-name": "Line 2099",
    x1: 12.434,
    y2: 5.053,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.214, 714.53)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2100",
    "data-name": "Line 2100",
    x1: 12.089,
    y2: 5.642,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.235, 715.066)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2101",
    "data-name": "Line 2101",
    x2: 0.727,
    y2: 1.435,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.272, 713.479)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2102",
    "data-name": "Line 2102",
    x1: 15.703,
    y2: 0.748,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.894, 711.333)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2103",
    "data-name": "Line 2103",
    x2: 3.269,
    y2: 4.305,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.162, 711.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2104",
    "data-name": "Line 2104",
    x2: 16.934,
    y2: 2.161,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.906, 697.364)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2105",
    "data-name": "Line 2105",
    y1: 2.144,
    x2: 13.665,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.003, 697.81)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2106",
    "data-name": "Line 2106",
    x1: 10.619,
    y2: 3.559,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.643, 711.917)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2107",
    "data-name": "Line 2107",
    y1: 3.915,
    x2: 13.539,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.086, 700.236)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2108",
    "data-name": "Line 2108",
    x1: 16.086,
    y1: 0.098,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.162, 711.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2109",
    "data-name": "Line 2109",
    x2: 3.996,
    y2: 5.74,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.162, 711.177)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2110",
    "data-name": "Line 2110",
    x2: 17.661,
    y2: 3.597,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.906, 697.365)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2111",
    "data-name": "Line 2111",
    y1: 4.434,
    x2: 13.274,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.476, 700.909)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2112",
    "data-name": "Line 2112",
    x1: 10.404,
    y2: 3.151,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.495, 707.31)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2113",
    "data-name": "Line 2113",
    x1: 15.901,
    y1: 1.122,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.412, 706.655)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2114",
    "data-name": "Line 2114",
    x1: 11.892,
    y2: 4.907,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.482, 710.343)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2115",
    "data-name": "Line 2115",
    x1: 4.009,
    y1: 6.029,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.412, 706.655)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2116",
    "data-name": "Line 2116",
    x1: 17.46,
    y1: 4.647,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.857, 693.21)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2117",
    "data-name": "Line 2117",
    y1: 1.382,
    x2: 13.451,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.209, 693.498)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2118",
    "data-name": "Line 2118",
    y1: 3.551,
    x2: 13.081,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.402, 696.527)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2119",
    "data-name": "Line 2119",
    x1: 14.581,
    y2: 0.55,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.951, 706.769)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2120",
    "data-name": "Line 2120",
    x2: 3.059,
    y2: 4.133,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.413, 706.655)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2121",
    "data-name": "Line 2121",
    x1: 11.522,
    y2: 4.683,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 795.315, 709.762)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2122",
    "data-name": "Line 2122",
    x2: 16.51,
    y2: 2.751,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.857, 693.21)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2123",
    "data-name": "Line 2123",
    y1: 2.76,
    x2: 13.203,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.479, 695.873)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2124",
    "data-name": "Line 2124",
    x1: 12.842,
    y2: 3.012,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.68, 709.414)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2125",
    "data-name": "Line 2125",
    x1: 0.95,
    y1: 1.896,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.733, 708.788)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2126",
    "data-name": "Line 2126",
    x1: 12.569,
    y2: 4.42,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.774, 714.072)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2127",
    "data-name": "Line 2127",
    x1: 12.14,
    y2: 5.369,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.703, 714.269)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2128",
    "data-name": "Line 2128",
    x1: 11.875,
    y2: 5.723,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 788.629, 714.75)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2129",
    "data-name": "Line 2129",
    x2: 0.693,
    y2: 1.303,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 784.45, 713.153)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2130",
    "data-name": "Line 2130",
    x1: 15.527,
    y2: 0.92,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.407, 710.956)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2131",
    "data-name": "Line 2131",
    x2: 3.387,
    y2: 4.45,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.507, 710.765)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2132",
    "data-name": "Line 2132",
    x2: 16.85,
    y2: 2.344,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.246, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2133",
    "data-name": "Line 2133",
    y1: 2.106,
    x2: 13.464,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 792.306, 697.596)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2134",
    "data-name": "Line 2134",
    x1: 10.329,
    y2: 3.908,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.33, 711.577)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2135",
    "data-name": "Line 2135",
    y1: 3.867,
    x2: 13.363,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.229, 700.082)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2136",
    "data-name": "Line 2136",
    x1: 15.955,
    y1: 0.029,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.507, 710.765)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2137",
    "data-name": "Line 2137",
    x2: 4.08,
    y2: 5.752,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.507, 710.765)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2138",
    "data-name": "Line 2138",
    x2: 17.544,
    y2: 3.647,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.247, 697.158)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2139",
    "data-name": "Line 2139",
    y1: 4.122,
    x2: 13.098,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.755, 700.748)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2140",
    "data-name": "Line 2140",
    x1: 1.303,
    y1: 8,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.981, 703.711)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2141",
    "data-name": "Line 2141",
    x2: 0.143,
    y2: 4.904,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 798.981, 703.71)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2142",
    "data-name": "Line 2142",
    x1: 1.16,
    y1: 3.096,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.156, 702.83)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2143",
    "data-name": "Line 2143",
    x1: 1.387,
    y1: 8.824,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.059, 678.98)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2144",
    "data-name": "Line 2144",
    y1: 2.594,
    x2: 12.472,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.652, 666.78)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2145",
    "data-name": "Line 2145",
    x1: 2.067,
    y1: 11.173,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.059, 678.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2146",
    "data-name": "Line 2146",
    x1: 11.741,
    y1: 0.253,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2147",
    "data-name": "Line 2147",
    x1: 13.043,
    y1: 8.253,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2148",
    "data-name": "Line 2148",
    x1: 12.085,
    y2: 2.263,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.399, 691.5)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2149",
    "data-name": "Line 2149",
    x2: 0.958,
    y2: 10.516,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2150",
    "data-name": "Line 2150",
    x1: 13.09,
    y2: 2.385,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 804.392, 679.475)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2151",
    "data-name": "Line 2151",
    x2: 14.048,
    y2: 8.131,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.058, 678.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2152",
    "data-name": "Line 2152",
    y1: 3.042,
    x2: 11.98,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.676, 679.312)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2153",
    "data-name": "Line 2153",
    x2: 13.972,
    y2: 4.391,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 802.059, 678.979)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2154",
    "data-name": "Line 2154",
    x2: 0.882,
    y2: 6.775,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2155",
    "data-name": "Line 2155",
    y1: 4.433,
    x2: 12.585,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 797.476, 679.423)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2156",
    "data-name": "Line 2156",
    x1: 10.925,
    y2: 5.359,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.427, 692.143)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2157",
    "data-name": "Line 2157",
    x1: 11.001,
    y2: 1.619,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 796.442, 692.07)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2158",
    "data-name": "Line 2158",
    x2: 0.076,
    y2: 3.74,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 794.859, 691.733)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2159",
    "data-name": "Line 2159",
    x1: 0.681,
    y1: 2.35,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.14, 678.501)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2160",
    "data-name": "Line 2160",
    y1: 6.783,
    x2: 11.905,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 797.334, 680.089)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2161",
    "data-name": "Line 2161",
    x1: 11.884,
    y1: 5.157,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 801.67, 692.279)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2162",
    "data-name": "Line 2162",
    y1: 0.311,
    x2: 19.704,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.235, 680.713)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2163",
    "data-name": "Line 2163",
    x2: 0.992,
    y2: 1.955,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.256, 699.422)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2164",
    "data-name": "Line 2164",
    x2: 18.519,
    y2: 2.209,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 793.938, 678.135)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2165",
    "data-name": "Line 2165",
    x1: 1.072,
    y1: 2.687,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 790.779, 695.3)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2166",
    "data-name": "Line 2166",
    y1: 2.564,
    x2: 14.056,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 785.955, 699.811)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2167",
    "data-name": "Line 2167",
    y1: 3.137,
    x2: 14.884,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 787.708, 701.151)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2168",
    "data-name": "Line 2168",
    y1: 2.48,
    x2: 14.266,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 789.682, 699.938)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2169",
    "data-name": "Line 2169",
    x1: 14.153,
    y2: 0.864,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 791.625, 695.479)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2170",
    "data-name": "Line 2170",
    x2: 58.678,
    y2: 12.841,
    transform: "matrix(-0.208, 0.978, -0.978, -0.208, 833.732, 468.558)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2171",
    "data-name": "Line 2171",
    x1: 12.266,
    y1: 17.523,
    transform: "translate(822.933 468.931)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2172",
    "data-name": "Line 2172",
    y1: 0.086,
    x2: 9.93,
    transform: "translate(821.525 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2173",
    "data-name": "Line 2173",
    y1: 1.255,
    x2: 8.522,
    transform: "translate(822.933 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1828",
    "data-name": "Line 1828",
    x1: 10.472,
    y1: 1.596,
    transform: "translate(833.35 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1829",
    "data-name": "Line 1829",
    x1: 7.992,
    y1: 0.39,
    transform: "translate(833.35 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2174",
    "data-name": "Line 2174",
    y1: 0.066,
    x2: 10.417,
    transform: "translate(822.933 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2175",
    "data-name": "Line 2175",
    x1: 1.849,
    y1: 17.59,
    transform: "translate(833.35 468.865)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1830",
    "data-name": "Line 1830",
    x1: 9.888,
    y1: 1.579,
    transform: "translate(831.455 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2176",
    "data-name": "Line 2176",
    y1: 17,
    x2: 7.534,
    transform: "translate(823.921 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2177",
    "data-name": "Line 2177",
    x1: 1.895,
    y1: 1.188,
    transform: "translate(831.455 467.676)",
    fill: "none",
    stroke: "#b4cffd",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.01, -7)",
    filter: "url(#Line_2250)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2250-2",
    "data-name": "Line 2250",
    y1: 0.5,
    x2: 54,
    transform: "translate(9.01 8)",
    fill: "rgba(0,0,0,0)",
    stroke: "#9a9ba1",
    strokeWidth: 2,
    opacity: 0.43
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.01, -7)",
    filter: "url(#Line_2251)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2251-2",
    "data-name": "Line 2251",
    x1: 272,
    y1: 186,
    transform: "translate(62.01 7.5)",
    fill: "rgba(0,0,0,0)",
    stroke: "#9a9ba1",
    strokeWidth: 2,
    opacity: 0.43
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.01, -7)",
    filter: "url(#Ellipse_52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52-2",
    "data-name": "Ellipse 52",
    transform: "translate(322.51 182)",
    fill: "#fff",
    stroke: "#d3d3d6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.01, -7)",
    filter: "url(#Line_2252)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2252-2",
    "data-name": "Line 2252",
    x2: 54.001,
    y2: 0.5,
    transform: "translate(605.01 7)",
    fill: "rgba(0,0,0,0)",
    stroke: "#9a9ba1",
    strokeWidth: 2,
    opacity: 0.43
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.01, -7)",
    filter: "url(#Line_2253)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2253-2",
    "data-name": "Line 2253",
    y1: 65,
    x2: 170,
    transform: "translate(435.01 7.5)",
    fill: "rgba(0,0,0,0)",
    stroke: "#9a9ba1",
    strokeWidth: 2,
    opacity: 0.43
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.01, -7)",
    filter: "url(#Ellipse_53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53-2",
    "data-name": "Ellipse 53",
    transform: "translate(423.51 61)",
    fill: "#fff",
    stroke: "#d3d3d6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanBodyDigitalTwin);
export default __webpack_public_path__ + "static/media/human_body_digital_twin.82d97a9f0a0db6302354090c35716169.svg";
export { ForwardRef as ReactComponent };